<template>
  <v-row no-gutters>
    <v-row v-if="[routeName.VIP, routeName.PROMOTION].includes($route.name)" style="width:100%">
      <v-col cols="12" class="py-5">
        <v-divider></v-divider>
      </v-col>
    </v-row>

    <v-row v-if="$route.name == routeName.HOME">
      <v-col cols="12" class="pa-0" v-if="!this.$route.params.lang && this.checkDomain()">
        <v-col>
          <h1 class="h2">Krikya Bangladesh</h1>
          <br />
          <p>
            <router-link class="router_href" :to="{ name: ROUTE_NAME.HOME, params: { lang: $route.params.lang } }">Krikya</router-link>
            is your one-stop destination for online gaming in Bangladesh. Built with local players in mind, Krikya offers a fun and secure place to enjoy your favorite games. From sports betting and
            casino tables to slots and lotteries, everything is right here in one platform. New players can jump in easily, while experienced ones will find plenty to keep things exciting. With
            helpful support, fast payments, and fresh games added often, Krikya keeps the experience simple, safe, and enjoyable for everyone.
          </p>
          <div :class="{ 'hidden-content': !expanded, show: expanded }">
            <h2 class="h2">Games You Can Play on Krikya</h2>
            <br />
            <p>
              Krikya has something for every kind of player. You’ll find everything from familiar casino favorites to newer, fast-paced games that keep things interesting. Each game is built to keep
              you entertained and give you a fair shot at winning. It's all about fun, variety, and keeping the action going.
            </p>

            <h2 class="h2">Cricket Betting</h2>
            <br />
            <p>
              <router-link class="router_href" :to="{ name: ROUTE_NAME.CRICKET, params: { lang: $route.params.lang } }">Cricket</router-link>
              is a big part of life in Bangladesh, and Krikya makes it even more exciting. Bet on local and international matches, follow your favorite teams, and feel the rush as the game unfolds.
              The platform is easy to use, and the odds are made to give you real value with every bet.
            </p>
            <h2 class="h2">Sportsbook</h2>
            <br />
            <p>
              Krikya lets you bet on all kinds of sports, from football and tennis to basketball and beyond. Follow the action, pick your teams, and place your bets with just a few clicks. Whether
              it’s a local match or a global event, you’ll find plenty of options and solid odds on our
              <router-link class="router_href" :to="{ name: ROUTE_NAME.SPORTSBOOK, params: { lang: $route.params.lang } }">sportsbook</router-link>
              to keep things interesting.
            </p>
            <h2 class="h2">Live Casino</h2>
            <br />
            <p>
              <router-link class="router_href" :to="{ name: ROUTE_NAME.CASINO, params: { lang: $route.params.lang } }">Krikya’s live casino</router-link>
              brings the real casino feel straight to your screen. Play games like blackjack, roulette, and baccarat with live dealers and chat with other players while you play. It’s fast, fun, and
              gives you that real-time vibe without ever leaving home.
            </p>

            <h2 class="h2">Slots</h2>
            <br />
            <p>
              Krikya offers a large selection of
              <router-link class="router_href" :to="{ name: ROUTE_NAME.SLOT, params: { lang: $route.params.lang } }">slot games</router-link>
              with different looks, features, and ways to win. From the charm of classic slot machines to the exciting visuals of modern video slots, there’s plenty to explore. Each game is built to
              keep you engaged, with simple gameplay and the chance to land big rewards. No matter what kind of slot you enjoy, Krikya has something that fits your style.
            </p>

            <h2 class="h2">Table Games</h2>
            <br />
            <p>
              Krikya features a strong lineup of
              <router-link class="router_href" :to="{ name: ROUTE_NAME.TABLE_GAMES, params: { lang: $route.params.lang } }">table games</router-link>
              like poker, blackjack, roulette, and baccarat. Each game is built to feel real and keep you involved, whether you enjoy careful strategy or quick decision-making. With clear rules and
              clean visuals, these games give you the feel of a real casino with the comfort of playing from home.
            </p>

            <h2 class="h2">Crash Games</h2>
            <br />
            <p>
              <router-link class="router_href" :to="{ name: ROUTE_NAME.CRASH, params: { lang: $route.params.lang } }">Crash games</router-link>
              are quick and exciting, challenging you to cash out before the multiplier drops. It’s all about timing and smart moves—and it can lead to big wins. At Krikya, our crash games are built
              for pure excitement and the chance to score serious rewards.
            </p>

            <h2 class="h2">Fishing Games</h2>
            <br />
            <p>
              Our
              <router-link class="router_href" :to="{ name: ROUTE_NAME.FISHING, params: { lang: $route.params.lang } }">fishing games</router-link>
              are packed with fun and chances to win. Cast your line into the virtual waters and catch all kinds of fish to unlock prizes and bonuses. At Krikya, these games bring a mix of excitement
              and rewards, making them a top pick for many of our players.
            </p>

            <h2 class="h2">Lottery</h2>
            <br />
            <p>
              Take a shot at winning with our
              <router-link class="router_href" :to="{ name: ROUTE_NAME.LOTTERY, params: { lang: $route.params.lang } }">lottery games</router-link>
              . With different options to choose from, you get several chances to land a major prize. Simple to play and full of potential, our lottery games bring extra excitement to every moment you
              play at Krikya.
            </p>

            <h2 class="h2">Languages and Player Support</h2>
            <br />
            <p>
              At Krikya, we make sure every player feels at home by offering our platform in multiple languages. This helps you enjoy the full experience in the language you’re most comfortable with.
            </p>
            <h2 class="h2">English</h2>
            <br />
            <p>
              Our entire platform is available in English, giving English-speaking players easy access to all games, services, and customer support. Everything is designed for a smooth and clear
              experience.
            </p>
            <h2 class="h2">Bengali</h2>
            <br />
            <p>
              We also provide full support in Bengali, so local players can enjoy everything Krikya has to offer in their own language. It’s an easy and comfortable way for Bangladeshi users to
              connect with our games and services.
            </p>
            <h2 class="h2">Safety and Security</h2>
            <br />
            <p>
              At Krikya, keeping your information safe is a top priority. We use strong encryption tools to protect your personal and payment details at all times. Our games are also checked often to
              make sure they stay fair and reliable. You can enjoy your favorite games knowing the platform is secure and built with your safety in mind.
            </p>
            <h2 class="h2">Customer Supports</h2>
            <br />
            <p>
              Our customer support team is ready to help with any questions or problems you might have. We offer several ways to reach us, so you can get quick and helpful support whenever you need
              it.
            </p>
            <h2 class="h2">Phone</h2>
            <br />
            <p>
              You can contact our support team by phone for quick help. Our team is well-trained and ready to assist with any issues or questions you may have, giving you fast and reliable support.
            </p>
            <h2 class="h2">Email</h2>
            <br />
            <p>
              For non-urgent matters, you can reach out to us by email. We reply quickly and aim to give complete answers to your concerns, helping you with any questions or problems that come up.
            </p>
            <h2 class="h2">Live Chat</h2>
            <br />
            <p>
              Our live chat lets you talk to us in real time, so you can get help right when you need it. Our agents are friendly, helpful, and focused on making sure your time at Krikya is easy and
              enjoyable.
            </p>

            <h2 class="h2">Mobile Compatibility</h2>
            <br />
            <p>
              Krikya works perfectly on mobile devices. Whether you're using a smartphone or tablet, you can enjoy all our games and features without losing any quality or speed. The mobile version is
              easy to use and built to give you a smooth gaming experience wherever you are.
            </p>
            <h2 class="h2">Easy Sign Up Process</h2>
            <br />
            <p>Getting started on Krikya takes just a few moments. Follow the steps below to join:</p>
            <h2 class="h2">How to Sign Up on Krikya</h2>
            <br />
            <p>
              Click the
              <router-link class="router_href" :to="{ name: ROUTE_NAME.REGISTER, params: { lang: $route.params.lang } }">‘Sign Up’</router-link>
              button, fill in your details, and you’re all set to start playing. The process is easy and designed to get you into the action fast.
            </p>
            <h2 class="h2">Simple and Secure Login</h2>
            <br />
            <p>Accessing your Krikya account is easy and smooth, with no unnecessary steps or delays.</p>

            <h2 class="h2">How to Login into Krikya</h2>
            <br />
            <p>
              Click the ‘Login’ button, enter your username and password, and you’re ready to jump into your favorite games. Our login system is secure and built to get you into your account quickly
              and safely.
            </p>
            <h2 class="h2">Trust and Fair</h2>
            <br />
            <p>
              At Krikya, fairness and trust are at the core of everything we do. All our games are regularly checked to make sure they’re fair, and we follow strict guidelines to keep the platform
              safe. You can count on Krikya for an honest and open gaming experience.
            </p>

            <h2 class="h2">Bonuses and Promotions in Krikya</h2>
            <br />
            <p>
              At Krikya, players enjoy a mix of offers made to make every session more exciting. These rewards are created for both newcomers and regular users, giving everyone something extra to look
              forward to.
            </p>
            <h2 class="h2">Welcome Bonuses</h2>
            <br />
            <p>
              New to Krikya? Start off with a welcome bonus that gives your first deposit a solid boost. This extra balance gives you more room to try different games and enjoy your time without
              rushing. It’s the perfect way to kick off your journey and discover all the fun Krikya has to offer.
            </p>
            <h2 class="h2">Reload and Weekly Promotions</h2>
            <br />
            <p>
              Players who keep coming back can enjoy reload bonuses and weekly deals that drop in regularly. These offers are a way for us to say thank you and keep your balance topped up. They’re
              simple to claim and help stretch your playtime, making each visit feel even more rewarding.
            </p>
            <h2 class="h2">Special Bonuses</h2>
            <br />
            <p>
              From time to time, we roll out
              <router-link class="router_href" :to="{ name: ROUTE_NAME.PROMOTION, params: { lang: $route.params.lang } }">special promotions</router-link>
              that are only around for a short while. These could be tied to events, holidays, or just random surprises. Keep an eye on the promo section so you don’t miss out. These offers often come
              with great perks and bring something new to your regular play.
            </p>
            <h2 class="h2">Payment Options</h2>
            <br />
            <p>
              At Krikya, we support several payment methods to make your deposits and withdrawals smooth and secure. Each option is chosen to give you a fast and dependable way to manage your money
              while you play.
            </p>
            <h2 class="h2">Nagad</h2>
            <br />
            <p>
              Nagad is one of the top choices for quick deposits and withdrawals. It’s widely used across Bangladesh and offers a simple way to move your money in and out of your account without
              delays.
            </p>
            <h2 class="h2">Rocket</h2>
            <br />
            <p>Rocket is another trusted option for handling payments. Whether you're adding funds or cashing out your winnings, Rocket makes the process simple and secure every time.</p>
            <h2 class="h2">Bkash</h2>
            <br />
            <p>Bkash is well-known for being user-friendly and fast. It’s a reliable choice for players in Bangladesh who want an easy way to handle their payments without any hassle.</p>

            <h2 class="h2">Upay</h2>
            <br />
            <p>Upay gives you a smooth and safe way to handle your funds on Krikya. With its growing popularity, it’s a solid option for quick deposits and worry-free withdrawals.</p>

            <h2 class="h2">Krikya Mobile App and APK</h2>
            <br />
            <p>
              Get the Krikya app or APK and take your gaming wherever you go. The mobile version brings you the full experience of the platform, all packed into a smooth and easy-to-use app. Whether
              you’re on a phone or tablet, everything is designed to run fast, feel simple, and keep you fully connected to your favorite games.
            </p>
            <h2 class="h2">Affiliate Program</h2>
            <br />
            <p>
              <router-link class="router_href" :to="{ name: ROUTE_NAME.APPLY_AGENT, params: { lang: $route.params.lang } }">Become a Krikya affiliate</router-link>
              and earn by sharing our platform with others. It's a simple way to turn your audience or network into a steady stream of income. Our program gives you a chance to make regular
              commissions, with reliable support and guidance at every step. You’ll get access to banners, links, and marketing tools that are ready to use, so you can focus on reaching new players.
              The more users you bring in, the more you earn. It’s a strong setup designed to help you grow and succeed while being part of the Krikya community.
            </p>
          </div>
          <a style="color: #959595;" @click="toggleContent">{{ expanded ? 'Read Less' : 'Read More' }}</a>
        </v-col>
      </v-col>
      <v-col cols="12" class="pa-0" v-if="this.$route.params.lang && this.checkDomain()">
        <v-col v-if="i18n.locale == 'en'">
          <h1 class="h2">Welcome to Krikya – A Reliable Online Gambling Platform in Bangladesh</h1>
          <br />
          <p>
            <router-link class="router_href" :to="{ name: ROUTE_NAME.HOME, params: { lang: $route.params.lang } }">Krikya</router-link>
            is a trustworthy online space in Bangladesh for betting users, gambler areas, as well as genuine chances to win casino players. The objective is to offer the very best safe and secure,
            intelligent and easy gambling experience at Perpetual. From betting on cricket, football or whatever other sports you like to live Casino games along with the actual dealers you want at
            the comfort of home. We support local payment options and offer quick, helpful customer service whenever needed. We want to keep it simple so the process does not confuse the players on
            our platform. You trust us and that is why we keep our systems updated, fair play and with choice in gambling. Krikya is more than just another betting site, but built for players who want
            clear features, easy navigation, and confidence in every session.
          </p>
          <div :class="{ 'hidden-content': !expanded, show: expanded }">
            <h2 class="h2">What Sets Krikya Apart?</h2>
            <br />
            <p>
              According to research published in the Journal of Gambling Issues, gamblers in South Asia often face more risks and fewer support options compared to other groups. Krikya was built to
              mitigate these pain points. The blind spot of other international platforms avoid the local users in bangladesh we do only for this region. Making us able to deliver functional and
              relevant solutions. We built our system to create as little confusion as possible, nip the tailgating in the bud and supply actual tools for use. This includes full mobile compatibility,
              quick withdrawals, and customer support in the local language. Every feature we offer is based on what Bangladeshi players truly need, not borrowed ideas from other platforms, but
              carefully developed options designed specifically for this market.
            </p>
            <h2 class="h2">Explore Krikya’s Game Options</h2>
            <br />
            <h2 class="h2">Sports Betting</h2>
            <br />
            <p>
              Krikya’s sports betting section is built to match the way sports fans in Bangladesh follow and enjoy their favorite games. With the other events such as football, cricket, basketball,
              tennis, baseball or boxing and so on that each is clearly explained and readily available information. It is not betting for the sake of betting but knowing cricket, waging awareness on
              matches and making wise decisions and being there. The platform is made to support your understanding, not to confuse or overwhelm.
            </p>
            <h2 class="h2">Lottery Games</h2>
            <br />
            <p>
              Our lottery section offers a simple and trustworthy way to join regular draws. Instead of big claims, Krikya focuses on giving users smooth access to reliable lottery games. Every ticket
              provides a moment of excitement, with results presented clearly. The system respects traditional lottery play but is updated to suit the expectations of today’s players, easy to use,
              stable, and straightforward.
            </p>
            <h2 class="h2">Cricket Betting</h2>
            <br />
            <p>
              Cricket is such a passionate game in Bangladesh and Krikya cricket betting is reflecting that passion. It minimizes fancy features and then only presents match types, player stats,
              betting markets as what fans are already familiar with on the platform. From local leagues to global Test matches, everything is planned to operate well to keep users informed and
              entertained. To be able to play cricket betting as they want, with peace and not pressure or gobsmack.
            </p>
            <h2 class="h2">Slot Machines</h2>
            <br />
            <p>
              Krikya has the sweets selected for a particular slot game which gives you stability over huge numbers in quality. Based on well recognized makers, loved for their reliable execution and
              solid gameplay, each of the games is picked from. Visuals are sharp, loading is smooth, and every game delivers a fair and straightforward experience. Instead of following temporary
              trends, Krikya provides slot options that are dependable, especially for Bangladeshi users who prefer trusted titles over flashy designs.
            </p>
            <h2 class="h2">Fishing Games</h2>
            <br />
            <p>
              For those who enjoy a slower, more focused style of gaming, Krikya’s fishing games are a great choice. These games combine simple controls with a relaxing and simple experience that
              focuses on players aiming and shooting in a fluid rhythm. Rather than over the top effects, the design focuses on crisp graphics, smooth animations and competent play. Designed by
              developers that appreciate simplicity, the games are for people in Bangladesh who want some things to do but are not bombarded with options.
            </p>
            <h2 class="h2">Live Casino Games</h2>
            <br />
            <p>
              Krikya takes it one step further by offering live dealer games that have a real casino feel on your screen. Blackjack, the Roulette or any other classic game, it is all hosted by experts
              and live streamed in real-time with perfect video quality. Nice and Clean setup, not too distracting that it almost becomes a valid experience. For Bangladeshi players we have a format
              of table live games where they can play with so much joy in their hands with proper organisation.
            </p>
            <h2 class="h2">Table Games</h2>
            <br />
            <p>
              Krikya brings in table games that are classic and come with the basic flavor of their progenitors Here, black jack, baccarat as well being the roulette and also poker everyone gets a
              flat presentation right out the box with simple rules and speedy enough flow that you are able to enjoy without being afraid. These are not the digital duals, but thematically and
              otherwise polished counterparts−crafted, you know it will be buttery smooth like their developer-bottomed sites. For players in Bangladesh, it’s a direct and familiar way to enjoy
              timeless games in a clean setting.
            </p>
            <h2 class="h2">Crash Games</h2>
            <br />
            <p>
              Krikya’s crash games are a good dose of fresh/fast paced gaming with timing being key to quick decisions. The attention is only on that single line that you can pick when to hit and get
              out, no flashiness or complexity. The design is simple, but the gameplay keeps you alert, without feeling out of control. Games built by professionals, these are fair, stable and
              reliable. A nice option for Bangladeshi users who want something different and still not too hardcore/complex.
            </p>
            <h2 class="h2">Safe Payments and Trusted Local Methods</h2>
            <br />
            <p>
              Krikya handles all payments carefully step by step ensuring good performance with known services to Bangladeshi users. All popular mobile money services like bKash, Nagad and Rocket are
              fully supported and operate smoothly, on the platform. Everyday tools for millions in Bangladesh, deposits and withdrawals feel most safe and smooth because they are common appliances.
              The transaction process follows a step by step process where all steps are visible and verifiable so users can have an easy gaming experience without hassle with payment-related problems
              or delays.
            </p>
            <h2 class="h2">Fair Gaming and Player Protection</h2>
            <br />
            <p>
              Krikya believes in ethical competitive playing. It is being operated under gaming license from Curaçao (the live platform must operate within strict guidelines to safeguard the users and
              ensure a fair, open & honest gameplay) All games are powered by reputable Random Number Generators (RNGs) regularly audited to prove they deliver fair and unbiased outcomes. This makes
              this space safe for Bangladeshi players to play. Krikya supports responsible betting with features such as deposit limits, session timers and breaks or self-exclusion for the user to
              keep control and enjoy a balanced experience.
            </p>
            <h2 class="h2">Built Specifically for Bangladeshi Users</h2>
            <br />
            <p>
              Krikya is not a global site simply adjusted for Bangladesh, it has been developed from the start to meet the specific needs of local players. The interface supports regional languages,
              payment systems are fully compatible with commonly used Bangladeshi wallets, and the games reflect popular local interests, such as cricket betting and familiar game formats. According
              to insights from Kzing International, platforms succeed in Bangladesh when they are designed with local habits in mind, not just translated. Krikya operates on the same model, one where
              the local and live-in for Bangladeshi players is paramount.
            </p>
            <h2 class="h2">Supporting the Growth of Gaming in Bangladesh</h2>
            <br />
            <p>
              Krikya will be expanding into the Bangladesh area, taking part in this increase of digital gaming population. In the middle of 2024, the country had surged to more than 142 million
              internet users with a 10.5% compared to some days ago and smartphones owned by 70% of the total households. That indicates the strong trend of digital lifestyle in the country. Krikya
              play to do this by providing a progress compatible platform. Krikya is trying to make sure that players in Bangladesh will be able to find games that match their culture and interests
              through its emphasis on stability and reliability.
            </p>
          </div>
          <a style="color: #959595;" @click="toggleContent">{{ expanded ? 'Read Less' : 'Read More' }}</a>
        </v-col>
        <v-col v-if="i18n.locale == 'bd'">
          <h1 class="h2">ক্রিকিয়া-তে আপনাকে স্বাগতম – বাংলাদেশের জন্য নির্ভরযোগ্য অনলাইন গেম্বলিং প্ল্যাটফর্ম</h1>
          <br />
          <p>
            ক্রিকিয়া একটি বিশ্বস্ত গেম্বলিং সাইট, যেখানে বাংলাদেশি খেলোয়াড়রা বাজি ধরতে পারেন, ক্যাসিনো গেম খেলতে পারেন এবং বাস্তব জয়ের সুযোগ উপভোগ করতে পারেন। আমাদের লক্ষ্য হলো অনলাইন গেম্বলিংকে
            সবার জন্য স্বচ্ছ, নিরাপদ এবং সহজ করে তোলা। আপনি ক্রিকেট, ফুটবলসহ বিভিন্ন খেলায় বাজি ধরতে পারেন, অথবা ঘরে বসেই আসল ডিলারদের সাথে ক্যাসিনো টেবিলে যোগ দিতে পারেন। আমরা স্থানীয় পেমেন্ট গ্রহণ
            করি এবং যেকোনো সময় সহায়তার জন্য দ্রুত সাপোর্ট প্রদান করি। আমাদের সব কিছুই সরল ও বোধগম্য করে তৈরি করা হয়েছে, যাতে আপনি সময় নষ্ট না করেন কিংবা জটিল নিয়মে বিভ্রান্ত না হন। আমরা আপনার
            বিশ্বাসকে সম্মান করি, এজন্য সবকিছু ন্যায়সঙ্গত রাখি, নিয়মিত আমাদের সিস্টেম আপডেট করি এবং আপনাকে আপনার খেলার উপর নিয়ন্ত্রণ রাখার জন্য প্রয়োজনীয় টুলস দিই। ক্রিকিয়া শুধুমাত্র আরেকটি
            গেম্বলিং সাইট নয়—এটি এমন একটি জায়গা, যা তৈরি হয়েছে এমন খেলোয়াড়দের জন্য, যারা চায় সহজ ফিচার, পরিস্কার অপশন এবং প্রতিটি খেলায় আত্মবিশ্বাস।
          </p>
          <div :class="{ 'hidden-content': !expanded, show: expanded }">
            <h2 class="h2">কেন ক্রিকিয়া বেছে নেবেন?</h2>
            <br />
            <p>
              Journal of Gambling Issues-এ প্রকাশিত একটি গবেষণায় উল্লেখ করা হয়েছে, দক্ষিণ এশিয়ান গেম্বলাররা প্রায়ই সাংস্কৃতিকভাবে উপযুক্ত সহায়তার অভাব এবং অন্যান্য গোষ্ঠীর তুলনায় বেশি ঝুঁকির
              মুখোমুখি হন। এই বাস্তবতা মাথায় রেখেই ক্রিকিয়া তৈরি হয়েছে। অনেক আন্তর্জাতিক সাইট বাংলাদেশি ব্যবহারকারীদের পুরোপুরি সহায়তা দিতে পারে না—বিশেষ করে সার্ভিস এবং পেমেন্ট অপশনের দিক থেকে।
              কিন্তু আমরা শুধুমাত্র এই বাজারের জন্য কাজ করি, তাই আমরা সাধারণ সমাধান নয়, সত্যিকারের কার্যকর সেবা দিতে পারি। আমাদের প্ল্যাটফর্ম এমনভাবে তৈরি, যাতে বিভ্রান্তি কমে, দেরি না হয়, এবং
              খেলোয়াড়রা প্রয়োজনীয় টুলস ব্যবহার করতে পারেন। এর মধ্যে রয়েছে সম্পূর্ণ মোবাইল অ্যাক্সেস, দ্রুত উইথড্রয়াল প্রসেসিং এবং এমন একটি সহায়তা দল, যারা ব্যবহারকারীর ভাষায় উত্তর দেয়। আমরা
              যেটা দিচ্ছি, তা অন্যদের নকল নয়—এটা তৈরি হয়েছে বাংলাদেশের খেলোয়াড়দের চাহিদা শুনে, বুঝে, এবং সেই অনুযায়ী গড়ে তোলা হয়েছে।
            </p>
            <h2 class="h2">গেম ক্যাটাগরি</h2>
            <br />
            <h2 class="h2">স্পোর্টসবুক</h2>
            <br />

            <p>
              ক্রিকিয়ার স্পোর্টসবুক শুধুমাত্র একটি ফিচার নয়, বরং এটি এমন একটি পরিসর যা বাংলাদেশি দর্শকদের খেলার প্রতি ভালবাসা ও অনুসরণের ধরন বুঝে তৈরি করা হয়েছে। ফুটবল ও ক্রিকেট থেকে শুরু করে
              বাস্কেটবল, বেসবল, টেনিস, বক্সিং এবং আরও অনেক খেলাকে এখানে উপস্থাপন করা হয়েছে স্পষ্টতা ও প্রাসঙ্গিকতার সঙ্গে। বিষয়টি শুধু অঙ্কের পেছনে দৌড়ানো নয়, বরং ম্যাচের ধারাবাহিকতা বোঝা,
              চিন্তাভাবনা করে সিদ্ধান্ত নেওয়া এবং খেলাধুলার ছন্দের সাথে যুক্ত থাকার ব্যাপার। এই প্ল্যাটফর্মটি তৈরি হয়েছে বুঝে খেলার জন্য, বিভ্রান্ত হওয়ার জন্য নয়।
            </p>
            <h2 class="h2">লটারি</h2>
            <br />
            <p>
              ক্রিকিয়া লটারিকে দেখেছে ভারসাম্যপূর্ণভাবে—যেখানে অংশগ্রহণ সহজ, কিন্তু পরিবেশটি নিরাপদ ও বিশ্বাসযোগ্য। চোখধাঁধানো প্রতিশ্রুতির বদলে, এখানে জোর দেওয়া হয়েছে সহজ প্রবেশ এবং নিয়মিত ড্র-এ
              অংশগ্রহণের সুযোগে। প্রতিটি টিকিট মানে একটি ছোট্ট প্রত্যাশার মুহূর্ত। অভিজ্ঞতাটি ঐতিহ্যকে সম্মান করে, কিন্তু আজকের ব্যবহারকারীদের উপযোগীভাবে সাজানো হয়েছে—সরল, স্থিতিশীল এবং পরিষ্কারভাবে
              উপস্থাপিত।
            </p>
            <h2 class="h2">ক্রিকেট বেটিং</h2>
            <br />
            <p>
              বাংলাদেশে ক্রিকেটের যে বিশেষ স্থান আছে, তা মাথায় রেখেই ক্রিকিয়ায় ক্রিকেট বেটিং তৈরি করা হয়েছে। এটি জটিল করে তোলা হয়নি; বরং ম্যাচ ফরম্যাট, খেলোয়াড়দের পরিসংখ্যান এবং বাজারের
              বিকল্পগুলো এমনভাবে উপস্থাপন করা হয়েছে, যা দর্শকরা আগে থেকেই যেভাবে খেলা অনুসরণ করেন, তার সঙ্গে সঙ্গতিপূর্ণ। এটি স্থানীয় সিরিজ হোক বা আন্তর্জাতিক টেস্ট, প্রতিটি অংশে জোর দেওয়া হয়েছে
              স্বচ্ছতা ও সংযোগের উপর—যাতে ব্যবহারকারীরা তাড়াহুড়ো না করে চিন্তাভাবনা করে যুক্ত হতে পারেন।
            </p>
            <h2 class="h2">স্লট গেমস</h2>
            <br />

            <p>
              ক্রিকিয়ায় স্লট গেম উপস্থাপন করা হয়েছে গুণগত মানকে গুরুত্ব দিয়ে, সংখ্যার চেয়ে মানের উপর জোর দিয়ে। এই গেমগুলোর নির্বাচন করা হয়েছে এমন প্রোভাইডারদের থেকে, যারা শুধুমাত্র অভিজ্ঞ নয়,
              বরং প্রতিটি গেমে ধারাবাহিকতা ও স্থিতিশীলতা বজায় রাখে। গ্রাফিক্স স্পষ্ট, পারফরম্যান্স মসৃণ এবং গেমপ্লে নিজের উদ্দেশ্যে সৎ—সরল, নির্ভরযোগ্য ও ন্যায়সঙ্গত। এটি ট্রেন্ডের পেছনে ছুটে বেড়ানো
              নয়, বরং এমন কিছু দেওয়া, যা সত্যিই কাজ করে—বিশেষ করে বাংলাদেশের ব্যবহারকারীদের জন্য, যারা আকর্ষণীয় চমকের চেয়ে ভরসাযোগ্য অপশনকেই বেশি গুরুত্ব দেন।
            </p>
            <h2 class="h2">ফিশিং গেমস</h2>
            <br />
            <p>
              ক্রিকিয়ার ফিশিং গেমগুলো ধীর গতির হলেও মনোযোগ ধরে রাখে। ডিজাইনটি সরল মেকানিক্সের সাথে টাইমিং ও ফোকাসের একটি ভারসাম্য তৈরি করে, যেখানে খেলোয়াড়রা লক্ষ্য করেন, শুট করেন এবং একটি স্থির
              কিন্তু সক্রিয় পরিবেশে পয়েন্ট সংগ্রহ করেন। চোখ ধাঁধানো ইফেক্টের চেয়ে, গুরুত্ব দেওয়া হয়েছে মসৃণ মুভমেন্ট, স্থিতিশীল ভিজ্যুয়াল এবং ভারসাম্যপূর্ণ গেমপ্লের ওপর—যা তৈরি করেছে এমন
              স্টুডিওগুলো, যারা জানে কীভাবে সবকিছু পরিষ্কার ও উপভোগ্য রাখা যায়। এটি বাংলাদেশের সেই ব্যবহারকারীদের জন্য একটি বিকল্প, যারা চায় ইন্টারঅ্যাকটিভ কিছু, কিন্তু অতিরিক্ত জটিলতা ছাড়া।
            </p>
            <h2 class="h2">লাইভ ডিলার গেমস</h2>
            <br />

            <p>
              ক্রিকিয়ায় লাইভ ডিলার গেমগুলো এমনভাবে ডিজাইন করা হয়েছে, যাতে টেবিলের অভিজ্ঞতা ঘরের কাছাকাছি আসে, কিন্তু বাড়তি চাপ ছাড়াই। রুলেট ও ব্ল্যাকজ্যাকের মতো ক্লাসিক অপশন থেকে শুরু করে আধুনিক
              কার্ড রুম পর্যন্ত, প্রতিটি সেশন পরিচালনা করেন প্রশিক্ষিত ডিলাররা, সরাসরি সম্প্রচারে, স্থিতিশীল ভিডিও কোয়ালিটির মাধ্যমে। পরিবেশটি পেশাদার, নয় নাটকীয়—এটি তৈরি হয়েছে স্বচ্ছতা ও
              বাস্তবতার অনুভূতি দিতে। বাংলাদেশের খেলোয়াড়দের জন্য এটি একটি আসল খেলার পরিবেশের উপস্থিতি দেয়, যা এমন একটি প্ল্যাটফর্মে সহজলভ্য, যেখানে কাঠামোকে প্রাধান্য দেওয়া হয়, দেখনদারিকে নয়।
            </p>
            <h2 class="h2">টেবিল গেমস</h2>
            <br />
            <p>
              ক্রিকিয়া টেবিল গেম উপস্থাপন করে প্রতিটি গেমের মূল রূপ ও ঐতিহ্যকে সম্মান জানিয়ে। এটি ব্ল্যাকজ্যাক, বাকারা, রুলেট বা পোকার যাই হোক না কেন, লেআউট রাখা হয়েছে পরিষ্কার, নিয়মগুলো ব্যাখ্যা
              করা হয়েছে সহজভাবে এবং গেমের গতি এমনভাবে নির্ধারিত, যাতে খেলোয়াড়রা চাপ ছাড়াই অংশ নিতে পারেন। এগুলো শুধুমাত্র ডিজিটাল সংস্করণ নয়—বরং পরিচিত ফরম্যাটে গঠিত, যা তৈরি করেছে এমন
              প্রোভাইডাররা যারা স্পষ্টতা ও মসৃণ পারফরম্যান্সকে গুরুত্ব দেয়। বাংলাদেশের ব্যবহারকারীদের জন্য এটি পরিচিত গেমগুলো উপভোগ করার সরল এবং মনোযোগ বিচ্যুতি ছাড়াই একটি উপায়।
            </p>
            <h2 class="h2">ক্র্যাশ গেমস</h2>
            <br />

            <p>
              ক্রিকিয়ার ক্র্যাশ গেমগুলো ভিন্নধরনের ছন্দ নিয়ে আসে—দ্রুত, ভিজ্যুয়াল এবং টাইমিং নির্ভর, শুধুমাত্র ভাগ্যের উপর নয়। এখানে থিম বা ইফেক্টের ওপর নির্ভর না করে, গেমপ্লে কেন্দ্রীভূত একটি সরল
              ওঠানামার লাইনের ওপর এবং খেলোয়াড়ের সিদ্ধান্তের ওপর—কখন থামবেন। গেমটি দ্রুতগতির হলেও বিশৃঙ্খল নয়, এবং এটি এমন ডেভেলপারদের দ্বারা তৈরি, যারা জানে কীভাবে মেকানিকসকে ন্যায্য ও স্থিতিশীল
              রাখা যায়। বাংলাদেশের খেলোয়াড়দের জন্য, যারা চায় আধুনিক কিন্তু সরল কিছু, এটি একটি তীক্ষ্ণ, নিয়ন্ত্রিত অভিজ্ঞতা প্রদান করে—অপ্রয়োজনীয় গোলমাল ছাড়াই।
            </p>
            <h2 class="h2">নিরাপদ লেনদেন ও পেমেন্ট পদ্ধতি</h2>
            <br />
            <p>
              ক্রিকিয়া লেনদেন পরিচালনা করে ধারাবাহিকতা এবং স্থানীয় অভিজ্ঞতাকে গুরুত্ব দিয়ে। বাংলাদেশের ব্যবহারকারীদের জন্য bKash, Nagad এবং Rocket এর মতো পেমেন্ট পদ্ধতিগুলো শুধু অপশন হিসেবে নয়,
              বরং ভরসাযোগ্য সেবারূপে প্ল্যাটফর্মে মসৃণভাবে সংযুক্ত করা হয়েছে। এই পদ্ধতিগুলো দেশজুড়ে লক্ষ লক্ষ মানুষের দৈনন্দিন লেনদেনে ব্যবহৃত হয়, যা প্রতিটি ডিপোজিট বা উইথড্রয়ালকে আরও
              আত্মবিশ্বাসী করে তোলে। পুরো প্রক্রিয়াটি রাখা হয়েছে সহজ, প্রতিটি ধাপ যাচাই করা হয়, যেন ব্যবহারকারীরা অভিজ্ঞতার উপর মনোযোগ দিতে পারেন—পেছনের জটিলতা নিয়ে ভাবতে না হয়।
            </p>
            <h2 class="h2">ফেয়ার প্লে ও দায়িত্বশীল গেমিং</h2>
            <br />
            <p>
              ক্রিকিয়া ন্যায়সংগত খেলার নিশ্চয়তা দেয় লাইসেন্সপ্রাপ্ত তত্ত্বাবধান এবং আধুনিক প্রযুক্তির সমন্বয়ে। কুরাকাও গেমিং লাইসেন্সের আওতায় থাকায়, প্ল্যাটফর্মটি কঠোর মানদণ্ড মেনে চলে—যা
              খেলোয়াড়দের সুরক্ষা ও স্বচ্ছতা নিশ্চিত করে। প্রতিটি গেম পরিচালিত হয় নির্ভরযোগ্য র‍্যান্ডম নাম্বার জেনারেটর দ্বারা, যা স্বাধীনভাবে যাচাই করা হয়েছে যাতে ফলাফল সবসময় এলোমেলো ও
              পক্ষপাতহীন থাকে। বাংলাদেশের খেলোয়াড়দের জন্য এটি একটি নিরাপদ পরিবেশ নিশ্চিত করে, যেখানে প্রতিটি ফলাফলে আস্থা রাখা যায় এবং নিয়মতান্ত্রিকতার মাধ্যমে বিশ্বাস গড়ে ওঠে।
            </p>
            <p>
              এছাড়াও, ক্রিকিয়া দায়িত্বশীল গেমিং অনুশীলনকে সমর্থন করে—ব্যবহারকারীদের খেলার নিয়ন্ত্রণে সহায়তা করার জন্য বিভিন্ন টুলস প্রদান করে। এর মধ্যে রয়েছে ডিপোজিট সীমা নির্ধারণ, সেশন
              ট্র্যাকিং এবং আত্ম-নিষেধাজ্ঞা (self-exclusion) অপশন, যার উদ্দেশ্য হলো খেলাকে একটি সুস্থ, নিরাপদ এবং উপভোগ্য অভিজ্ঞতায় পরিণত করা।
            </p>
            <h2 class="h2">বাংলাদেশি খেলোয়াড়দের জন্য ডিজাইনকৃত</h2>
            <br />
            <p>
              ক্রিকিয়া এমন একটি প্ল্যাটফর্ম নয় যা সাধারণ কাঠামো থেকে বাংলাদেশে মানিয়ে নেওয়া হয়েছে—এটি শুরু থেকেই বাংলাদেশি খেলোয়াড়দের কথা মাথায় রেখে তৈরি। ইন্টারফেসটি স্থানীয় ভাষার জন্য
              উপযোগী, পেমেন্ট সিস্টেম জনপ্রিয় বাংলাদেশি ওয়ালেটগুলোর সাথে সামঞ্জস্যপূর্ণ এবং গেমের নির্বাচনেও প্রতিফলিত হয়েছে এই অঞ্চলের অনন্য আগ্রহ—যেমন ক্রিকেট-ভিত্তিক বেটিং এবং সাংস্কৃতিকভাবে
              পরিচিত ফরম্যাট। Kzing International-এর এক গবেষণায় দেখা গেছে, বাংলাদেশে প্ল্যাটফর্ম তখনই সফল হয়, যখন কেবল কনটেন্ট নয়, ডিজাইনেও স্থানীয় অভ্যাস যুক্ত থাকে। ক্রিকিয়া এই দৃষ্টিভঙ্গিকে
              অনুসরণ করে, যেখানে অভিজ্ঞতা বিদেশি নয়, বরং ঘরোয়া ও পরিচিত মনে হয়।
            </p>
            <h2 class="h2">বাংলাদেশি গেমারদের প্রতি আমাদের অঙ্গীকার</h2>
            <br />
            <p>
              ক্রিকিয়া বাংলাদেশের বিকাশমান অনলাইন গেমিং সংস্কৃতিকে সমর্থন করতে প্রতিশ্রুতিবদ্ধ। ২০২৪ সালের মাঝামাঝি পর্যন্ত দেশে ইন্টারনেট ব্যবহারকারীর সংখ্যা দাঁড়িয়েছে ১৪.২ কোটিরও বেশি, যা বছরের
              শুরু থেকে ১০.৫% বৃদ্ধি নির্দেশ করে। পাশাপাশি, ৭০.১% পরিবারে স্মার্টফোনের মালিকানা রয়েছে—যা একটি তরুণ ও সক্রিয় ডিজিটাল সম্প্রদায়ের ইঙ্গিত দেয়। এই বাস্তবতা বিবেচনায় রেখে, ক্রিকিয়ার
              লক্ষ্য এমন একটি প্ল্যাটফর্ম সরবরাহ করা যা এই পরিবর্তনের সঙ্গে সামঞ্জস্যপূর্ণ। একটি নির্ভরযোগ্য ও সাংস্কৃতিকভাবে সংবেদনশীল অভিজ্ঞতার মাধ্যমে, ক্রিকিয়া এই ইতিবাচক রূপান্তরের অংশ হতে
              চায়—যাতে বাংলাদেশের বেটাররা তাদের আকাঙ্ক্ষার প্রতিফলন দেখতে পান একটি পরিচিত ও সম্মানজনক পরিবেশে।
            </p>
          </div>
          <a style="color: #959595;" @click="toggleContent">{{ expanded ? 'Read Less' : 'Read More' }}</a>
        </v-col>
      </v-col>

      <v-col cols="12" class="pa-0" v-else>
        <!--        <v-col v-if="i18n.locale == 'en'">-->
        <!--          <h1 class="h2">-->
        <!--            Krikya | Online Casino {{ currentYear }} | IPL | Indian Premier League | Crazy Time | Krikya88 | Krikya Trusted Online Betting Site | Online Casino Bangladesh | Krikya Bet | Krikya Casino-->
        <!--            App Download-->
        <!--          </h1>-->
        <!--          <br/>-->
        <!--          <h2>Begin Playing {{ currentYear }}'s Top Online Casino Bangladesh</h2>-->
        <!--          <p>-->
        <!--            With krikya casino {{ currentYear }}, you can play Live Casino Bangladesh games, play slot games, bet on cricket, and win real money or jackpots. With a wide range of slot games and Online-->
        <!--            Casino Bangladesh, we can provide you with the best of what is available.-->
        <!--          </p>-->
        <!--          <p>Online Slot Bangladesh, Indian Premier League, live ball, mad time, and betting are a few of the many types of Cricket Exchange games we offer.</p>-->
        <!--          <h2>Top Games Pick At Krikya</h2>-->
        <!--          <p>-->
        <!--            In addition to sports and top online casino {{ currentYear }}, we also offer slots, arcade games, and live ball games. This will keep you entertained and provide you with better-->
        <!--            opportunities to win amazing prizes and real money. Furthermore, the Bangladeshi online Krikya casino offers you the chance to try your luck in Online Casino Bangladesh.-->
        <!--          </p>-->
        <!--          <h2>Play Top Cricket Casino in Bangladesh</h2>-->
        <!--          <p>-->
        <!--            There is a variety of cricket casino {{ currentYear }} in Bangladesh gaming options available to you. At the top cricket betting site Bangladesh, we have Bangladesh Cricket Betting, Cricket-->
        <!--            Exchange, and have fun. In addition, you can choose from several cricket betting options that will provide you with an entirely different gaming experience. So, go to best cricket-->
        <!--            betting,download it and start playing playing Best Cricket Betting!-->
        <!--          </p>-->
        <!--          <p>Join us for Best cricket betting!</p>-->
        <!--          <h2>Create Account To Play Krikya Games</h2>-->
        <!--          <p>-->
        <!--            Creating an account is much easier and takes hardly any time for Crazy Time experience. Let our experts handle the rest of the work after you have read through the Indian Premier League-->
        <!--            details and reviewed and accepted all terms and conditions.-->
        <!--          </p>-->
        <!--          <p>Whether you as a casino player are interested in learning the basics of IPL or enjoying online slots bangladesh Bangladesh, we provide you with the right solutions on Krikya bet.</p>-->
        <!--          <h2>Is Krikya casino safe to play?</h2>-->
        <!--          <p>Absolutely yes! Krikya is safe to play the verities of online casino games and betting. You can come to us and play or bet on any of your favorite casino games today!</p>-->
        <!--          <h2>How to join Krikya?</h2>-->
        <!--          <p>Visit Krikya and sign up to join our casino. The time you join the casino, you will get exciting gaming offers and also big rewards to win.</p>-->
        <!--        </v-col>-->
        <!--        <v-col v-else-if="i18n.locale == 'bd'">-->
        <!--          <h1 class="h2">-->
        <!--            ক্রিক্য | অনলাইন ক্যাসিনো {{ currentYear }} | হিন্দুন প্রিমিয়ার লিগ | পাগলামী সময় | আইপিএল | ইন্ডিয়ানপ্রিমিয়ার লিগ | পাগল সময় | Krikya88 | ক্রিক্যা বিশ্বস্ত অনলাইন বেটিং সাইট-->
        <!--          </h1>-->
        <!--          <br/>-->
        <!--          <h2>{{ currentYear }} এর সেরা অনলাইন ক্যাসিনো বাংলাদেশ খেলা শুরু করুন</h2>-->
        <!--          <p>-->
        <!--            সঙ্গে krikya casino {{ currentYear }}, আপনি লাইভ ক্যাসিনো বাংলাদেশ গেম খেলতে পারেন, স্লট গেম খেলতে পারেন, ক্রিকেটে বাজি ধরতে পারেন এবং আসল টাকা বা জ্যাকপট জিততে পারেন। স্লট গেমের বিস্তৃত-->
        <!--            পরিসর এবং অনলাইন ক্যাসিনো বাংলাদেশ এর সাথে, আমরা আপনাকে যা পাওয়া যায় তার সেরাটি দিতে পারি।-->
        <!--          </p>-->
        <!--          <p>অনলাইন স্লট বাংলাদেশ, ইন্ডিয়ান প্রিমিয়ার লিগ, লাইভ বল, পাগলামী সময়, এবং বেটিং হল এর অনেক প্রকারের কয়েকটি। ক্রিকেট এক্সচেঞ্জ গেম আমরা অফার করি।</p>-->
        <!--          <h2>Krikya-এ সেরা গেম বাছাই করুন</h2>-->
        <!--          <p>-->
        <!--            খেলাধুলা এবং অনলাইন ক্যাসিনো {{ currentYear }} ছাড়াও, আমরা স্লট, আর্কেড গেম এবং লাইভ বল গেমও অফার করি। এটি আপনাকে বিনোদন দেবে এবং আপনাকে আশ্চর্যজনক পুরস্কার এবং আসল অর্থ জেতার আরও ভাল সুযোগ-->
        <!--            প্রদান করবে। উপরন্তু, বাংলাদেশী অনলাইন Krikya ক্যাসিনো আপনাকে অনলাইন ক্যাসিনো বাংলাদেশ।-->
        <!--          </p>-->
        <!--          <h2>বাংলাদেশে শীর্ষ ক্রিকেট ক্যাসিনো খেলুন</h2>-->
        <!--          <p>-->
        <!--            বাংলাদেশে বিভিন্ন ধরনের ক্রিকেট ক্যাসিনো গেমিং অপশন আপনার জন্য উপলব্ধ। শীর্ষে ক্রিকেট বেটিং বাংলাদেশ, আমাদের আছে বাংলাদেশ ক্রিকেট বাজি, ক্রিকেট এক্সচেঞ্জ, এবং মজা করুন৷ এছাড়াও, আপনি বিভিন্ন-->
        <!--            ক্রিকেট বেটিং অপশন থেকে বেছে নিতে পারেন যা আপনাকে সম্পূর্ণ ভিন্ন গেমিং অভিজ্ঞতা প্রদান করবে। সুতরাং, সেরা ক্রিকেট বেটিং এ যান, ডাউনলোড করুন এবং সেরা ক্রিকেট খেলা শুরু করুন!-->
        <!--          </p>-->
        <!--          <p>সেরা ক্রিকেট খেলার জন্য আমাদের সাথে যোগ দিন!</p>-->
        <!--          <h2>Krikya গেম খেলতে অ্যাকাউন্ট তৈরি করুন</h2>-->
        <!--          <p>-->
        <!--            একটি অ্যাকাউন্ট তৈরি করা অনেক সহজ এবং ক্রেজি টাইম অভিজ্ঞতার জন্য খুব কমই সময় লাগে৷ আপনি ইন্ডিয়ান প্রিমিয়ার লিগের বিশদটি পড়ার পরে এবং সমস্ত শর্তাবলী পর্যালোচনা ও গ্রহণ করার পরে আমাদের-->
        <!--            বিশেষজ্ঞদের বাকি কাজ পরিচালনা করতে দিন .-->
        <!--          </p>-->
        <!--          <p>আপনি একজন ক্যাসিনো খেলোয়াড় হিসেবে IPL এর মূল বিষয়গুলি শিখতে বা উপভোগ করতে আগ্রহী কিনা অনলাইন স্লট বাংলাদেশ বাংলাদেশ, আমরা আপনাকে ক্রিক্যা বেটের সঠিক সমাধান প্রদান করি।</p>-->
        <!--          <h2>Krikya ক্যাসিনো খেলার জন্য নিরাপদ?</h2>-->
        <!--          <p>অবশ্যই হ্যাঁ! Krikya অনলাইন ক্যাসিনো গেম এবং বাজি খেলার জন্য নিরাপদ। আপনি আমাদের কাছে এসে আজই আপনার পছন্দের যে কোনো ক্যাসিনো গেম খেলতে বা বাজি ধরতে পারেন!</p>-->
        <!--          <h2>কিভাবে Krikya এ যোগদান করবেন?</h2>-->
        <!--          <p>Krikya-এ যান এবং আমাদের ক্যাসিনোতে যোগ দিতে সাইন আপ করুন। আপনি ক্যাসিনোতে যোগদান করার সময়, আপনি আকর্ষণীয় গেমিং অফার পাবেন এবং জেতার জন্য বড় পুরস্কারও পাবেন।</p>-->
        <!--        </v-col>-->
      </v-col>
    </v-row>
    <v-row v-else-if="$route.name == routeName.CASINO">
      <v-col cols="12" class="pa-0" v-if="!this.$route.params.lang && this.checkDomain()">
        <v-col>
          <h1 class="h2">Play Krikya Live Casino with Experienced Real Dealers</h1>
          <br />
          <p>
            Enter a live casino that combines real time gaming with actual persons interacting live. At
            <router-link class="router_href" :to="{ name: ROUTE_NAME.HOME, params: { lang: $route.params.lang } }">Krikya</router-link>
            , live tables take place with elite and friendly dealers who give you the full casino party that you would experience at the house directly from your screen. Each session is meticulously
            crafted to transport you into a world of HD live streaming, seamless in-game experience and an authentic feel equally well. Krikya keeps the live action stream going unbroken, whether you
            are at home or away from home where experienced hosts will slide every run. There’s nothing automated here, only real games players face against other real live gamers and you actually
            have a chance of winning.
          </p>
          <div :class="{ 'hidden-content': !expanded, show: expanded }">
            <h2 class="h2">Live Casino Available 24/7</h2>
            <br />
            <h2 class="h2">Live Baccarat</h2>
            <br />
            <p>
              Baccarat at Krikya blends simplicity with elegance. The game is presented in a calm and focused environment, allowing you to observe every card as it's dealt by a real dealer. Table
              ambiance stays the same, so you are not going to feel unsteady and make decisions with distractions. Flexible settings + a steady pace are clearly in tune for players who prefer less
              shake and more fluidity/defined win/losses.
            </p>
            <h2 class="h2">Live Blackjack</h2>
            <br />
            <p>
              Live Blackjack tables offer the live and real face of playing in our Uganda Casino Booking. All sessions have a professional dealer that communicates in a clear and fair way. The
              structure of the game allows for nuanced decisions, acting as a buffer to help you implement your strategy without having it wrong. It keeps a very professional and grounded feel just
              like you planned to have as a balance of engagement but not distracted for those times.
            </p>
            <h2 class="h2">Live Roulette</h2>
            <br />
            <p>
              Live Roulette at Krikya captures the quiet anticipation of every spin. The wheel is handled with care, and results are delivered in real time without delay. You can choose from local or
              international tables, each offering a consistent pace and a familiar setting. The setup is built to mimic what a real casino is like, with no disturbances or distractions.
            </p>
            <h2 class="h2">Live Dragon Tiger</h2>
            <br />
            <p>
              Dragon Tiger goes straight down the line, each and every deal moves directly from question to answer in a single format. Krikya uses this game in a concentrated manner that delivers the
              message, and keeps the player engaged without any distractions. The dealer plays every hand with predictability, making quick decisions blend into a steady rhythm. Perfect for people who
              like to quickly and assertively make a decision.
            </p>
            <h2 class="h2">Live Sic Bo</h2>
            <br />
            <p>
              The game is meticulously displayed so that you process each roll as it lives. Dealers have a neutral presence and guide each round in a focused manner. The interface is very good for
              betting. Coming to this version has the same experience just that it provides a consistent and enveloping space for play.
            </p>
            <h2 class="h2">Live Gameplay with Certified Casino Hosts</h2>
            <br />
            <p>
              At Krikya, every live game is powered by stable streaming technology that keeps the action clear and uninterrupted. Professional dealers manage each table with confidence and a calm
              presence, creating a setting that feels both genuine and well-organized. The studio environment is carefully arranged to reflect a real casino, with lighting, layout, and pace all
              designed for comfort and focus. The result is a space where players can trust what they see and enjoy steady, real-time gameplay.
            </p>
            <h2 class="h2">Play from Anywhere in Bangladesh</h2>
            <br />
            <p>
              At Krikya, because over 65% of users in key demographics like Dhaka and Chattogram are playing us live casino platforms from mobile as per statistics we have optimized to a great extent
              for mobile.
            </p>
            <p>
              We provide flawless experience in Android, iOS and low-bandwidth networks so players can play smoothly even if they are using 3G or unstable 4G connections. The interface continues to be
              active and solid regardless of if it's the app or mobile browser. We also utilize safe and reliable local payment methods such as bKash, Nagad, Rocket thereby enabling players from all
              over Bangladesh to deposit and withdraw money with speed and security at any hour, in any place.
            </p>
            <h2 class="h2">Trusted, Secure, and Fair Live Gaming</h2>
            <br />
            <p>
              Krikya’s live casino operates exclusively with licensed software providers whose games are monitored in real time by both internal compliance teams and third-party auditors. Processed
              every card dealt, turn spun and dice rolled is live streamed over secure end-to-end encrypted channels that preserve data integrity and player security. All live games sessions including
              the ones hosted by your dealer, again run on regulated systems running RNG verification tools in addition as monitored directly by the game studios and certified labs behind the scenes.
              The multi-tiered ecosystem not only complies with global gaming regulations but also the endeavor of Krikya to provide a fair and transparent environment for the players in bangladesh.
            </p>
          </div>
          <a style="color: #959595;" @click="toggleContent">{{ expanded ? 'Read Less' : 'Read More' }}</a>
        </v-col>
      </v-col>
      <v-col cols="12" class="pa-0" v-if="this.$route.params.lang && this.checkDomain()">
        <v-col v-if="i18n.locale == 'en'">
          <h1 class="h2">Experience Real-Time Gaming with Live Dealers at Krikya</h1>
          <br />
          <p>
            <router-link class="router_href" :to="{ name: ROUTE_NAME.HOME, params: { lang: $route.params.lang } }">Krikya</router-link>
            offers a live casino that is as you read the description and every single game is being played in real-time by real dealers. The live tables are hosted by professionals. They were trained
            to make every session entertaining and headache free. With clear video, stable performance, and a lifelike setting, the experience feels close to visiting a traditional casino, only
            without leaving your home. Whether you’re using a mobile device or desktop, Krikya gives you full access to live gameplay, where every action is handled by a skilled dealer, not a machine.
            It’s about real people, real cards, and real chances to win.
          </p>
          <div :class="{ 'hidden-content': !expanded, show: expanded }">
            <h2 class="h2">Live Casino Anytime You Want</h2>
            <br />
            <h2 class="h2">Live Baccarat</h2>
            <br />
            <p>
              Baccarat at Krikya is simple, elegant, and easy to follow. A real dealer manages each round in a quiet, steady environment that helps you focus. You get to watch each card being dealt
              live one by one with no hustle and no interruptions. Good game layout, good pace (not too fast or slow), works for players who like to have the wheel of mass murder spinning freely.
            </p>
            <h2 class="h2">Live Blackjack</h2>
            <br />
            <p>
              Krikya live Blackjack will take you to the street-realistic and simple place. The dealers are proven, loud and fair running each game. The form gives patience in making decisions so that
              you can make your move nicely, as per the strategy. A perfect working environment to be calm and focused, players who love challenging their skills in fair gameplay
            </p>
            <h2 class="h2">Live Roulette</h2>
            <br />
            <p>
              The live roulette from krikya is a slow and relaxed game, where each spin is being shown live. The dealer spins the wheel gently and results come almost instantly. Choose from the local
              or international tables and get tables that are always meant to be a normal tempo. The entire installation is very smooth and drama-free, so it actually reminds me of a real casino
              table.
            </p>
            <h2 class="h2">Live Dragon Tiger</h2>
            <br />
            <p>
              Play Dragon Tiger with Krikya, every round goes from cards being dealt to result shown, keeping the game speedy enough not to bore yet not hectic for players. The dealer goes with a
              steady click, walking all around the table so you can pick your move. Perfect for those that like fast action games but still desire an even keel.
            </p>
            <h2 class="h2">Live Sic Bo</h2>
            <br />
            <p>
              Sic Bo is the classic dice live casino Krikya provides an interactive gameplay using in real-time, with easy-to-use controls. You will clearly see each dice roll, with a pro dealer
              running the session and moderating it a touch calming the whole thing so it is easy to follow. Good simple laid out betting layout so no distractions and you can concentrate on your
              picks. It stays closer to the traditional gameplay of the game but also remains easy enough for players these days in Bangladesh.
            </p>
            <h2 class="h2">Real-Time Casino Action with Trained Hosts</h2>
            <br />
            <p>
              At Krikya, all live games are streamed using stable and high-quality technology, so players get a smooth and reliable experience. Every table is managed by skilled dealers who run the
              game with calm and confidence. The overall setting is intended to look and feel 100% smoke-filled, camera angles everywhere to keep you in check. It is laid out perfectly so you can see
              exactly what is going on and believe what you see.
            </p>
            <h2 class="h2">Play Live Casino on Mobile Anywhere in Bangladesh</h2>
            <br />
            <p>
              Krikya’s live casino is fully built to work well on mobile devices. Knowing that many users from cities like Dhaka and Chattogram use smartphones, the platform is made for Android, iOS,
              and even works well on slower networks like 3G. The gameplay is still slick, the user experience is comfortable whether you are playing from mobile browser or Krikya app. We also
              facilitate in-country payment options for our users (bKash, Nagad, Rocket etc.) so you can deposit or withdraw wherever you are in Bangladesh and still make it convenient for anyone.
            </p>
            <h2 class="h2">Verified Live Games with Full Security</h2>
            <br />
            <p>
              Krikya only uses licensed live casino software from trusted providers. Every game is monitored in real time by both in-house teams and certified third-party testers. Every spin, card
              draw, and dice roll is streamed securely using encrypted connections to protect user data. In games that have a live dealer, it is the Random Number Generators (RNGs) that spin the reels
              for fairness behind the scenes. Made to conform with global gaming standards, the system is regularly audited by the game studios and put through independent labs. This is in Krikya
              promise of ensuring safety, trustability and genuineness of the gaming environment to players in bangladesh.
            </p>
          </div>
          <a style="color: #959595;" @click="toggleContent">{{ expanded ? 'Read Less' : 'Read More' }}</a>
        </v-col>
        <v-col v-if="i18n.locale == 'bd'">
          <h1 class="h2">কৃকিয়া লাইভ ক্যাসিনোতে অভিজ্ঞ বাস্তব ডিলারদের সাথে খেলুন</h1>
          <br />
          <p>
            আসল সময়ের গেম এবং প্রকৃত মানব যোগাযোগের সমন্বয়ে কৃকিয়া লাইভ ক্যাসিনোতে প্রবেশ করুন। আমাদের লাইভ টেবিলগুলি পেশাদার ও বন্ধুত্বপূর্ণ ডিলারদের দ্বারা পরিচালিত হয়, যারা আপনার স্ক্রিনে
            ঐতিহ্যবাহী ক্যাসিনোর সম্পূর্ণ উত্তেজনা পৌঁছে দেয়। প্রতিটি সেশন অত্যন্ত যত্ন সহকারে ডিজাইন করা হয়েছে, যা উচ্চ-রেজোলিউশনের স্ট্রিমিং, নির্বিঘ্ন গেমপ্লে এবং বাস্তবধর্মী পরিবেশের সংমিশ্রণে
            একটি আকর্ষণীয় অভিজ্ঞতা তৈরি করে।
          </p>
          <p>
            আপনি বাড়িতে আরামদায়ক অবস্থায় থাকুন বা চলার পথে খেলুন, কৃকিয়া আপনাকে নিরবচ্ছিন্ন লাইভ অ্যাকশন উপভোগের সুযোগ দেয়, যেখানে দক্ষ হোস্টরা প্রতিটি পদক্ষেপকে নিখুঁতভাবে পরিচালনা করে। এখানে
            কোনও স্বয়ংক্রিয় ব্যবস্থা নেই - শুধুমাত্র বাস্তব গেম, বাস্তব মানুষ এবং জয়ের বাস্তব সুযোগ রয়েছে।
          </p>
          <div :class="{ 'hidden-content': !expanded, show: expanded }">
            <h2 class="h2">লাইভ ক্যাসিনো ২৪/৭ উপলব্ধ</h2>
            <br />
            <h2 class="h2">লাইভ ব্যাকারাট</h2>
            <br />
            <p>
              কৃকিয়ায় লাইভ ব্যাকারাট সরলতা এবং সৌন্দর্যের একটি নিখুঁত মিশ্রণ। গেমটি একটি শান্ত এবং মনোযোগী পরিবেশে উপস্থাপিত হয়, যেখানে আপনি আসল ডিলারের দ্বারা বিতরণ করা প্রতিটি কার্ড পরিষ্কারভাবে
              পর্যবেক্ষণ করতে পারেন। টেবিলের পরিবেশ স্থিতিশীল থাকে, যা আপনাকে কোনো বিঘ্ন ছাড়াই আপনার সিদ্ধান্তে নিয়ন্ত্রণ বজায় রাখতে সহায়তা করে। নমনীয় সেটিংস এবং নিয়মিত গেমপ্লে গতির সাথে এটি
              তাদের জন্য উপযুক্ত, যারা মসৃণ প্রবাহ এবং পরিষ্কার ফলাফলকে মূল্যায়ন করেন।
            </p>
            <h2 class="h2">লাইভ ব্ল্যাকজ্যাক</h2>
            <br />
            <p>
              আমাদের লাইভ ব্ল্যাকজ্যাক টেবিলগুলি সরাসরি এবং প্রামাণিক খেলার অভিজ্ঞতা প্রদান করে। প্রতিটি সেশন অভিজ্ঞ ডিলারদের দ্বারা পরিচালিত হয়, যারা স্পষ্ট যোগাযোগ এবং ন্যায্য খেলার নিশ্চয়তা দেয়।
              গেমের গঠন আপনাকে চিন্তাশীল সিদ্ধান্ত নেওয়ার সুযোগ দেয়, যাতে আপনি চাপে না পড়ে আপনার কৌশল প্রয়োগ করতে পারেন। পরিবেশটি সর্বদা পেশাদার এবং স্থিতিশীল থাকে, যা মনোযোগ এবং সম্পৃক্ততা
              পছন্দকারী খেলোয়াড়দের জন্য আদর্শ।
            </p>

            <h2 class="h2">লাইভ রুলেট</h2>
            <br />
            <p>
              কৃকিয়ার লাইভ রুলেটে প্রতিটি স্পিনের শান্ত উত্তেজনা উপভোগ করুন। চাকার প্রতিটি ঘূর্ণন সাবধানে পরিচালিত হয় এবং ফলাফলগুলি তাৎক্ষণিকভাবে সরাসরি প্রদর্শিত হয়, কোনো বিলম্ব ছাড়াই। আপনি
              স্থানীয় বা আন্তর্জাতিক টেবিলের মধ্যে পছন্দ করতে পারেন, প্রতিটি টেবিল ধারাবাহিক গতি এবং পরিচিত পরিবেশ প্রদান করে। এই অভিজ্ঞতাটি একটি সত্যিকারের ক্যাসিনোর ছন্দকে প্রতিফলিত করতে ডিজাইন করা
              হয়েছে, যেখানে কোনো বিঘ্ন বা মনোযোগ বিচ্যুতি নেই।
            </p>
            <h2 class="h2">লাইভ ড্রাগন টাইগার</h2>
            <br />
            <p>
              ড্রাগন টাইগার একটি সরাসরি গেমফরম্যাট, যেখানে প্রতিটি রাউন্ড দ্রুততার সাথে ডিল থেকে ফলাফলে পৌঁছায়। কৃকিয়ায়, এই গেমটি স্পষ্টতা ও মনোযোগ সহ উপস্থাপিত হয়, যা খেলোয়াড়দের অপ্রয়োজনীয়
              বিভ্রান্তি ছাড়াই সম্পূর্ণ মনোযোগ ধরে রাখতে সহায়তা করে। ডিলার প্রতিটি কার্ড বিতরণে ধারাবাহিকতা বজায় রাখে, একটি স্থিতিশীল গতিসম্পন্ন পরিবেশ তৈরি করে, যেখানে দ্রুত চিন্তাভাবনা এবং
              আত্মবিশ্বাসী সিদ্ধান্তের মিল রয়েছে। এটি তাদের জন্য উপযুক্ত, যারা দ্রুত এবং দৃঢ় সিদ্ধান্ত গ্রহণে আনন্দ পান।
            </p>
            <h2 class="h2">লাইভ সিক বো</h2>
            <br />
            <p>
              কৃকিয়ার সিক বো গেমটি ঐতিহ্যবাহী পাশা খেলার অভিজ্ঞতাকে বাস্তব সময়ে উপস্থাপন করে। গেমটি সতর্কতার সাথে প্রতিটি বিশদে মনোযোগ দিয়ে উপস্থাপিত হয়, যাতে আপনি প্রতিটি পাশা নিক্ষেপ স্পষ্টভাবে
              পর্যবেক্ষণ করতে পারেন। ডিলাররা প্রতিটি রাউন্ড শান্তভাবে পরিচালনা করে, যেখানে ইন্টারফেসটি স্পষ্ট বাজির বিকল্প সমর্থন করে। এই সংস্করণটি গেমের মূল ঐতিহ্যের প্রতি বিশ্বস্ত, একটি স্থিতিশীল
              এবং আকর্ষণীয় পরিবেশ প্রদান করে, যেখানে আপনি আত্মবিশ্বাসের সাথে খেলতে পারবেন।
            </p>
            <h2 class="h2">প্রশিক্ষিত ক্যাসিনো হোস্টদের সাথে লাইভ গেমপ্লে</h2>
            <br />
            <p>
              কৃকিয়ায় প্রতিটি লাইভ গেম স্থিতিশীল স্ট্রিমিং প্রযুক্তি দ্বারা পরিচালিত হয়, যা গেমপ্লেকে পরিষ্কার এবং নিরবচ্ছিন্ন রাখে। পেশাদার ডিলাররা আত্মবিশ্বাস এবং প্রশান্ত মনোভাব নিয়ে প্রতিটি
              টেবিল পরিচালনা করেন, যা একটি বাস্তবসম্মত এবং সুসংগঠিত পরিবেশ সৃষ্টি করে। স্টুডিও পরিবেশটি একটি প্রকৃত ক্যাসিনোর অনুভূতি প্রদানের জন্য সতর্কতার সাথে সাজানো হয়েছে, যেখানে আলো, বিন্যাস এবং
              গেমের গতি আরাম ও মনোযোগের জন্য নিখুঁতভাবে ডিজাইন করা। এর ফলে খেলোয়াড়রা যা দেখেন তাতে আস্থা রাখতে পারেন এবং অবিচ্ছিন্ন, বাস্তব সময়ের গেমপ্লে উপভোগ করতে পারেন।
            </p>
            <h2 class="h2">বাংলাদেশের যে কোনো স্থান থেকে খেলুন</h2>
            <br />
            <p>
              কৃকিয়ায় আমাদের লাইভ ক্যাসিনো প্ল্যাটফর্মটি মোবাইল খেলার জন্য সম্পূর্ণরূপে অপ্টিমাইজ করা হয়েছে, যেখানে ঢাকা এবং চট্টগ্রামের মতো গুরুত্বপূর্ণ অঞ্চলে ৬৫% এর বেশি ব্যবহারকারী স্মার্টফোনের
              মাধ্যমে গেম অ্যাক্সেস করেন। অ্যান্ড্রয়েড, আইওএস এবং কম ব্যান্ডউইথ নেটওয়ার্কগুলির জন্য সমর্থনের সাথে, খেলোয়াড়রা এমনকি ৩জি বা অস্থির ৪জি সংযোগেও সহজ গেমপ্লে উপভোগ করতে পারেন। অ্যাপ বা
              মোবাইল ব্রাউজার ব্যবহার করলেও ইন্টারফেসটি সবসময় প্রতিক্রিয়াশীল এবং স্থিতিশীল থাকে।
            </p>
            <p>
              নিরবচ্ছিন্ন অ্যাক্সেস নিশ্চিত করতে, আমরা বিশ্বস্ত স্থানীয় পেমেন্ট পদ্ধতি যেমন বিকাশ, নগদ এবং রকেটের মাধ্যমে তহবিল জমা ও উত্তোলনের সুবিধা প্রদান করি, যা বাংলাদেশের যেকোনো স্থান থেকে
              খেলোয়াড়দের দ্রুত এবং নিরাপদ লেনদেন নিশ্চিত করে।
            </p>
            <h2 class="h2">বিশ্বস্ত, নিরাপদ এবং ন্যায্য লাইভ গেমিং</h2>
            <br />
            <p>
              কৃকিয়ার লাইভ ক্যাসিনো শুধুমাত্র লাইসেন্সপ্রাপ্ত সফটওয়্যার প্রদানকারীদের সাথে পরিচালিত হয়, যাদের গেমগুলি অভ্যন্তরীণ নিয়ন্ত্রণ দল এবং তৃতীয় পক্ষের নিরীক্ষকদের দ্বারা বাস্তব সময়ে
              পর্যবেক্ষিত হয়। প্রতিটি বিতরণ করা কার্ড, সম্পন্ন হওয়া স্পিন এবং নিক্ষিপ্ত পাশা সম্পূর্ণরূপে এনক্রিপ্টেড চ্যানেলের মাধ্যমে সুরক্ষিতভাবে স্ট্রিম করা হয়, যা ডেটার অখণ্ডতা এবং
              খেলোয়াড়দের সুরক্ষা নিশ্চিত করে।
            </p>
            <p>
              পর্দার আড়ালে, প্রতিটি লাইভ গেম সেশন একটি নিয়ন্ত্রিত সিস্টেমে চলে, যেখানে র্যান্ডম নাম্বার জেনারেটর (RNG) যাচাইকরণ সরঞ্জাম যুক্ত রয়েছে, এমনকি ডিলার-হোস্ট করা ফরম্যাটেও। এই গেমগুলি
              সরাসরি গেম স্টুডিও এবং প্রত্যয়িত ল্যাবের তত্ত্বাবধানে থাকে। এই বহুমাত্রিক কাঠামো আন্তর্জাতিক গেমিং মানদণ্ড পূরণ করে এবং বাংলাদেশের খেলোয়াড়দের জন্য একটি ন্যায্য এবং স্বচ্ছ পরিবেশ
              প্রদানের প্রতি কৃকিয়ার প্রতিশ্রুতি প্রতিফলিত করে।
            </p>
          </div>
          <a style="color: #959595;" @click="toggleContent">{{ expanded ? 'Read Less' : 'Read More' }}</a>
        </v-col>
      </v-col>
    </v-row>
    <v-row v-else-if="$route.name == routeName.CRASH">
      <v-col cols="12" class="pa-0" v-if="!this.$route.params.lang && this.checkDomain()">
        <v-col>
          <h1 class="h2">Discover Crash Games at Krikya</h1>
          <br />
          <p>
            Krikya’s Crash games provide a unique form of tension, they are timed and testing your observation, instinct. Instead of reading the cards or watching wheels spin, you have to watch an
            ascending value that can stall at any time. It feels like a simple design, but is packed with decisions.
          </p>
          <div :class="{ 'hidden-content': !expanded, show: expanded }">
            <h2 class="h2">Explore a Range of Crash Games</h2>
            <br />
            <h2 class="h2">Classic Multiplier Crash</h2>
            <br />
            <p>
              Games like Aviator, Spaceman™, High Flyer, and Big Bass Crash focus on the core idea of risk and timing. Each round builds on a rising multiplier, challenging players to make a single
              decision at just the right moment. The format stays clean and consistent, offering a familiar rhythm for those who prefer a direct style of play. These titles keep the attention on
              movement, reaction, and a clear visual path from start to finish.
            </p>
            <h2 class="h2">Themed Crash Games</h2>
            <br />
            <p>
              Crash Cricket, Cricketer X, Miner Donkey Rider and Firework Burst are characters and setting of Crash of the game. With each one comes a new domain, its animations and design are
              characteristic of said theme. Despite the mechanical core of timing and exits, the extra visual elements create players in another comfort zone. The same challenge in more organic,
              story-tending setting than you would get from these games.
            </p>
            <h2 class="h2">Power-Ups Crash Games</h2>
            <br />
            <p>
              Plinko Spin, Dice, Plinko, and Mines add new elements to the core idea of crash gameplay. Each title includes its own layer of interaction, giving players small but important decisions
              beyond just watching and reacting. The setup is still crisp and sharp, but there is some scope for the ending. Such games maintain the freshness of the format without ever losing sight
              of the genre clarity.
            </p>
            <h2 class="h2">Multiplayer Crash Battles</h2>
            <br />
            <p>
              In other words Aviator, Crash Duel X, Goal and Smash X brings the same round into a shared space where both (or more) players eventually should be on. Every person is moving in real time
              and every other player is seeing action based on exactly the same move. Here the environment fosters an undertone of rivalry without fundamentally altering how the game normally
              functions. A format that respects the crash format, but also adds some level of social technicolor.
            </p>
            <h2 class="h2">Predict, React & Win the Games</h2>
            <br />
            <p>
              Crash games have to be able to recognize patterns on the fly and act on them correctly. It takes place in realtime and every second is moving forward crafting its result. Though our
              research of the reaction time based decision-making showed that the savviest players perform best when steady as can be under pressure, sound judgement (and instinct) can go a long way.
              You see this at Krikya in what they are trying to achieve with the experience. The motion of each round ramps up tension, no room for error during the climb. Whether it's due to speed
              alone or the ability in anticipation before the line drops, recognizing an instant that is both simple and heavy.
            </p>
            <h2 class="h2">Built for Fast Play on Any Device</h2>
            <br />
            <p>
              Crash games of
              <router-link class="router_href" :to="{ name: ROUTE_NAME.HOME, params: { lang: $route.params.lang } }">Krikya</router-link>
              are played optimised for smooth experience on mobile, tablet & PC. Backend to ensure little lag in input so the game is well responsive despite high action. Adaptive layouts and
              lightweight visual components keep the system running even when screen size/resolution or network condition changes. With this,players would want to customize their completion with full
              confidence of a stable game environment from one device to another.
            </p>
            <h2 class="h2">Fairness Backed by Real-Time Systems</h2>
            <br />
            <p>
              Every crash game at Krikya is driven by the systems in real-time that record outcomes, transparency across all rounds. The underlying framework uses verifiable processes to handle
              timing, results, and payouts without manual input. This not only maintains fairness but also removes the possibility of bias or interference. For players, the result is a stable and open
              experience, where every action is recorded and reflected instantly, just as it happens.
            </p>
          </div>
          <a style="color: #959595;" @click="toggleContent">{{ expanded ? 'Read Less' : 'Read More' }}</a>
        </v-col>
      </v-col>
      <v-col cols="12" class="pa-0" v-if="this.$route.params.lang && this.checkDomain()">
        <v-col v-if="i18n.locale == 'en'">
          <h1 class="h2">Unique Crash Games on Krikya</h1>
          <br />

          <p>
            <router-link class="router_href" :to="{ name: ROUTE_NAME.HOME, params: { lang: $route.params.lang } }">Krikya</router-link>
            crash games offer a fresh type of gameplay based on timing, quick decisions, and focus. Instead of cards or spinning wheels, you watch a value rise and you must decide when to cash out
            before it suddenly drops. It’s a fast-paced yet simple format that puts control in your hands. The screen stays clean, the graphics are steady, and everything runs in real time, giving
            players a modern game experience without distractions.
          </p>
          <div :class="{ 'hidden-content': !expanded, show: expanded }">
            <h2 class="h2">Different Crash Games to Match Your Style</h2>
            <br />

            <h2 class="h2">Simple Multiplier Games</h2>
            <br />

            <p>
              Popular titles like Aviator, Spaceman™, High Flyer, and Big Bass Crash follow a basic but exciting idea: the longer you wait, the higher the potential win but the risk also grows. These
              are games for the kind of players that like easy mechanics and can key one thing per round. The only thing that remains is the layout, which lets you pick up and play easily.
            </p>

            <h2 class="h2">Crash Games with Themes</h2>
            <br />

            <p>
              Krikya also has games with good style and story too, like Crash Cricket, Cricketer X Miner Donkey Rider and Firework Burst. The games are the same in core mechanics but with animations
              and graphics that adapt to the theme of the game. The theme has a fun to watch vibe if you are watching a miner mine gold or fireworks explode in the sky but still doesn't deviate from
              the core gameplay in any way. It fits well for people who seek to be entertained and amused but still want something easy to understand.
            </p>

            <h2 class="h2">Crash Games with Extra Features</h2>
            <br />

            <p>
              Plinko Spin, Dice Plinko and Mines are variations of the classic crash layout that games. These formats allow players more control using tiny decisions that can have a consequence.
              Instead of only waiting to cash out, you get to interact more with the game while still keeping the core idea simple. The visuals stay clean, and the gameplay remains clear, but there’s
              added depth for those who enjoy being more involved. These games refresh the experience without making it too complex.
            </p>

            <h2 class="h2">Multiplayer Crash Modes</h2>
            <br />

            <p>
              Titles such as Aviator, Crash Duel X, Goal, and Smash X create a shared environment where many players join the same round. Everyone sees the same result in real time, but each person
              decides when to exit based on their own strategy. With this setup we bring a touch of competition but the main crash rules are still unaltered. Great for the social games types who would
              otherwise lose the quick focus, crash-game aspect of this type of playing.
            </p>

            <h2 class="h2">Watch Closely & Act Wisely to Win</h2>
            <br />

            <p>
              Crash games play on fast decisions and smart choices based on movement. It increases in real time and the way you process it will directly influence the outcome. Quick decision making
              studies indicate that players perform best when they remain calm, using instinct together with sound thinking. At Krikya, this idea is built into the design. Each round grows in
              intensity as the value climbs, and there's no chance to pause. Success often depends not just on reacting fast, but on knowing exactly when to make your move. Its one small moment that
              makes a big impact.
            </p>

            <h2 class="h2">Smooth Gameplay on Any Screen</h2>
            <br />

            <p>
              Krikya's crash games are designed to work effortlessly on all devices (phones, tablets and computers). Everything is built on this same system to eliminate lag, so what you see on screen
              should happen as a result of your actions. With flexible layouts and simple graphics, the games adjust to different screen sizes and internet speeds. Whether you're using a strong Wi-Fi
              signal or just a mobile network, the experience remains quick and stable, allowing you to play with confidence wherever you are.
            </p>

            <h2 class="h2">Real-Time Systems Ensure Fair Play</h2>
            <br />

            <p>
              All crash games at Krikya operate on real-time monitoring tools that check and confirm every result as it happens. These systems run automatic checks on timing, results, and payments,
              with no human control involved. This setup guarantees fairness, removing any chance of errors or bias. Each move is tracked and shown instantly, giving players full trust in the process
              and outcome of every round.
            </p>
          </div>
          <a style="color: #959595;" @click="toggleContent">{{ expanded ? 'Read Less' : 'Read More' }}</a>
        </v-col>
        <v-col v-if="i18n.locale == 'bd'">
          <h1 class="h2">কৃকিয়ায় ক্র্যাশ গেম আবিষ্কার করুন</h1>
          <br />
          <p>
            কৃকিয়ার ক্র্যাশ গেমগুলি সময়জ্ঞান, পর্যবেক্ষণ এবং প্রবৃত্তির উপর ভিত্তি করে একটি ভিন্ন ধরনের উত্তেজনা প্রদান করে। এখানে কার্ড বা চাকা ঘোরানোর পরিবর্তে, আপনি একটি ক্রমবর্ধমান মান দেখছেন,
            যা যে কোনো মুহূর্তে থেমে যেতে পারে। গেমের ডিজাইন সহজ হলেও সিদ্ধান্ত গ্রহণে এটি বহুস্তরীয়। সবকিছু বাস্তব সময়ে প্রদর্শিত হয়, পরিষ্কার ভিজ্যুয়াল এবং কোনো বিভ্রান্তি ছাড়া।
          </p>
          <p>এই ফরম্যাটটি আপনাকে মনোযোগ কেন্দ্রীভূত করতে, দ্রুত প্রতিক্রিয়া জানাতে এবং আপনার নিজস্ব ছন্দ খুঁজে নিতে সুযোগ দেয়, যা আধুনিক হলেও নিয়ন্ত্রিত পরিবেশের অনুভূতি প্রদান করে।</p>
          <div :class="{ 'hidden-content': !expanded, show: expanded }">
            <h2 class="h2">বিভিন্ন ধরনের ক্র্যাশ গেম অন্বেষণ করুন</h2>
            <br />
            <h2 class="h2">ক্লাসিক মাল্টিপ্লায়ার ক্র্যাশ</h2>
            <br />
            <p>
              Aviator, Spaceman™, High Flyer এবং Big Bass Crash-এর মতো গেমগুলি ঝুঁকি এবং সময়জ্ঞানকে কেন্দ্র করে গড়ে উঠেছে। প্রতিটি রাউন্ডে একটি ক্রমবর্ধমান মাল্টিপ্লায়ার থাকে, যেখানে খেলোয়াড়দের
              সঠিক মুহূর্তে একটি মাত্র সিদ্ধান্ত নিতে হয়। গেমের বিন্যাস পরিষ্কার এবং ধারাবাহিক থাকে, যা সরাসরি খেলার স্টাইল পছন্দ করা খেলোয়াড়দের জন্য পরিচিত ছন্দ প্রদান করে।
            </p>
            <p>এই গেমগুলি গতি, প্রতিক্রিয়া এবং শুরু থেকে শেষ পর্যন্ত একটি পরিষ্কার ভিজ্যুয়াল পথে মনোযোগ বজায় রাখে।</p>
            <h2 class="h2">থিমযুক্ত ক্র্যাশ গেম</h2>
            <br />
            <p>
              Crash Cricket, Cricketer X, Miner Donkey Rider এবং Firework Burst গেমগুলি চরিত্র এবং পরিবেশকে গেমপ্লেতে একীভূত করে। প্রতিটি গেম একটি অনন্য জগত উপস্থাপন করে, যেখানে এর থিমকে প্রতিফলিত করে
              এমন অ্যানিমেশন এবং ডিজাইন থাকে।
            </p>
            <p>
              যদিও গেমের মূল কাঠামো সময়জ্ঞান এবং প্রস্থানকেন্দ্রিক থাকে, যুক্ত ভিজ্যুয়াল বিবরণ খেলোয়াড়দের একটি ভিন্ন ধরনের পরিবেশ প্রদান করে। এই গেমগুলি একই চ্যালেঞ্জ উপস্থাপন করে, তবে একটি আরও
              আকর্ষণীয় এবং গল্পভিত্তিক সেটিংয়ে।
            </p>
            <h2 class="h2">পাওয়ার-আপস ক্র্যাশ গেমস</h2>
            <br />
            <p>
              Plinko Spin, Dice, Plinko এবং Mines গেমগুলি ক্র্যাশ গেমপ্লের মূল ধারণায় নতুন উপাদান যুক্ত করে। প্রতিটি গেম নিজস্ব ইন্টারঅ্যাকশনের স্তর প্রবর্তন করে, যা খেলোয়াড়দের শুধু দেখার এবং
              প্রতিক্রিয়া জানানোর বাইরে ছোট কিন্তু গুরুত্বপূর্ণ সিদ্ধান্ত নেওয়ার সুযোগ দেয়।
            </p>
            <p>গেমের বিন্যাস এখনও পরিষ্কার এবং কেন্দ্রীভূত থাকে, তবে ফলাফলে প্রভাব বিস্তারের আরও সুযোগ থাকে। এই গেমগুলি ঘরানার স্বচ্ছতা বজায় রেখে ফরম্যাটকে তাজা রাখে।</p>
            <h2 class="h2">মাল্টিপ্লেয়ার ক্র্যাশ ব্যাটলস</h2>
            <br />
            <p>
              Aviator, Crash Duel X, Goal এবং Smash X গেমগুলি একটি ভাগ করা স্থান উপস্থাপন করে, যেখানে খেলোয়াড়রা একই রাউন্ডে একসাথে অংশ নেন। গেমটি বাস্তব সময়ে ঘটে, যেখানে প্রতিটি খেলোয়াড় একই গতির
              উপর ভিত্তি করে তাদের নিজস্ব সিদ্ধান্ত নেন।
            </p>
            <p>এই সেটিংটি একটি সূক্ষ্ম প্রতিযোগিতামূলক অনুভূতি তৈরি করে, গেমের মূল কাঠামো পরিবর্তন না করেই। এটি ক্র্যাশ শৈলীর প্রতি বিশ্বস্ত থাকে, তবে এতে সামাজিক সম্পৃক্ততার একটি স্তর যুক্ত করে।</p>
            <h2 class="h2">প্রেডিক্ট করুন, প্রতিক্রিয়া জানান এবং জিতুন</h2>
            <br />
            <p>
              ক্র্যাশ গেমগুলি দ্রুত প্যাটার্ন শনাক্ত করা এবং সঠিকভাবে প্রতিক্রিয়া জানানোর দক্ষতার উপর নির্ভর করে। গেমের অ্যাকশন বাস্তব সময়ে চলতে থাকে, এবং প্রতিটি সেকেন্ড সরাসরি ফলাফলকে প্রভাবিত
              করে। প্রতিক্রিয়াভিত্তিক সিদ্ধান্ত গ্রহণের উপর গবেষণা দেখায় যে খেলোয়াড়রা চাপের মধ্যে স্থির থাকলে সেরা পারফর্ম করেন, যেখানে প্রবৃত্তি এবং সুচিন্তিত বিচার একসাথে কাজ করে।
            </p>
            <p>
              কৃকিয়ায় এই অভিজ্ঞতা সেই ভারসাম্যকে প্রতিফলিত করতে ডিজাইন করা হয়েছে। প্রতিটি রাউন্ড গতির মাধ্যমে উত্তেজনা তৈরি করে, যেখানে আরোহণ শুরু হওয়ার পর থেকে কোনো দ্বিধার সুযোগ নেই। জয়লাভ
              প্রায়ই শুধুমাত্র গতির উপর নির্ভর করে না, বরং সঠিক মুহূর্ত চিহ্নিত করার উপর নির্ভর করে, যখন লাইনটি পড়ে যাওয়ার আগেই পদক্ষেপ নেওয়া প্রয়োজন। এটি সহজ মনে হলেও এতে রয়েছে গুরুত্বপূর্ণ
              তাৎপর্য।
            </p>
            <h2 class="h2">যেকোনো ডিভাইসে দ্রুত খেলার জন্য নির্মিত</h2>
            <br />
            <p>
              কৃকিয়ার ক্র্যাশ গেমগুলি মোবাইল, ট্যাবলেট এবং ডেস্কটপ প্ল্যাটফর্ম জুড়ে ধারাবাহিক কর্মক্ষমতার জন্য অপ্টিমাইজ করা হয়েছে। ব্যাকএন্ড সিস্টেম ইনপুট বিলম্ব কমাতে ডিজাইন করা হয়েছে, যা উচ্চ
              কার্যকলাপের সময়েও গেমটিকে প্রতিক্রিয়াশীল রাখে।
            </p>
            <p>
              অ্যাডাপটিভ লেআউট এবং হালকা ভিজ্যুয়াল উপাদান ব্যবহার করে, সিস্টেমটি স্ক্রিনের আকার বা সংযোগের শক্তি নির্বিশেষে স্থিতিশীল গতি বজায় রাখে। এই পদ্ধতি খেলোয়াড়দের পূর্ণ আত্মবিশ্বাসে
              অংশগ্রহণের সুযোগ দেয়, জেনে যে তাদের গেমিং পরিবেশ যেকোনো ডিভাইসে নির্ভরযোগ্য থাকে।
            </p>
            <h2 class="h2">বাস্তব সময়ের সিস্টেম দ্বারা নিশ্চিত ন্যায্যতা</h2>
            <br />
            <p>
              কৃকিয়ার প্রতিটি ক্র্যাশ গেম বাস্তব সময়ের সিস্টেম দ্বারা সমর্থিত, যা প্রতিটি রাউন্ডের ফলাফলকে স্বচ্ছ রাখে। গেমের মূল কাঠামো যাচাইযোগ্য প্রক্রিয়া ব্যবহার করে, যা সময়, ফলাফল এবং পেআউট
              পরিচালনা করে, যেখানে কোনো ম্যানুয়াল হস্তক্ষেপের সুযোগ নেই।
            </p>
            <p>
              এটি শুধুমাত্র ন্যায্যতা নিশ্চিত করে না, বরং পক্ষপাত বা হস্তক্ষেপের সম্ভাবনাকেও দূর করে। খেলোয়াড়দের জন্য এটি একটি স্থিতিশীল এবং খোলামেলা অভিজ্ঞতা প্রদান করে, যেখানে প্রতিটি পদক্ষেপ
              তাৎক্ষণিকভাবে রেকর্ড এবং প্রতিফলিত হয়, যেমনটি বাস্তবে ঘটে।
            </p>
          </div>
          <a style="color: #959595;" @click="toggleContent">{{ expanded ? 'Read Less' : 'Read More' }}</a>
        </v-col>
      </v-col>
    </v-row>
    <v-row v-else-if="$route.name == routeName.CRICKET">
      <v-col cols="12" class="pa-0" v-if="!this.$route.params.lang && this.checkDomain()">
        <v-col>
          <h1 class="h2">Bet on Cricket with Krikya</h1>
          <br />
          <p>
            At
            <router-link class="router_href" :to="{ name: ROUTE_NAME.HOME, params: { lang: $route.params.lang } }">Krikya</router-link>
            , our cricket betting is timed to tick with the rhythm of this grand game. From the first delivery to the last over, the platform is reactive real-time providing updates that match the
            stage of play and not artificially slow or confounding. The UI is organized to ensure important information is visible, so the reader can read between the lines and make choices
            purposefully. You are not just guessing, you are guessing with context. For instance player form, pitch, and court dynamics and match momentum delivered in a comfort format. A system for
            speed, but with the awareness of the game and to have each decision count.
          </p>
          <div :class="{ 'hidden-content': !expanded, show: expanded }">
            <h2 class="h2">Types of Cricket Bets You Can Place</h2>
            <br />
            <h2 class="h2">Match Winner</h2>
            <br />
            <p>
              This is one of the simplest bets, but it still needs some planning. You choose which team will win the match. What makes it interesting is how conditions like pitch quality, weather, and
              player form can shift the likely outcome. At Krikya, we don’t just show you odds, we give you time to think through what matters before you place your bet. It’s not about guessing, it’s
              about making a call based on what you know.
            </p>
            <h2 class="h2">Top Batsman</h2>
            <br />
            <p>
              This option lets you pick the player who will score the most runs. Some players start strong, others build slowly across innings. You might look at recent matches or even past
              performances against the same opponent. The point is not to crunch hot shots, but be looking at trends. This type of bet works best for users who follow player form hard and not just the
              score.
            </p>
            <h2 class="h2">Total Runs</h2>
            <br />
            <p>
              Not betting on a team or player, this one is about runs to be made in the match or any part of that match. for runs. You can apply your understanding of team strategy, field setup, and
              match tempo. It’s a slower decision, often used by people who prefer to stay away from team bias and want to focus only on match dynamics.
            </p>
            <h2 class="h2">First Wicket Method</h2>
            <br />
            <p>
              This bet asks you to choose how the first wicket will fall. It could be caught, bowled, run out, or other legal outcomes. It’s a small moment in the game, but it tells a bigger story.
              Some players fall early to spin, others to pace. Knowing who’s opening and who’s bowling first helps make this a more thoughtful pick.
            </p>
            <h2 class="h2">Live Betting for Every Ball</h2>
            <br />
            <p>
              Krikya live betting is designed for people who pay attention to every ball. Odds change over time as the match goes on in real life. A boundary, wicket or even a boring over can alter
              the dynamics very fast. The updates are visible that our system handles them with no ifs, buts or ifs and then's for you because football moves so quick. Results are automatically
              updated once settlement of bet is done without waiting for long. You have more time to keep the eye on the ball, as opposed to long blank or unclear breaks. Everything is designed to
              keep pace with the match, from the first over to the final ball.
            </p>
            <h2 class="h2">Local and International Cricket Covered</h2>
            <br />
            <p>
              At Krikya, cricket betting is available across major leagues and international events, with special focus on what matters to players in Bangladesh. In the BPL, IPL, PSL and ICC T20
              tournaments all the important leagues are covered. Viacom18 says that as of 2024, the IPL crossed 620 million digital viewers and ICC Men’s Cricket World Cup reached a staggering over
              500m global TV viewers. These numbers reflect how much attention these events draw, not just worldwide, but in South Asia too. By covering both local leagues and world-stage matches, we
              make sure your betting options stay relevant to the games you actually follow.
            </p>
            <h1 class="h2">Smart Tools for Smarter Bets</h1>
            <br />
            <p>
              Krikya provides tools that help you make informed choices before and during a match. Pre-match stats and team data are provided on one platform only, giving a clearer insight into how
              players, squads have been performing in the past and not searching for results from various corners. Visual updates that track the highlights in real time during games so you can read
              those matches like a book. There is a nice enough track of win probability too, which gives you a sense the balance is changing just a bit with what has transpired thus far. These are
              not for telling you the outcome of those games, but more providing enough context that you can make the call yourself.
            </p>
          </div>
          <a style="color: #959595;" @click="toggleContent">{{ expanded ? 'Read Less' : 'Read More' }}</a>
        </v-col>
      </v-col>
      <v-col cols="12" class="pa-0" v-if="this.$route.params.lang && this.checkDomain()">
        <v-col v-if="i18n.locale == 'en'">
          <h1 class="h2">Place Cricket Bets with Krikya</h1>
          <br />
          <p>
            At
            <router-link class="router_href" :to="{ name: ROUTE_NAME.HOME, params: { lang: $route.params.lang } }">Krikya</router-link>
            , cricket betting is built to match the natural flow of the game. From the opening ball to the final delivery, the system updates instantly to show the current stage of play. There’s no
            confusion. Just up-to-the-minute clarity as the match goes live. The template is laid out so that the information sits right in front of you, to better follow what is happening and if need
            be, take informed decisions. All your decisions are not random guesses, but grounded fully in detail i.e performance of player, pitch conditions and the play. This setup allows you to stay
            focused and take part in the game with purpose.
          </p>
          <div :class="{ 'hidden-content': !expanded, show: expanded }">
            <h2 class="h2">Cricket Betting Options Available</h2>
            <br />
            <h2 class="h2">Winner of the Match</h2>
            <br />
            <p>
              This is one of the easiest ways to bet, but it still involves smart thinking. You simply pick which team you believe will win. Other than that, factors such as pitch conditions; player
              form and the weather could always influence the game. It is not only Krikya that gives you numbers, but everything apart from that. Simply so you can think about it before placing a bet
              we offer relevant analytics. Not guessing right away, but applying what you know for a better call.
            </p>
            <h2 class="h2">Most Runs by a Batter</h2>
            <br />
            <p>
              This type of bet allows you to choose the player you believe will score the highest number of runs. While some batters perform well right from the start, others build their innings
              gradually. It helps to look at recent performances and how certain players have done against specific teams. IThis does not mean following famous names, this bet is rather for people who
              watch form and action closely. Good for users who are seasoned pickers who like to choose from preference and vig instead of just popularity.
            </p>
            <h2 class="h2">Total Score in Runs</h2>
            <br />
            <p>
              Now the emphasis moves to Total runs scored in the place of. Either by one team or across the whole match. This option doesn’t require choosing a side or a specific player. Instead, it
              suits people who understand game tempo, field placements, and team tactics. It’s often used by those who want to stay neutral and concentrate on the broader flow of the match instead of
              supporting one side.
            </p>
            <h2 class="h2">Way the First Wicket Falls</h2>
            <br />
            <p>
              This bet involves predicting how the first player will get out. Whether caught, bowled, run out, or another legal method. Though it’s just one event, it often reveals more about the
              game’s early tone. Some openers struggle against fast bowlers; others have difficulty with spin. Understanding who is starting and opening the bowling with which players helps this type
              of bet to be a smarter, more strategic wager.
            </p>
            <h2 class="h2">Ball-by-Ball Live Betting</h2>
            <br />
            <p>
              Krikya live cricket betting is for the users who give cricket games with delivery. Odds change as the game unfolds in real time, odds adjust fast during the course of the game. Be it
              boundary, or wicket or just a dull over. The changes are updated live so that you aren't always playing behind the ball. A confirmation of the bet placed and settled reflects the result
              right away. Your main focus is on the match, not on loading screens due to the smooth process. From the opening over to the final delivery, the platform keeps pace with every moment of
              play.
            </p>
            <h2 class="h2">Coverage of Local and Global Cricket</h2>
            <br />
            <p>
              Krikya offers cricket betting options across all major tournaments, both domestic and international. This includes leagues like the BPL, IPL, PSL, and top-tier ICC events. In 2024
              Viacom18 reported that IPL had reached over 620 million digital views, ICC Men's World Cup had over 500 million viewers worldwide on TV. These stats tell us that cricket is very much
              followed, especially in South Asia. Krikya includes both regional Must Watch fixtures and Global ones so that your betting always corresponds to relevant games for you.
            </p>
            <h2 class="h2">Helpful Features for Better Decisions</h2>
            <br />
            <p>
              Krikya also has helpful tools before and during each match to aid better decision making. Pre-game data consist of player form stats and team performance stats from one or two-touching
              all together for immediate screening. While the live play updates with images in live action, in runs and extras, wickets and boundaries. You can also encounter win likelihood graphs
              that demonstrate the game is unfolding in real time based on pick up. These do not tell you what is going to happen. These give context, so you can choose with purpose and certainty.
            </p>
          </div>
          <a style="color: #959595;" @click="toggleContent">{{ expanded ? 'Read Less' : 'Read More' }}</a>
        </v-col>
        <v-col v-if="i18n.locale == 'bd'">
          <h1 class="h2">কৃকিয়ায় ক্রিকেটে বাজি ধরুন</h1>
          <br />
          <p>
            কৃকিয়ায় ক্রিকেট বাজি খেলার অভিজ্ঞতা খেলার স্বাভাবিক ছন্দের সাথে সুর মিলিয়ে চলে। প্রথম ডেলিভারি থেকে শেষ ওভার পর্যন্ত, প্ল্যাটফর্মটি বাস্তব সময়ে ম্যাচের সর্বশেষ পরিস্থিতি প্রতিফলিত করে,
            যা বিলম্ব বা বিভ্রান্তি ছাড়াই আপডেট প্রদান করে।
          </p>
          <p>
            ইন্টারফেসটি অত্যাবশ্যকীয় তথ্যকে স্পষ্টভাবে দৃশ্যমান রাখে, যা আপনাকে ম্যাচের গতি বুঝতে এবং সুচিন্তিত সিদ্ধান্ত নিতে সহায়তা করে। অনুমানের উপর নির্ভর করার পরিবর্তে, আপনি প্রাসঙ্গিক
            বিশ্লেষণের সাথে কাজ করেন, যেমন খেলোয়াড়ের ফর্ম, পিচের আচরণ এবং ম্যাচের গতি। সবকিছু একটি সুশৃঙ্খল এবং ব্যবহারযোগ্য বিন্যাসে উপস্থাপিত হয়। এটি কেবল দ্রুত ক্রিয়ার জন্য নয়, বরং খেলার
            প্রবাহকে ঘনিষ্ঠভাবে অনুসরণ করে প্রতিটি সিদ্ধান্তকে অর্থবহ করার জন্য ডিজাইন করা হয়েছে।
          </p>
          <div :class="{ 'hidden-content': !expanded, show: expanded }">
            <h2 class="h2">কৃকিয়ায় ক্রিকেটে যে ধরনের বাজি ধরতে পারবেন</h2>
            <br />
            <h2 class="h2">ম্যাচ বিজয়ী</h2>
            <br />
            <p>
              এটি বাজি ধরার সবচেয়ে সরাসরি উপায়গুলির মধ্যে একটি, তবে এটি এখনও চিন্তাশীল বিশ্লেষণ প্রয়োজন। এখানে আপনাকে নির্ধারণ করতে হয় কোন দল ম্যাচটি জিতবে। তবে মজার বিষয় হল, পিচের গুণমান,
              আবহাওয়া এবং খেলোয়াড়দের ফর্মের মতো শর্তগুলি ফলাফলকে প্রভাবিত করতে পারে।
            </p>
            <p>কৃকিয়ায় আমরা কেবল আপনাকে অডস প্রদর্শন করি না, আমরা আপনাকে গুরুত্বপূর্ণ বিষয়গুলি বিবেচনা করার সময় দিই, যাতে আপনার বাজি অনুমানের উপর নয়, বরং আপনার বিশ্লেষণের উপর ভিত্তি করে থাকে।</p>
            <h2 class="h2">শীর্ষ ব্যাটসম্যান</h2>
            <br />
            <p>
              এই বিকল্পটি আপনাকে সেই খেলোয়াড়টি নির্বাচন করতে দেয় যিনি সর্বাধিক রান করবেন। কিছু খেলোয়াড় শক্তিশালী শুরু করেন, অন্যরা ইনিংস জুড়ে ধীরে ধীরে গড়ে ওঠেন। আপনি সাম্প্রতিক ম্যাচ, বা এমনকি
              একই প্রতিপক্ষের বিপক্ষে অতীতের পারফরম্যান্সও বিশ্লেষণ করতে পারেন।
            </p>
            <p>
              এই ধরনের বাজি তাদের জন্য উপযুক্ত, যারা ব্যক্তিগত ফর্ম ঘনিষ্ঠভাবে পর্যবেক্ষণ করেন এবং শুধুমাত্র স্কোরবোর্ডের বাইরে বিশ্লেষণ করেন। বড় নামের পেছনে ছুটতে নয়, বরং ধারাবাহিকতা এবং
              পারফরম্যান্সের প্যাটার্ন চিহ্নিত করাই এখানে মূল লক্ষ্য।
            </p>
            <h2 class="h2">মোট রান</h2>
            <br />
            <p>
              দল বা খেলোয়াড়ের উপর বাজি ধরার পরিবর্তে, এই ধরনের বাজি ম্যাচের মোট রান বা এর একটি নির্দিষ্ট অংশের রানকে কেন্দ্র করে। এখানে আপনি দলীয় কৌশল, ফিল্ড সেটআপ এবং ম্যাচের গতি সম্পর্কে আপনার
              জ্ঞান প্রয়োগ করতে পারেন। এটি একটি তুলনামূলকভাবে ধীর সিদ্ধান্ত, যা সাধারণত তাদের দ্বারা ব্যবহৃত হয় যারা দলগত পক্ষপাত এড়িয়ে শুধুমাত্র ম্যাচের গতিশীলতার উপর মনোযোগ দিতে চান।
            </p>
            <h2 class="h2">প্রথম উইকেটের ধরন</h2>
            <br />
            <p>
              এই বাজি আপনাকে অনুমান করতে বলে প্রথম উইকেটটি কীভাবে পড়বে। এটি হতে পারে ক্যাচ আউট, বোল্ড, রান আউট, বা অন্য কোনো বৈধ পদ্ধতিতে। এটি খেলার একটি ছোট মুহূর্ত, কিন্তু এর মাধ্যমে একটি বড় গল্প
              উঠে আসে। কিছু ব্যাটসম্যান স্পিনের বিপক্ষে দ্রুত আউট হন, অন্যরা পেস বোলিংয়ের কাছে পরাস্ত হন।
            </p>
            <p>জানতে হবে কারা ওপেনিং করবে এবং কারা প্রথমে বল করবে – এই জ্ঞান আপনার সিদ্ধান্তকে আরও সুচিন্তিত করে তোলে।</p>
            <h2 class="h2">প্রতি বলের জন্য লাইভ বাজি</h2>
            <br />
            <p>
              কৃকিয়ায় লাইভ বাজি তাদের জন্য যারা প্রতিটি ডেলিভারি ঘনিষ্ঠভাবে অনুসরণ করেন। ম্যাচের প্রতিটি মুহূর্তে ঘটনাগুলোর উপর ভিত্তি করে অডস পরিবর্তিত হয়। একটি বাউন্ডারি, একটি উইকেট, এমনকি একটি
              নিরব ওভারও পরিস্থিতি দ্রুত পরিবর্তন করতে পারে।
            </p>
            <p>
              আমাদের সিস্টেমটি এই আপডেটগুলি তাৎক্ষণিকভাবে দৃশ্যমান রাখে, যাতে গেমের দ্রুত গতিতে আপনি পিছিয়ে না পড়েন। আপনার বাজি নিষ্পত্তি হওয়ার পর, ফলাফল দ্রুত প্রক্রিয়াকৃত হয়, অপ্রয়োজনীয়
              অপেক্ষা ছাড়াই।
            </p>
            <p>
              এটি আপনাকে দীর্ঘ বিরতি বা অস্পষ্ট ফলাফলের সাথে সময় নষ্ট না করে খেলার উপর মনোযোগ ধরে রাখতে সাহায্য করে। প্রথম ওভার থেকে শেষ বল পর্যন্ত, সবকিছু খেলার গতির সাথে সঙ্গতিপূর্ণভাবে ডিজাইন করা
              হয়েছে।
            </p>
            <h2 class="h2">স্থানীয় এবং আন্তর্জাতিক ক্রিকেট কাভারেজ</h2>
            <br />
            <p>
              কৃকিয়ায় ক্রিকেট বাজি বাংলাদেশের খেলোয়াড়দের আগ্রহের কেন্দ্রবিন্দুতে থাকা প্রধান লিগ এবং আন্তর্জাতিক ইভেন্ট জুড়ে উপলব্ধ। বিপিএল (বাংলাদেশ প্রিমিয়ার লিগ), আইপিএল (ইন্ডিয়ান প্রিমিয়ার
              লিগ), পিএসএল (পাকিস্তান সুপার লিগ) থেকে শুরু করে আইসিসি টুর্নামেন্ট পর্যন্ত সব গুরুত্বপূর্ণ প্রতিযোগিতা এখানে অন্তর্ভুক্ত।
            </p>
            <p>
              ২০২৪ সালে, ভায়াকম১৮-এর তথ্য অনুযায়ী, আইপিএল ৬২০ মিলিয়ন ডিজিটাল দর্শকের রেকর্ড গড়েছিল, যখন আইসিসি মেনস ক্রিকেট বিশ্বকাপ বিশ্বব্যাপী ৫০০ মিলিয়নেরও বেশি টিভি দর্শককে আকর্ষণ করেছিল। এই
              পরিসংখ্যানগুলি শুধুমাত্র বিশ্বব্যাপী নয়, দক্ষিণ এশিয়াতেও ক্রিকেটের জনপ্রিয়তা প্রতিফলিত করে।
            </p>
            <p>স্থানীয় লিগ এবং বিশ্বমঞ্চের ম্যাচ উভয়ই কভার করে, আমরা নিশ্চিত করি যে আপনার বাজির বিকল্পগুলি সেই গেমগুলির সাথে প্রাসঙ্গিক থাকে যা আপনি আসলে অনুসরণ করেন।</p>
            <h2 class="h2">স্মার্ট টুলসের সাহায্যে আরও স্মার্ট বাজি</h2>
            <br />
            <p>
              কৃকিয়া এমন টুলস সরবরাহ করে যা আপনাকে ম্যাচের আগে এবং চলাকালীন জ্ঞানপূর্ণ সিদ্ধান্ত নিতে সহায়তা করে। প্রি-ম্যাচ স্ট্যাটস এবং দলীয় তথ্য আপনাকে খেলোয়াড় এবং স্কোয়াডের সাম্প্রতিক
              পারফরম্যান্স সম্পর্কে পরিষ্কার ধারণা দেয়, অন্য প্ল্যাটফর্মে খোঁজার প্রয়োজন ছাড়াই।
            </p>
            <p>
              লাইভ গেম চলাকালীন, আপনি ভিজ্যুয়াল আপডেটের মাধ্যমে গুরুত্বপূর্ণ মুহূর্তগুলি অনুসরণ করতে পারেন, যা আপনাকে ম্যাচের গতি বুঝতে সহায়তা করে। এছাড়াও, উইন প্রোবাবিলিটি চার্ট উপলব্ধ রয়েছে, যা
              বর্তমান খেলার উপর ভিত্তি করে ভারসাম্য কীভাবে পরিবর্তিত হচ্ছে তার একটি মৌলিক ধারণা দেয়।
            </p>
            <p>এই টুলগুলি আপনার জন্য ফলাফল পূর্বাভাস দেওয়ার জন্য নয়, বরং আপনাকে পর্যাপ্ত প্রসঙ্গ প্রদান করে যাতে আপনি নিজেই সঠিক সিদ্ধান্ত নিতে পারেন।</p>
          </div>
          <a style="color: #959595;" @click="toggleContent">{{ expanded ? 'Read Less' : 'Read More' }}</a>
        </v-col>
      </v-col>
    </v-row>
    <v-row v-else-if="$route.name == routeName.FISHING">
      <v-col cols="12" class="pa-0" v-if="!this.$route.params.lang && this.checkDomain()">
        <v-col>
          <h1 class="h2">Enjoy Fishing Games at Krikya</h1>
          <br />
          <p>
            Fishing games on
            <router-link class="router_href" :to="{ name: ROUTE_NAME.HOME, params: { lang: $route.params.lang } }">Krikya</router-link>
            offer a different kind of experience from traditional casino or betting games. Instead of relying on cards or scorelines, these games ask for timing, focus, and hand-eye coordination. The
            setup is simple: you target and shoot at moving fish, each carrying a different value. Although the idea is to play like an arcade, odds and payouts are intended for cash players. Users in
            general like this form of the best punting pool because it is more interactive and less of a crap shoot. Also, you can stop and start as quickly as possible in case the playing sessions
            are short.
          </p>
          <div :class="{ 'hidden-content': !expanded, show: expanded }">
            <h2 class="h2">Different Types of Fishing Games Available</h2>
            <br />
            <h2 class="h2">Classic Fish Shooting</h2>
            <br />
            <p>
              These games are very basic. You shoot, aim and score based on what fish you reel in. While the pace can be fairly fast, the rules are always square. Crazy Hunter, Crazy Hunter 2 Happy
              Fishing Mega Fishing Bombing Fishing Boom Legend and title formats in a word. Most of the ones I have are very simple to grasp after one or two rounds. Designed for people that are
              really good at timing and accuracy, not RNG tenants. The more you play and learn the patterns, it gives you an upper hand which is not found in games based on luck.
            </p>
            <h2 class="h2">Multiplayer Fishing Rooms</h2>
            <br />
            <p>
              These fishing games place you in a shared room with other players, where everyone is aiming for the same targets in real time. Instead of playing alone, you're reacting to what others
              are doing while also trying to build your own score. Games like All-star Fishing, Royal Fishing, Fortune King, and the updated version of Crazy Hunter 2 make this mode more active. This
              format often appeals to those who like to stay alert and work around changing situations. Each match feels different, depending on who you’re playing with and how fast the action moves.
            </p>
            <h2 class="h2">Jackpot Fishing Games</h2>
            <br />
            <p>
              Some games have jackpot elements for fishing, such that rare catches are granted much bigger prizes. It's not purely on speed and score, but pixel hunting and connecting the dots with
              rarity targets. The Ocean King Jackpot, Jackpot fishing, Fishing God and Dragon Fortune are all these kinds of titles. These games, the higher risk and reward is what players target
              initially and still require skill/determination. While the jackpot features are integrated with the game itself, which means in the same play environment.
            </p>
            <h2 class="h2">Themed Fishing Adventures</h2>
            <br />
            <p>
              These games add visual and story elements that give each session a different feel. Instead of a plain underwater setting, you might find yourself in a world with dragons, ancient
              creatures, or fantasy backdrops. Games like Dinosaur Tycoon, Dinosaur Tycoon II, Dragon Fortune, and Fishing God are built around this kind of design. Not just by the way to fish these
              titles provide a fresh dimension to interact and explore while playing. The additional detail is nice for players who want a little more diversity in how each round looks and sounds.
            </p>
            <h2 class="h2">Skill-Based Action with Instant Rewards</h2>
            <br />
            <p>
              In these games winning requires aiming and shooting with exactness. Luck will not win the decision for you; instead, it will be the step in your hands to command rewards. A shot that
              lands is worth some points, or triggers a multiplier or two or activates power-ups for an improved you. This brings excitement of real time, where you can actually watch your action
              causing some effect on the game. These players are here to believe they call the shots with their skills as they progress, opening higher reward lanes on-the-spot.
            </p>
            <h1 class="h2">Localized Gaming Experience</h1>
            <br />
            <p>
              In Krikya, we try to offer a gaming experience for people who play in bangladesh. This required game tuning for best low-latency play, so that your actions are seen quickly with no lag.
              No matter if it's mobile or desktop, the controls are well thought out for a great experience on both the app fronts. Your connection and controls have no reason to cause problems when
              playing makes it only about the game style for all that better experience!
            </p>
            <h2 class="h2">Fair Play and Certified Game Mechanics</h2>
            <br />
            <p>
              At Krikya, we take fair play seriously and as such you can trust that we work only with reputable game providers and maintain the transparency of their algorithms. All of our games are
              developed with a regulated random number generator (RNG) covered by ongoing testing to ensure payment that we promise. At the end of a study performed by eCOGRA (an impartial testing
              institute) certified RNGs are known to mostly contribute to fairness and reliability for players. That way every event in our games happens according to statistics, no joke or artificial
              bias so you can be sure to have an honest and stable gaming experience.
            </p>
          </div>
          <a style="color: #959595;" @click="toggleContent">{{ expanded ? 'Read Less' : 'Read More' }}</a>
        </v-col>
      </v-col>
      <v-col cols="12" class="pa-0" v-if="this.$route.params.lang && this.checkDomain()">
        <v-col v-if="i18n.locale == 'en'">
          <h1 class="h2">Exciting Fishing Games on Krikya</h1>
          <br />

          <p>
            <router-link class="router_href" :to="{ name: ROUTE_NAME.HOME, params: { lang: $route.params.lang } }">Krikya</router-link>
            Fishing games offer an escape from the norm of conventional casino / betting options. They are gameplay that is skill based, all about timing, concentration and precision hand-eye
            coordination on part of a player. It is simple: Players shoot different moving fish which have values in them, one by one. The mechanics may mirror an arcade game but the gameplay and the
            rewards are kept simple for real-money players. It is a popular format for the users. It makes them want to actively participate rather than just passively. And, of course, short duration
            gameplay lets you start and stop without a plan for long session.Explore Various
          </p>
          <div :class="{ 'hidden-content': !expanded, show: expanded }">
            <h2 class="h2">Fishing Game Options</h2>
            <br />

            <h2 class="h2">Traditional Fish Shooting Games</h2>
            <br />

            <p>
              The fishing games stick to a simple formula. Play and score fish as captured, its a target shooter for the fishes. In the gameplay it is usually fast-paced and very common, such as Crazy
              Hunter, Crazy Hunter 2, Happy Fishing, Mega Fishing, Bombing Fishing and Boom Legend. For people that like your timings and precise work rather than just sticks for the delta. Over time,
              these games cause players to notice a lot of the same events over and over which creates a perceived agency that otherwise would not be present in a totally random game.
            </p>

            <h2 class="h2">Multiplayer Fishing Challenges</h2>
            <br />

            <p>
              Multiplayer fishing games on Krikya elevate the level of enthusiasm by allowing players to battle with each other in real-time rather than against the system. Solo part playing here
              because you need to keep your opponents in mind while also aiming for the highest score. Popular games of this genre are All-star Fishing, Royal Fishing, Fortune King, and the next level
              Crazy Hunter 2 Last Updated 01/28/2019. This is a format that works well with players who love fast paced, strategy of one upmanship requiring response time in the blink of an eye. A new
              game in every match for different skill levels and play styles will make no two rounds be experienced alike.
            </p>

            <h2 class="h2">High-Stakes Jackpot Fishing Games</h2>
            <br />

            <p>
              Jackpot fishing games spice things up with an extra element of the unpredictable, Greek lottery-like huge win potential through ultra rare catches. In these games winning is less about
              being quick or high on score and not only about spotting but it is also panning for that super specific high value fish. Such as Ocean King Jackpot, Jackpot Fishing, Fishing god and even
              Duang fortune class of these popular titles. It brings in players who are genuinely looking to take the larger risk in hopes of reaping bigger rewards. The gameplay is very much tied to
              skill and the more strategic decision making despite all the jackpots. Jackpot features in the main game provide an integrated and seamless, cool-gaming-uninterrupted experience.
            </p>

            <h2 class="h2">Themed Shoot Fishing</h2>
            <br />

            <p>
              Themed fishing Krikya games Entertain players with more fun and a visually appealing rather than that conventional underwater base of standard game. Instead of just aiming at regular
              fish, players can explore realms filled with mythical creatures, ancient beasts, or magical landscapes. Popular titles like Dinosaur Tycoon, Dinosaur Tycoon II, Dragon Fortune, and
              Fishing God bring these imaginative environments to life. These games go beyond the simple objective of catching fish, allowing players to immerse themselves in diverse, story-driven
              backgrounds. This further visual and otherwise immersive layering is what draws users that enjoy uniqueness in appearance of atmosphere for every gaming session.
            </p>

            <h2 class="h2">Master Skill-Based Action for Instant Rewards</h2>
            <br />

            <p>
              The krikya skill based fishing game centered on player ability makes every cast a game of patience and care. Here, the games decide your success with how narrowly you can direct aim and
              shoot rather than luck alone. The players are rewarded in points, initiated multipliers or power ups directly by their performance. The fact that these are live games means you can
              immediately see what you did and how it affected, increasing excitement. If you're among the ones who love to brush up on your skills at every gameplay, then these titles are for you to
              grab quick rewards and score higher right just above your spot.
            </p>

            <h2 class="h2">Customized Gaming Experience Designed for Bangladesh</h2>
            <br />

            <p>
              We at Krikya are striving hard to provide a gaming experience which is only for the players of Bangladesh. We built for low-latency gameplay where your actions equal instant, and do not
              experience noticeable time lag on our platform. For any device (mobile or desktop) that you are accessing our games from, the controls are very responsive and give a fluid and natural
              feel on all platforms as well. This helps us to keep stable connection and easy interface for better gameplay without having any technical term distracted. You are playing from any
              servers no matter, you can be sure gaming will be constant and pleasurable.
            </p>

            <h2 class="h2">Guaranteed Fair Play with Certified Game Systems at Krikya</h2>
            <br />

            <p>
              Fair play is ensured by working with trusted game providers at Krikya and we make our game mechanics 100% transparent. We use regulated RNG (random number generator) systems which are
              rigorously examined and audited for fairness on an ongoing basis to determine our platform outcomes. An eCOGRA-accredited testing laboratory for the RNG systems assure conformance to
              this standard, this is an expert body when it comes to gaming fairness and security. This certification assures players that every single game result is determined by nobody else - Just
              pure luck! Fair Play is carved in stone from the bottom of the tower so you know that everything on Krikya revolves around your gaming experience.
            </p>
          </div>
          <a style="color: #959595;" @click="toggleContent">{{ expanded ? 'Read Less' : 'Read More' }}</a>
        </v-col>
        <v-col v-if="i18n.locale == 'bd'">
          <h1 class="h2">ক্রিকিয়াতে ফিশিং গেমস উপভোগ করুন</h1>
          <br />
          <p>
            ক্রিকিয়ার ফিশিং গেমসগুলি ঐতিহ্যবাহী ক্যাসিনো বা বেটিং গেম থেকে আলাদা ধরনের অভিজ্ঞতা দেয়। এখানে কার্ড বা স্কোরলাইন-এর ওপর নির্ভর করার পরিবর্তে, সময়জ্ঞান, মনোযোগ এবং চোখ-হাতের সমন্বয়
            প্রয়োজন হয়। গেমের নিয়ম সহজ: আপনি চলমান মাছ লক্ষ্য করে গুলি করবেন, প্রতিটি মাছের পয়েন্ট ভিন্ন। যদিও এই গেমগুলি আর্কেড গেমের মতো মনে হয়, তবে এগুলোর পেআউট এবং গেমপ্লে বাস্তব অর্থে খেলার
            জন্য তৈরি।
          </p>
          <p>
            অনেক ব্যবহারকারী এই গেমগুলি উপভোগ করেন কারণ এগুলি বেশি সক্রিয় এবং কম পরিমাণে ভাগ্যের ওপর নির্ভরশীল। আপনি অল্প সময়ের জন্যও খেলতে পারেন, ফলে দীর্ঘ সময় ধরে খেলতে বাধ্য হওয়ার প্রয়োজন হয়
            না।
          </p>
          <div :class="{ 'hidden-content': !expanded, show: expanded }">
            <h2 class="h2">বিভিন্ন ধরনের ফিশিং গেমস</h2>
            <br />
            <h2 class="h2">ক্লাসিক ফিশ শ্যুটিং</h2>
            <br />
            <p>এই ধরনের গেম খুবই সহজ। আপনি লক্ষ্য করেন, গুলি করেন, এবং ধরা মাছ অনুযায়ী পয়েন্ট অর্জন করেন। গেমের গতি দ্রুত হতে পারে, কিন্তু নিয়ম সবসময় স্পষ্ট থাকে।</p>
            <p>Crazy Hunter, Crazy Hunter 2, Happy Fishing, Mega Fishing, Bombing Fishing, এবং Boom Legend এই ধরনের গেমের উদাহরণ। এক বা দুই রাউন্ড খেলার পরেই বোঝা যায় কীভাবে খেলতে হয়।</p>
            <p>
              যারা টাইমিং এবং নিখুঁত নিশানায় বিশ্বাস করেন, তাদের জন্য এগুলো উপযুক্ত। আপনি যত বেশি খেলবেন, মাছের চলাফেরার ধরণ তত ভালোভাবে বুঝবেন—যা আপনাকে আরও নিয়ন্ত্রণ দেয়, যা ভাগ্যনির্ভর গেমে থাকে
              না।
            </p>
            <h2 class="h2">মাল্টিপ্লেয়ার ফিশিং রুম</h2>
            <br />
            <p>
              এই গেমগুলোতে আপনি অন্য খেলোয়াড়দের সঙ্গে একটি শেয়ারড রুমে থাকেন, যেখানে সবাই একই মাছের পেছনে ছুটছেন রিয়েল-টাইমে। এখানে একা খেলার পরিবর্তে, আপনাকে অন্যদের পদক্ষেপ লক্ষ্য করে নিজের
              স্কোর তৈরি করতে হয়।
            </p>
            <p>All-star Fishing, Royal Fishing, Fortune King, এবং আপডেটেড Crazy Hunter 2 এই ধরনের গেমে অন্তর্ভুক্ত।</p>
            <p>
              এই ফরম্যাট তাদের জন্য আকর্ষণীয় যারা সবসময় সতর্ক থাকতে এবং পরিবর্তনশীল পরিস্থিতিতে দ্রুত প্রতিক্রিয়া দিতে ভালোবাসেন। প্রতিটি ম্যাচের অভিজ্ঞতা ভিন্ন হয়, আপনি কার সঙ্গে খেলছেন এবং
              অ্যাকশনের গতি কেমন—তার ওপর নির্ভর করে।
            </p>
            <h2 class="h2">জ্যাকপট ফিশিং গেমস</h2>
            <br />
            <p>
              কিছু ফিশিং গেমে জ্যাকপট উপাদান যুক্ত থাকে, যেখানে বিরল মাছ ধরার মাধ্যমে বড় পুরস্কার জেতা যায়। এসব গেম শুধুমাত্র গতি বা স্কোরের ওপর নির্ভর করে না, বরং বিরল টার্গেট শনাক্ত করে সঠিকভাবে
              আঘাত করার দক্ষতার ওপর নির্ভরশীল।
            </p>
            <p>Ocean King Jackpot, Jackpot Fishing, Fishing God, এবং Dragon Fortune এই ক্যাটাগরিতে পড়ে।</p>
            <p>
              এই গেমগুলোতে খেলোয়াড়রা সাধারণত বেশি ঝুঁকি ও বেশি পুরস্কারের আশায় আকৃষ্ট হন। তবে জ্যাকপট বৈশিষ্ট্য গেমের অংশ হিসেবেই থাকে—আলাদা নয়—ফলে পুরো অভিজ্ঞতা একই গেমপ্লে-র মধ্যেই উপভোগ করা
              যায়।
            </p>
            <h2 class="h2">থিমযুক্ত ফিশিং অ্যাডভেঞ্চার</h2>
            <br />
            <p>
              এই ধরনের গেমে ভিজ্যুয়াল এবং কাহিনির উপাদান যোগ করা হয়, যা প্রতিটি গেম সেশনকে আলাদা অনুভূতি দেয়। সাধারণ জলের নিচের পরিবেশের পরিবর্তে, আপনি ড্রাগন, প্রাচীন জীব বা কাল্পনিক জগতে নিজেকে
              আবিষ্কার করতে পারেন।
            </p>
            <p>Dinosaur Tycoon, Dinosaur Tycoon II, Dragon Fortune, এবং Fishing God এই ধরণের গেমের উদাহরণ।</p>
            <p>
              এই গেমগুলো শুধু মাছ ধরার জন্য নয়, বরং নতুন নতুন দুনিয়া এক্সপ্লোর করারও সুযোগ দেয়। এই বাড়তি ভিজ্যুয়াল ও গল্পের গভীরতা এমন খেলোয়াড়দের জন্য আকর্ষণীয়, যারা প্রতিটি রাউন্ডে বৈচিত্র্য
              খোঁজেন—দৃশ্য ও শব্দে।
            </p>
            <h2 class="h2">স্কিল-ভিত্তিক অ্যাকশন ও তাৎক্ষণিক পুরস্কার</h2>
            <br />
            <p>এই ধরনের গেমে সফলতা নির্ভর করে আপনার নিশানা ও গুলি করার নিখুঁত দক্ষতার ওপর। এখানে ভাগ্যের অপেক্ষায় না থেকে, আপনার দক্ষতা-ই পুরস্কার পাওয়ার মূল চাবিকাঠি।</p>
            <p>
              প্রতিটি সঠিক শট আপনাকে পয়েন্ট দিতে পারে, মাল্টিপ্লায়ার অ্যাকটিভ করতে পারে, কিংবা এমন পাওয়ার-আপ চালু করতে পারে যা খেলাকে আরও শক্তিশালী করে তোলে। রিয়েল-টাইম প্রতিক্রিয়া গেমটিকে আরও
              উত্তেজনাপূর্ণ করে তোলে, কারণ আপনি সঙ্গে সঙ্গে দেখতে পান আপনার কাজের প্রভাব কী হয়েছে।
            </p>
            <p>এই গেমগুলো তাদের জন্য তৈরি যারা নিজেদের নিয়ন্ত্রণে রেখে খেলতে চান এবং দক্ষতার মাধ্যমে তাৎক্ষণিকভাবে বড় পুরস্কারের সুযোগ তৈরি করতে চান।</p>
            <h2 class="h2">লোকালাইজড গেমিং অভিজ্ঞতা</h2>
            <br />
            <p>
              ক্রিকিয়া বাংলাদেশের খেলোয়াড়দের জন্য উপযোগী করে তৈরি করা একটি গেমিং অভিজ্ঞতা প্রদান করতে প্রতিশ্রুতিবদ্ধ। এর মধ্যে রয়েছে লো-ল্যাটেন্সি প্লে-র জন্য গেম অপটিমাইজ করা, যাতে আপনার প্রতিটি
              অ্যাকশন দেরি ছাড়াই স্ক্রিনে প্রতিফলিত হয়।
            </p>
            <p>মোবাইল বা ডেস্কটপ—যেকোনো ডিভাইসেই খেলুন না কেন, কন্ট্রোলগুলো দ্রুত প্রতিক্রিয়াশীলভাবে ডিজাইন করা হয়েছে, যাতে আপনি দুই প্ল্যাটফর্মেই একইভাবে স্মুথ ও সাবলীল অভিজ্ঞতা পান।</p>
            <p>
              আমরা নিশ্চিত করি, আপনি যেখানেই খেলুন না কেন, একটি স্থিতিশীল সংযোগ ও সহজবোধ্য নিয়ন্ত্রণ পাবেন, যাতে গেমিংয়ের সময় কোনো টেকনিক্যাল সমস্যায় পড়তে না হয় এবং আপনি শুধু খেলায় মনোযোগ দিতে
              পারেন।
            </p>
            <h2 class="h2">ন্যায্য খেলা ও সার্টিফায়েড গেম মেকানিক্স</h2>
            <br />
            <p>ক্রিকিয়া সর্বদা ন্যায্য খেলার মান বজায় রাখতে বিশ্বস্ত গেম প্রোভাইডারদের সঙ্গে কাজ করে এবং স্বচ্ছ অ্যালগরিদম নিশ্চিত করে।</p>
            <p>আমাদের গেমগুলো চালিত হয় নিয়ন্ত্রিত র‍্যান্ডম নাম্বার জেনারেটর (RNG) সিস্টেমের মাধ্যমে, যা নিয়মিতভাবে পরীক্ষা করা হয় যাতে ন্যায্য পেআউট নিশ্চিত করা যায়।</p>
            <p>প্রখ্যাত টেস্টিং এজেন্সি eCOGRA-এর গবেষণা অনুযায়ী, সার্টিফায়েড RNG সিস্টেম গেমের নিরপেক্ষতা ও বিশ্বাসযোগ্যতা নিশ্চিত করার ক্ষেত্রে অত্যন্ত গুরুত্বপূর্ণ।</p>
            <p>
              এর অর্থ হলো আমাদের গেমে প্রতিটি ফলাফল সম্পূর্ণভাবে ভাগ্যের ওপর নির্ভর করে—এতে কোনো প্রকার হস্তক্ষেপ বা পক্ষপাতিত্ব থাকে না। ফলে আপনি আত্মবিশ্বাসের সঙ্গে খেলতে পারেন, কারণ আপনার গেমিং
              অভিজ্ঞতা হবে সৎ, নিরাপদ এবং নির্ভরযোগ্য।
            </p>
          </div>
          <a style="color: #959595;" @click="toggleContent">{{ expanded ? 'Read Less' : 'Read More' }}</a>
        </v-col>
      </v-col>
    </v-row>
    <v-row v-else-if="$route.name == routeName.LOTTERY">
      <v-col cols="12" class="pa-0" v-if="!this.$route.params.lang && this.checkDomain()">
        <v-col>
          <h1 class="h2">Play Lottery Games Online with Krikya</h1>
          <br />
          <p>
            Get Experienced in Lotteries with
            <router-link class="router_href" :to="{ name: ROUTE_NAME.HOME, params: { lang: $route.params.lang } }">Krikya</router-link>
            , Every ticket is an opportunity for them to turn their sleepless nights into moments of delight. We link you with different lottery options available in the market that lets you choose
            your game of preference and begins your luck streak right away. Optimised for quick access, Krikya keeps your soul and curtains open at the same time while keeping a transparent safe
            interaction that is right to you if possible.
          </p>
          <div :class="{ 'hidden-content': !expanded, show: expanded }">
            <h2 class="h2">Types of Lottery Games Available</h2>
            <br />
            <h2 class="h2">Daily Draws with Fast Results</h2>
            <br />
            <p>
              Get all entries for daily draws at Krikya to win fast. Pick your entry and within the same day, watch the winning numbers being drawn. These draws keep luck at it's most fluid; every day
              is an unknown so to speak.
            </p>
            <h2 class="h2">Number Selection Games</h2>
            <br />
            <p>
              Try your luck in number selection games, pick your lucky numbers and submit Choose from among thousands of games, experience the fun of predicting if your numbers match the draw results
              and you have a perfect mix of strategy and luck in every entry.
            </p>
            <h2 class="h2">Instant Win Scratch Cards</h2>
            <br />
            <p>
              Krikya enjoys scratch cards for thrill immediately tough luck for you. If you want to scratch, pass your digital cards and check seconds later if you are the winner. Best option for
              people who enjoy gameplay quickly with instant rewards.
            </p>
            <h2 class="h2">International Lottery Access</h2>
            <br />
            <p>
              You are able to directly access the most widely loved international lotteries through Krikya linking you to some of the top global draws. If you want to win a name-brand jackpot, or have
              a number for non-US games in mind, no problem.
            </p>
            <h2 class="h2">Transparent and Verified Draws</h2>
            <br />
            <p>
              Within the Krikya, every lottery draw process is conducted transparently. Our platform works only with regulated, approved providers who comply with the highest regulatory standards,
              conducting fair gameplay by using powerful random number generator (RNG) technology powered Advanced such as MD5 RNG or SHA-256 RNG. These technologies make sure no one is influencing
              any of the draw results. The results of the draw are released in open, alongside all payout history so players can audit outcomes after every draw. In the end, independent audits
              guarantee that all processes stay secure and reliable, making it possible to trust it fully.
            </p>
            <h2 class="h2">Lottery Insights for Smarter Play</h2>
            <br />
            <p>
              Krikya provides some great tips to assist in the correct selection for all lottery games. Take a look at past winning numbers for the number trends to see which numbers are usually seen.
              The article has the guides from number patterns, which includes common choices and evenly spread combinations. Most research suggests that reading the past results can give players more
              confidence in their choices but lottery draws are random and an amount of any ticket will pay three times the winning number.
            </p>
            <h2 class="h2">How Digital Lotteries Are Changing Play</h2>
            <br />
            <p>
              How players now take part of the lottery has drastically changed to a quicker, easier digital experience. Play games from krikya you need not go to any physical location and play games
              and select numbers for entries directly from your device. The results come back almost instantly, and winnings are sent safely to your account. Improved security keeps your entries safe
              and a clean track record of all tickets displayed. As a result of which lotteries are played more online, but in an even way also very transparent.
            </p>
          </div>
          <a style="color: #959595;" @click="toggleContent">{{ expanded ? 'Read Less' : 'Read More' }}</a>
        </v-col>
      </v-col>
      <v-col cols="12" class="pa-0" v-if="this.$route.params.lang && this.checkDomain()">
        <v-col v-if="i18n.locale == 'en'">
          <h1 class="h2">Thrilling Online Lottery Games with Krikya</h1>
          <br />
          <p>
            Enter the world of online lottery games excitement with
            <router-link class="router_href" :to="{ name: ROUTE_NAME.HOME, params: { lang: $route.params.lang } }">Krikya</router-link>
            where every ticket is a chance to make excitement into unique winning moments. On our website you can easily choose your favourite game and start playing for real on the lotteries offered
            in our platform. Krikya for simple and fast access to an easy bet, means no one spies on your moves. Whether you are an experienced lottery player or a recreational lottery player for the
            first time, our platform is really easy and fun to use so that you will be able to participate in this winning game.
          </p>
          <div :class="{ 'hidden-content': !expanded, show: expanded }">
            <h2 class="h2">Variety of Lottery Game Options</h2>
            <br />
            <h2 class="h2">Instant Result from Daily Draws</h2>
            <br />
            <p>
              At Krikya, you can join daily lottery draws that offer you the chance to win quickly. Simply select your entry, and watch as the winning numbers are announced on the same day. They offer
              an exciting, quicker draw system where you can test your luck in a short time lapse, and every day has a chance to be your lucky day. If you are playing for fun or for the major, both
              the daily draws keep kicking excitement with regular and efficient outcomes.
            </p>
            <h2 class="h2">Number Selection Lottery</h2>
            <br />
            <p>
              Our Number Selection Games are for the players who want a customized approach, here you get to determine your lucky figures and submit the entries for that. It is a hybrid format of
              sorts with strategy, where you are predicting the drawn results, and chanced on where you will pick your numbers. Every entry is a chance to guess right and possibly win a really good
              reward. Number selection games at Krikya gives us the choice to select our own numbers and test our luck whether that will end up in winning.
            </p>
            <h2 class="h2">Instant Prize Scratch Cards</h2>
            <br />
            <p>
              Play live scratch cards of Krikya just check the experience. This convenient gaming alternative means you can open your winnings right away by scratching off digital cards to show behind
              the hidden symbols in real-time. So simple, but yet so exciting in the fact you can get rewards quick scratch cards for any gaming session duration; be quick or you will miss out. With
              every scratch, you get a chance to see if you have won, making it an ideal choice for players who enjoy fast outcomes and the possibility of instant prizes.
            </p>
            <h2 class="h2">International Lottery Games</h2>
            <br />
            <p>
              Krikya allows direct access to hundreds of international lotteries, where you can enter into the most popular, profitable draws from across the globe. Our site makes it easy whether you
              want to play the big life changing jackpots in world famous lotteries or visit original international games. You can easily enter these prestigious lotteries without any geographical
              limitations, giving you the chance to test your luck and aim for massive rewards no matter where you are.
            </p>
            <h2 class="h2">Guaranteed Fairness and Verified Lottery Draws</h2>
            <br />
            <p>
              We at Krikya believe in 100% transparency and fairness for every draw on our platform. Dedicated trusted providers that are audited to regulatory requirements to produce all our lottery
              for games, to be fair in results. One of the high-standard reliable (RNG) tools for this operation, consisting of advanced random number generator systems as MD5 RNG and SHA-256 are
              implemented to produce draw results. This is to make sure that every result is fully independent and not influenced from outside using these modern techniques of technology. In our
              platform, one can see the winning numbers and their prizes after each draw through payout records. Independent audits are a further way we ensure the robustness of our system so come and
              play, knowing that every item we offer is run with honesty and transparency.
            </p>
            <h2 class="h2">Enhance Your Lottery Strategy</h2>
            <br />
            <p>
              Krikya provides you with useful resources where you can rely to make the right decision in playing the lottery. You can see the numbers that repeat themselves most with time to appear
              like many different numbers playing in groups that have shown up. In our comprehensive guides, we give you a hands on guide on picking number patterns, splitting your plays and
              dissection of the favored picks by players. While past results may influence your decision to choose more confidently, it is important to remember research has shown the lottery is a
              game of chance and every ticket (with a valid draw) has an equal chance of winning. This insight can allow you to gamble strategically, but in the end what's going to make you win is
              luck.
            </p>
            <h2 class="h2">Revolutionizing the Digital Lotteries</h2>
            <br />
            <p>
              Digital lotteries update the model of player interaction with their gaming in a way never seen before, providing for quicker and more conducive access than ever. Krikya one there is no
              physical location for entering of tickets to play lottery games. You can choose the numbers and buy entries of those numbers right on your own device, so there is no need to go to any
              place when playing. Results are released instantaneously and all winning claims are automatically posted into the account. Strong encrypted security means that your entries are safe and
              a clear transaction history will give you an idea of each ticket you have purchased. This shift towards online platforms help the players to become more neutral in their favor and
              maintain the true nature of the game players expect from a lotteries.
            </p>
          </div>
          <a style="color: #959595;" @click="toggleContent">{{ expanded ? 'Read Less' : 'Read More' }}</a>
        </v-col>
        <v-col v-if="i18n.locale == 'bd'">
          <h1 class="h2">ক্রিকিয়াতে অনলাইনে লটারি গেম খেলুন</h1>
          <br />
          <p>
            ক্রিকিয়ার মাধ্যমে লটারি গেমের উত্তেজনা অনুভব করুন, যেখানে প্রতিটি টিকিট হতে পারে আপনার বিজয়ী মুহূর্তের চাবিকাঠি। আমাদের প্ল্যাটফর্মে রয়েছে বিভিন্ন ধরনের লটারি বিকল্প, যাতে আপনি আপনার
            পছন্দের গেম বেছে নিয়ে মুহূর্তেই ভাগ্য পরীক্ষা করতে পারেন।
          </p>
          <p>ক্রিকিয়া একটি নিরাপদ ও স্বচ্ছ অভিজ্ঞতা নিশ্চিত করে, যা সহজে অ্যাক্সেসযোগ্য এবং ব্যবহারকারী-বান্ধব। এতে অংশগ্রহণ করা সহজ এবং জেতার আনন্দ উপভোগ করা আরও সহজতর।</p>
          <div :class="{ 'hidden-content': !expanded, show: expanded }">
            <h2 class="h2">উপলভ্য লটারি গেমের ধরনসমূহ</h2>
            <br />
            <h2 class="h2">দৈনিক ড্র – দ্রুত ফলাফলের সুযোগ</h2>
            <br />
            <p>
              ক্রিকিয়ার প্রতিদিনের ড্র-এ অংশগ্রহণ করুন এবং দ্রুত জেতার সুযোগ গ্রহণ করুন। শুধু আপনার এন্ট্রি বেছে নিন এবং একই দিনের মধ্যেই বিজয়ী নম্বর ঘোষণার অপেক্ষায় থাকুন। এই ড্রগুলো অপেক্ষাকৃত কম
              সময়ে ফলাফল দেয়, ফলে প্রতিদিনই আপনার জন্য হতে পারে এক নতুন সম্ভাবনার দিন।
            </p>
            <h2 class="h2">নম্বর নির্বাচনের গেম</h2>
            <br />
            <p>নম্বর নির্বাচনের লটারি গেমে আপনার ভাগ্য পরীক্ষা করুন, যেখানে আপনি নিজের পছন্দের সংখ্যাগুলো নির্ধারণ করে অংশ নিতে পারেন।</p>
            <p>আপনার নির্বাচিত নম্বরগুলো ড্র করা নম্বরের সঙ্গে মিলে গেলে মেলে উত্তেজনাময় অভিজ্ঞতা—এতে রয়েছে কৌশল এবং ভাগ্যের এক আকর্ষণীয় সমন্বয়।</p>
            <h2 class="h2">ইনস্ট্যান্ট উইন স্ক্র্যাচ কার্ড</h2>
            <br />
            <p>ক্রিকিয়াতে স্ক্র্যাচ কার্ডের মাধ্যমে উপভোগ করুন তাত্ক্ষণিক উত্তেজনা।</p>
            <p>শুধু ডিজিটাল কার্ড স্ক্র্যাচ করুন, গোপন প্রতীক উন্মোচন করুন এবং সঙ্গে সঙ্গেই জেনে নিন আপনি জিতেছেন কি না।</p>
            <p>যারা দ্রুত গতির গেমিং ও তাৎক্ষণিক পুরস্কারের সম্ভাবনা পছন্দ করেন, তাদের জন্য এটি একটি আদর্শ বিকল্প।</p>
            <h2 class="h2">আন্তর্জাতিক লটারি গেমে সরাসরি প্রবেশাধিকার</h2>
            <br />
            <p>ক্রিকিয়ার মাধ্যমে জনপ্রিয় আন্তর্জাতিক লটারিতে সহজেই অংশগ্রহণ করুন।</p>
            <p>বিশ্ববিখ্যাত জ্যাকপট জয়ের স্বপ্ন হোক বা নতুন ধরনের আন্তর্জাতিক গেম এক্সপ্লোর করার</p>
            <p>আগ্রহ—সবকিছুই এখন এক প্ল্যাটফর্মে।</p>
            <p>ক্রিকিয়া আপনাকে যুক্ত করে বিশ্বের শীর্ষস্থানীয় লটারি ড্র-গুলোর সঙ্গে, খুব সহজ ও স্বচ্ছ প্রক্রিয়ায়।</p>
            <h2 class="h2">স্বচ্ছ ও যাচাইকৃত ড্র</h2>
            <br />
            <p>ক্রিকিয়াতে প্রতিটি লটারি ড্র সম্পূর্ণ স্বচ্ছতার সাথে পরিচালিত হয়।</p>
            <p>আমাদের প্ল্যাটফর্ম লাইসেন্সপ্রাপ্ত প্রোভাইডারদের সঙ্গে কাজ করে, যারা কঠোর নিয়ন্ত্রক মানদণ্ড অনুসরণ করে।</p>
            <p>উন্নত র‍্যান্ডম নাম্বার জেনারেটর (RNG) প্রযুক্তি—যেমন MD5 RNG এবং SHA-256 RNG—ব্যবহার করে প্রতিটি ফলাফল নিরপেক্ষভাবে নির্ধারিত হয়।</p>
            <p>প্রত্যেকটি ড্রয়ের পর ফলাফল এবং পেআউট রেকর্ড প্রকাশ করা হয়, যাতে খেলোয়াড়রা নিজেরাই তা যাচাই করতে পারেন।</p>
            <p>স্বাধীন নিরীক্ষার (audit) মাধ্যমে প্রতিটি ধাপ নিরাপদ এবং বিশ্বস্ত রাখা হয়, যেন আপনি সম্পূর্ণ আত্মবিশ্বাস নিয়ে অংশগ্রহণ করতে পারেন।</p>
            <h2 class="h2">লটারি ইনসাইটস: বুদ্ধিমত্তার সাথে খেলা</h2>
            <br />
            <p>ক্রিকিয়া আপনাকে লটারি গেমে সচেতন সিদ্ধান্ত নিতে সহায়ক গুরুত্বপূর্ণ ইনসাইটস প্রদান করে।</p>
            <p>পূর্বের বিজয়ী নম্বরসমূহ বিশ্লেষণ করে আপনি দেখতে পারবেন কোন সংমিশ্রণগুলো সময়ের সাথে সাথে বেশি বার এসেছে।</p>
            <p>আমাদের গাইডগুলোতে নম্বর নির্বাচন নিয়ে প্র্যাকটিক্যাল টিপস দেওয়া হয়—যেমন জনপ্রিয় প্যাটার্ন, ভারসাম্যপূর্ণ সংমিশ্রণ ইত্যাদি।</p>
            <p>গবেষণায় দেখা গেছে, আগের ফলাফল বিশ্লেষণ খেলোয়াড়দের আত্মবিশ্বাস বাড়াতে সাহায্য করতে পারে,</p>
            <p>তবে এটি মনে রাখা গুরুত্বপূর্ণ যে লটারি একটি র‍্যান্ডম গেম, এবং প্রতিটি টিকিটের জয়ের সম্ভাবনা একই থাকে।</p>
            <h2 class="h2">ডিজিটাল লটারি: খেলার ধরনে নতুন পরিবর্তন</h2>
            <br />
            <p>ডিজিটাল লটারি বদলে দিয়েছে লটারিতে অংশগ্রহণের পদ্ধতি—এখন এটি আরও দ্রুত ও সহজে সম্ভব।</p>
            <p>ক্রিকিয়ার মাধ্যমে আপনি শারীরিকভাবে কোথাও না গিয়েই খেলতে পারেন;</p>
            <p>নাম্বার নির্বাচন থেকে শুরু করে টিকিট কেনা—সবই করা যায় আপনার ডিভাইস থেকেই।</p>
            <p>ফলাফল সঙ্গে সঙ্গেই পাওয়া যায়, এবং জেতা অর্থ নিরাপদভাবে আপনার অ্যাকাউন্টে জমা হয়।</p>
            <p>উন্নত সিকিউরিটি প্রযুক্তি আপনার টিকিট সুরক্ষিত রাখে, এবং ট্রান্সাকশনের পুরো ইতিহাস আপনি স্পষ্টভাবে দেখতে পারেন।</p>
            <p>এই অনলাইন প্ল্যাটফর্ম লটারিকে আরও সহজলভ্য করে তুলেছে, স্বচ্ছতা এবং নিরপেক্ষতা বজায় রেখেই।</p>
          </div>
          <a style="color: #959595;" @click="toggleContent">{{ expanded ? 'Read Less' : 'Read More' }}</a>
        </v-col>
      </v-col>
    </v-row>
    <v-row v-else-if="$route.name == routeName.SLOT">
      <v-col cols="12" class="pa-0" v-if="!this.$route.params.lang && this.checkDomain()">
        <v-col>
          <h1 class="h2">Spin and Win with Online Slots at Krikya</h1>
          <br />
          <p>
            Online slots at
            <router-link class="router_href" :to="{ name: ROUTE_NAME.HOME, params: { lang: $route.params.lang } }">Krikya</router-link>
            are designed for ease, not noise. Each game is selected with attention to smooth gameplay, steady visuals, and reliable performance. Rather than overwhelming players with effects or
            unclear mechanics, the focus is on a clean experience where every spin follows tested systems. For Bangladesh users it is just to have a fun modern looking slot but simply driven by those
            providers who get the whole fairness and functionality thing from start to finish.
          </p>
          <div :class="{ 'hidden-content': !expanded, show: expanded }">
            <h2 class="h2">Explore a Wide Variety of Slot Games</h2>
            <br />
            <h2 class="h2">Classic Three-Reel Slots</h2>
            <br />
            <p>
              For example, at Krikya you can find the classic three reel slots that everyone loves due to simplicity and ageless charm. Popular symbols and simple mechanics in titles such as the 888
              Gold by Pragmatic Play, Super Ace by Jili, the Triple Tigers by Habanero or Spadegaming Lucky 7. These games give you a traditional slot feel, geared toward simplicity and usability for
              Bangladesh users.
            </p>
            <h2 class="h2">Video Slots with Bonus Features</h2>
            <br />
            <p>
              For interactive gameplay, Krikya has video slots with bonus features as well for the players. Video slots based on sweet bonanza from Pragmatic Play, Candy Burst from PG Soft, Golden
              Empire from Jili & Fa Cai Shen Deluxe from Habanero and even free spins, multipliers and special symbols to keep the game interesting. Along with being detailed these features are easy
              to understand and access.
            </p>
            <h2 class="h2">Jackpot Slots with Big Wins</h2>
            <br />
            <p>
              Slots in jackpot selections by Krikya are the slot titles having the highest potential of getting you a big win. Pragmatic Play – Wolf Gold, Jili Fortune Gems, Habanero Lucky Fortune Cat
              and Gold Panther by Spadegaming have progressive jackpots, easy to understand gameplay. Such games provide players to hit big wins and understand the mechanics in games for Bangladesh
              players.
            </p>
            <h2 class="h2">Branded and Themed Slot Titles</h2>
            <br />
            <p>
              Krikya for the Themed experiences inclined People as it is with branded and themed slots catering into bland or niche story driven slots in the mainstream culture. The full on titles
              such as The Dog House (Pragmatic Play), Mahjong Ways 2 (PG Soft),Golden Queen (Jili) and Egyptian Dreams Deluxe(Habanero) also offer up environments to get lost in with the gameplay
              being repetitive. No-frills thematic experience slots
            </p>
            <h2 class="h2">Fair Play with Certified Providers</h2>
            <br />
            <p>
              Krikya works with licensed studios that build fairness into every game from the ground up. Outcomes are generated through secured internal systems that are reviewed by external testing
              bodies to make sure they remain balanced and unpredictable. Studios such as Pragmatic Play, Jili, PG Soft, Habanero and Spadegaming have their audit processes set out in a way that
              ensures every title meets industry standards, without giving the player too much to think about. This gives the needed structure and consistency to Bangladesh users, a trust base.
            </p>
            <h2 class="h2">Slot Features That Enhance Your Game</h2>
            <br />
            <p>
              Krikya's slot games are about the way a session feels that have some quiet features that determine the entire experience for the player/session. Options are free spins, bonus round and
              multiplier; for many games there are variations built-in but no confusion. Some games even offer paylines options or volatility sliders so the player has more stakes on their plays. They
              are presented in simple ways so that the users of Bangladesh can just find the settings that work best for them, hedging their bets between low-stakes versions or higher risk.
            </p>
            <h2 class="h2">How Online Slots Have Evolved in the Digital Era</h2>
            <br />
            <p>
              Slot games have come a long way from their original mechanical roots, rhythm reinvented in digital make. By Krikya, Players in Bangladesh can now play games directly on mobiles with a
              much more fine play and simpler visuals than ever. Breaking into the digital realm has enabled developers to concentrate on pacing, sound and personal interaction but not so heavy that
              it is complex. It is not about additional effects but structure and control that scale better, to how people actually play today.
            </p>
          </div>
          <a style="color: #959595;" @click="toggleContent">{{ expanded ? 'Read Less' : 'Read More' }}</a>
        </v-col>
      </v-col>
      <v-col cols="12" class="pa-0" v-if="this.$route.params.lang && this.checkDomain()">
        <v-col v-if="i18n.locale == 'en'">
          <h1 class="h2">Spin to Win with Krikya’s Online Slots</h1>
          <br />
          <p>
            <router-link class="router_href" :to="{ name: ROUTE_NAME.HOME, params: { lang: $route.params.lang } }">Krikya</router-link>
            Online Slots provide a best-in-class online casino experience featuring efficient gameplay and visuals that are even, reliable and easy to use online slots. Simplicity is key, to keep the
            play spins as transparent and uncomplicated as possible without auxiliary effects or misleading mechanics. Players can enjoy a clean, modern slot experience, where each game is powered by
            tested systems, creating a reliable atmosphere for users in Bangladesh. At Krikya, we partner with top providers who ensure that fairness and functionality are present from the first spin
            to the last, giving players a rewarding and stress-free experience.
          </p>
          <div :class="{ 'hidden-content': !expanded, show: expanded }">
            <h2 class="h2">Diverse Collection of Slot Games</h2>
            <br />
            <h2 class="h2">Classic & Simple Slots</h2>
            <br />
            <p>
              Krikya has a handful of the old school three reel slots that are always nice to play for their simplicity and endurance. Name some titles that are games based on Gold 888 by Pragmatic
              Play, Super Ace from Jili, Triple Tigers by Habanero and Lucky 7 from Spadegaming with traditional symbols and straightforward features that provide a classic slot experience for the
              less experienced. For players who enjoy simple mechanics and classic slot feel these are the perfect game to engage at any time keeping user experience in Bangladesh simple and less
              complex for slot gaming.
            </p>
            <h2 class="h2">Video Slots with Rich Bonuses</h2>
            <br />
            <p>
              For the demanding, more interactive and video slots with bonus features on Krikya are available for those wanting a bit more gameplay richness. Currently popular games like Sweet Bonanza
              from Pragmatic Play, Candy Blast from PG Soft, Golden Empire by Jili and Fa Cai Shen Deluxe by Habanero, feature engaging elements like free spins, multipliers and unique symbols that
              are a big highlight of the gaming experience. They make the gameplay varied and interesting, considering that it is still friendly for all player levels and keep a high level of fun for
              those who want something special with your slots.
            </p>
            <h2 class="h2">Jackpot Slots for Massive Wins</h2>
            <br />
            <p>
              Krikya is a jackpot slot where you get a chance to pull the biggest life changing jackpots out of dozens of selects. Games with progressive jackpots, like Wolf Gold from Pragmatic Play,
              Fortune Gems by Jili, Lucky Fortune Cat by Habanero and Gold Panther from Spadegaming can all be found consisting of these casino games and feature big prize pools that build on every
              spin. For all the opportunities in big wins, the gameplay is so clear and all 'naturals' in Bangladesh will find it just a breeze to sprint to massive jackpots without getting lost in
              vague rules. Straightforward but exciting way to go for massive prizes in the form of jackpot slots.
            </p>
            <h2 class="h2">Immersive Branded and Themed Slot</h2>
            <br />
            <p>
              Krikya also comes with a selection of branded and themed slots that are based on narratives a lot of people know or can relate before they even play as well. The Dog House from
              Playagmatic Play, Mahjong Ways 2 from PG Soft, Golden Queen by Jili and in the land of the Pharaohs, Egyptian Dreams Deluxe aka ED2 from Habanero are all fantastic examples that deliver
              high quality visuals along with immersive experiences and theming to take players somewhere. The thematic slots provide an immersive experience in their respective world, and it manages
              to keep the gameplay simple so that it is easy to understand so one can play without any complexity or clutter that takes fun out of the game.
            </p>
            <h2 class="h2">Commitment to Fair Play with Trusted Game Providers</h2>
            <br />
            <p>
              Krikya collaborates with licensed game studios that ensure the fairness of the games in their root construction. All game outcomes are developed on internal secure systems and undergo
              regular audits from independent third party testers to ensure they are fair, balanced and unpredictable. Major providers including Pragmatic Play, Jili Studios, PG Soft, Habanero Studios
              and Spadegaming are all audited closely to guarantee their games adhere to stringent industry standards while not overcomplicating the user experience. It ensures that players in
              Bangladesh trust and believe in transparency & consistency hence every game on the platform becomes trustworthy for players of Bangladesh.
            </p>
            <h2 class="h2">Game-Enhancing Features in Krikya’s Slot Games</h2>
            <br />
            <p>
              Krikya’s slot games contain intelligent player-friendly features that enhance the gaming experience without making the slot gaminator intimidating for the end user. Almost the entire set
              of them features free spins, bonus rounds and multipliers, which add a lot of flavour and fun would give the base games they return. Others allow players to change paylines or volatility
              levels in a number of games, giving variety and catering for different preferences. These are laid out in layman's terms, making it simple for users in Bangladesh to reach and switch
              between themes that match your play style (calm -> slower -> Risky/higher).
            </p>
            <h2 class="h2">The Evolution of Online Slots in the Digital Age</h2>
            <br />
            <p>
              Traditional slot games were mechanical in nature, slot machines have gone way beyond this to become a quick, smooth and slick digital experience with slot games. Krikya now lets the
              players of bangladesh to play these games easily on mobile devices making for an uninterrupted and fun gaming environment. The digital age has given developers the ability to polish bits
              of timing, sound and interactivity for a customized gaming playground. Instead of the grand palace of bling that classic video slots were, modern digital withdrawal focuses on abundance;
              control and a better brand with today's gaming habits in mind which shows an innovation to accessible experience.
            </p>
          </div>
          <a style="color: #959595;" @click="toggleContent">{{ expanded ? 'Read Less' : 'Read More' }}</a>
        </v-col>
        <v-col v-if="i18n.locale == 'bd'">
          <h1 class="h2">Krikya-তে অনলাইন স্লট ঘুরিয়ে জেতার আনন্দ নিন</h1>
          <br />
          <p>
            Krikya-তে অনলাইন স্লট গেমগুলো সহজ ও আরামদায়ক খেলার অভিজ্ঞতার জন্যই ডিজাইন করা হয়েছে। প্রতিটি গেম এমনভাবে বাছাই করা হয়েছে যাতে গেমপ্লে মসৃণ থাকে, ভিজ্যুয়াল স্থির থাকে এবং পারফরম্যান্স
            নির্ভরযোগ্য হয়। অপ্রয়োজনীয় গ্রাফিক্স বা জটিল নিয়মের বদলে এখানে প্রতিটি স্পিন চলে যাচাই করা সিস্টেম অনুযায়ী। বাংলাদেশের ব্যবহারকারীদের জন্য এটি একটি আধুনিক কিন্তু সহজ স্লট খেলার সুযোগ,
            যেখানে গেম প্রদানকারীরা প্রথম রাউন্ড থেকে শেষ পর্যন্ত ন্যায্যতা ও নির্ভরযোগ্যতা নিশ্চিত করে।
          </p>
          <div :class="{ 'hidden-content': !expanded, show: expanded }">
            <h2 class="h2">বিভিন্ন ধরণের স্লট গেম আবিষ্কার করুন</h2>
            <br />
            <h2 class="h2">ক্লাসিক থ্রি-রিল স্লটস</h2>
            <br />
            <p>
              Krikya-তে ক্লাসিক থ্রি-রিল স্লট গেমগুলো তাদের সরল গেমপ্লে ও চিরন্তন আকর্ষণের কারণে নির্বাচিত। Pragmatic Play-এর 888 Gold, Jili-এর Super Ace, Habanero-এর Triple Tigers, এবং Spadegaming-এর
              Lucky 7 গেমগুলো পরিচিত প্রতীক ও সহজ নিয়ম দিয়ে খেলার অভিজ্ঞতা দেয়। এই গেমগুলো বাংলাদেশের খেলোয়াড়দের জন্য এক সহজ এবং ঐতিহ্যবাহী স্লট অভিজ্ঞতা প্রদান করে।
            </p>
            <h2 class="h2">বোনাস ফিচার সহ ভিডিও স্লটস</h2>
            <br />
            <p>
              যারা আরও ইন্টারঅ্যাকটিভ গেমপ্লে খুঁজছেন, Krikya তাদের জন্য বোনাস ফিচারসহ ভিডিও স্লট অফার করে। যেমন Pragmatic Play-এর Sweet Bonanza, PG Soft-এর Candy Burst, Jili-এর Golden Empire এবং
              Habanero-এর Fa Cai Shen Deluxe গেমগুলোতে রয়েছে ফ্রি স্পিন, মাল্টিপ্লায়ার ও বিশেষ প্রতীক। এসব ফিচার গেমের গভীরতা বাড়ায়, কিন্তু তা সহজবোধ্যতা ও প্রবেশযোগ্যতার ভারসাম্য বজায় রেখেই।
            </p>
            <h2 class="h2">বড় জয়ের সুযোগ সহ জ্যাকপট স্লটস</h2>
            <br />
            <p>
              Krikya-তে থাকা জ্যাকপট স্লটগুলোর মধ্যে এমন কিছু টাইটেল রয়েছে যেগুলো বড় অঙ্কের পুরস্কার দেওয়ার সম্ভাবনার জন্য পরিচিত। Pragmatic Play-এর Wolf Gold, Jili-এর Fortune Gems, Habanero-এর Lucky
              Fortune Cat এবং Spadegaming-এর Gold Panther গেমগুলোতে রয়েছে প্রগ্রেসিভ জ্যাকপট ও সহজ গেমপ্লে। এই গেমগুলো উল্লেখযোগ্য পুরস্কার জয়ের সুযোগ দেয়, সেইসাথে বাংলাদেশের খেলোয়াড়দের জন্য
              নিয়ম-কানুন সহজবোধ্য রাখে।
            </p>
            <h2 class="h2">ব্র্যান্ডেড ও থিমযুক্ত স্লট টাইটেলসমূহ</h2>
            <br />
            <p>
              যারা থিম ভিত্তিক অভিজ্ঞতা পছন্দ করেন, Krikya তাদের জন্য জনপ্রিয় সংস্কৃতি ও অনন্য কাহিনি ভিত্তিক ব্র্যান্ডেড ও থিমযুক্ত স্লট গেম অফার করে। Pragmatic Play-এর The Dog House, PG Soft-এর
              Mahjong Ways 2, Jili-এর Golden Queen এবং Habanero-এর Egyptian Dreams Deluxe গেমগুলো আকর্ষণীয় সেটিংস এবং নিরবচ্ছিন্ন গেমপ্লে দিয়ে তৈরি। এই স্লটগুলো একটি থিম্যাটিক ভ্রমণের অভিজ্ঞতা দেয়,
              কিন্তু ব্যবহারকারীর অভিজ্ঞতা জটিল না করেই।
            </p>
            <h2 class="h2">ন্যায্য খেলা: সার্টিফাইড প্রদানকারীদের সাথে</h2>
            <br />
            <p>Krikya লাইসেন্সপ্রাপ্ত স্টুডিওর সঙ্গে কাজ করে, যারা প্রতিটি গেমের নির্মাণ প্রক্রিয়ার মধ্যে ন্যায্যতা নিশ্চিত করে।</p>
            <p>ফলাফলগুলি সুরক্ষিত অভ্যন্তরীণ সিস্টেমের মাধ্যমে তৈরি হয়, যা বাইরের টেস্টিং বডি দ্বারা পর্যালোচনা করা হয়, যাতে নিশ্চিত করা যায় যে সেগুলি ভারসাম্যপূর্ণ এবং অপ্রত্যাশিত থাকে।</p>
            <p>
              Pragmatic Play, Jili, PG Soft, Habanero এবং Spadegaming-এর মতো স্টুডিওগুলি স্পষ্ট অডিট পথ অনুসরণ করে, যার ফলে প্রতিটি টাইটেল ইন্ডাস্ট্রি স্ট্যান্ডার্ড মেনে চলে, খেলোয়াড়ের অভিজ্ঞতা জটিল
              না করে।
            </p>
            <p>বাংলাদেশের ব্যবহারকারীদের জন্য এটি একটি নির্ভরযোগ্য ভিত্তি তৈরি করে, যা কাঠামো এবং স্থিরতার উপর নির্ভর করে।</p>
            <h2 class="h2">স্লটের বৈশিষ্ট্য যা আপনার খেলা উন্নত করে</h2>
            <br />
            <p>Krikya-র স্লট গেমগুলো এমন বৈশিষ্ট্যগুলোর সাথে আসে যা প্রতিটি সেশনকে একটি নির্দিষ্ট অনুভূতি দেয়, কিন্তু অভিজ্ঞতাকে জটিল করে না।</p>
            <p>ফ্রি স্পিন, বোনাস রাউন্ড এবং মাল্টিপ্লায়ারের মতো অপশন অনেক গেমে অন্তর্ভুক্ত রয়েছে, যা ভিন্নতা প্রদান করে কিন্তু বিভ্রান্তি সৃষ্টি করে না।</p>
            <p>কিছু গেম খেলোয়াড়দের পে-লাইন পরিবর্তন বা ভোলাটিলিটি স্তর নির্বাচন করার সুযোগ দেয়, যা তাদের খেলার পদ্ধতির উপর আরও নিয়ন্ত্রণ প্রদান করে।</p>
            <p>এই সেটিংসগুলো স্পষ্টভাবে উপস্থাপিত, যাতে বাংলাদেশের ব্যবহারকারীরা সহজেই আবিষ্কার করতে পারেন কী তাদের জন্য সবচেয়ে উপযোগী, তারা কি স্থির গতি পছন্দ করেন, না কি উচ্চ ঝুঁকি।</p>
            <h2 class="h2">ডিজিটাল যুগে অনলাইন স্লটের বিকাশ</h2>
            <br />
            <p>স্লট গেমগুলি তাদের যান্ত্রিক শিকড় থেকে অনেক দূরে চলে এসেছে এবং ডিজিটাল ডিজাইনের মাধ্যমে একটি নতুন ছন্দ পেয়েছে।</p>
            <p>Krikya-তে, বাংলাদেশের খেলোয়াড়রা এখন সরাসরি মোবাইল থেকে গেমগুলো খেলতে পারেন, যেখানে আগের চেয়ে মসৃণ গেমপ্লে এবং পরিষ্কার ভিজ্যুয়াল রয়েছে।</p>
            <p>ডিজিটালে রূপান্তর ডেভেলপারদের জন্য আরও পেসিং, সাউন্ড, এবং ইন্টারঅ্যাকশনের দিকে মনোযোগ দেওয়ার সুযোগ তৈরি করেছে, যা ব্যক্তিগত অনুভূতি প্রদান করে তবে জটিল নয়।</p>
            <p>এই পরিবর্তনটি আরও এফেক্টস নিয়ে নয়, বরং এটি এমন একটি কাঠামো এবং নিয়ন্ত্রণের দিকে, যা আজকের দিনে মানুষ যেভাবে খেলে, তা তার সাথে মানানসই।</p>
          </div>
          <a style="color: #959595;" @click="toggleContent">{{ expanded ? 'Read Less' : 'Read More' }}</a>
        </v-col>
      </v-col>
    </v-row>
    <v-row v-else-if="$route.name == routeName.SPORTSBOOK">
      <v-col cols="12" class="pa-0" v-if="!this.$route.params.lang && this.checkDomain()">
        <v-col>
          <h1 class="h2">Bet on Sports with Confidence at Krikya</h1>
          <br />
          <p>
            Krikya sports betting builds a linear reliable experience from beginning to the end of the way. No matter what kind of sport, cricket, or football or any other sport you are betting on,
            the platform guarantees transparency and honesty covering all the odds,markets.
            <router-link class="router_href" :to="{ name: ROUTE_NAME.HOME, params: { lang: $route.params.lang } }">Krikya</router-link>
            keeps sports betting in Bangladesh simple and hassle-free for users, so players can enjoy their favorite sports without a wrinkly excess. You bet on every match with confidence when the
            right tools and resources are in place.
          </p>
          <div :class="{ 'hidden-content': !expanded, show: expanded }">
            <h2 class="h2">Top 4 Popular Sports to Bet On</h2>
            <br />
            <h2 class="h2">Cricket</h2>
            <br />
            <p>
              Cricket at Krikya is pretty creative in the way it takes betting, and makes it less score-centric and more about the rhythm of the game. And it gives you these, from Test matches on the
              sport through to T20 and One Day Internationals everything in Bangladesh format. For example the structures of odds n fold on crucial parts like power plays, overs and wickets teaches
              players some depth to the game. It's about cricket as the sport demands a level of patience and care that few of us partake in these days.
            </p>
            <h2 class="h2">Football</h2>
            <br />
            <p>
              Krikya football betting revolves around the dynamic rhythm of the game, not just the final score that you landed. Instead of win/loss results, the platform gives you an option for all
              international leagues till the school level matches available, that means team-run, player-injury, tactical formations all are being highlighted as well just win/loss. This enables the
              users of Bangladesh to bet more wisely and hence offer just not the Game but the depth which football provides.
            </p>
            <h2 class="h2">Kabaddi</h2>
            <br />
            <p>
              Krikya has taken Kabaddi betting to such a platform that understands well this dynamic nature of fast paced games. While not in its raw statistics the emphasis will be on moves of
              players, set-up in teams specifics and key events from each T20 match. It is not merely a sprint to the final score, it gives the kabaddi players in Bangladesh an opportunity to
              understand how, when to play and individual performance that decides the win.
            </p>
            <h2 class="h2">Tennis</h2>
            <br />
            <p>
              Tennis betting at Krikya beats out the rhythm of the game, a granular view on how each game is played. Aside from what the final ends up being, the site also monitors items such as set
              lengths, surface and player momentum for Bangladesh in-play users get better over time. The set up is meant to be a motivator for paying close attention to the specifics of the game,
              which ultimately provides a better experience than just who will win.
            </p>
            <h2 class="h2">Dynamic Odds with Real-Time Updates</h2>
            <br />
            <p>
              At Krikya these live dynamic odds update second wise to make sure players in bangladesh are up to date as things are happening in the market. Users can monitor the stats and progress of
              the match live throughout the game to make in-match betting adjustments. Fast settlement is an aspect that the platform handles, so you can be sure the results are live to deliver an
              error-free experience because every decision made here relies on timing & strategy.
            </p>
            <h2 class="h2">Tools to Support Smarter Bets</h2>
            <br />
            <p>
              Bangladesh users of Krikya are armed with the tools that make decisions looking towards results easier. Match previews, form guides and thorough analytics to give each event its due of
              light so that the team relations and player performance is clear on paper. Beside user-friendly bet slip and tracker, the platform has also included its own bettingslipper that allows
              punters to quickly track their bets. Which in turn trickles down to make betting easier, and thus wagers made with said confidence with a grain of salt.
            </p>
            <h2 class="h2">What Drives Loyalty in Online Sports Betting?</h2>
            <br />
            <p>
              Online sports betting loyalty? It is a construct of trust and respect for online user behavioural characteristics. Krikya is all about providing a sturdy platform where users feel safe
              to make their decisions. Ensured by open transparentness and fairness that gives an experience. Krikya is enabling long term engagement by listening to what the players want, and finally
              providing consistent superb service. The thing that helps retain, all in a right mix of appreciation for loyalty, keep trust, and offer an environment where players can have sports
              betting with fewer barriers.
            </p>
          </div>
          <a style="color: #959595;" @click="toggleContent">{{ expanded ? 'Read Less' : 'Read More' }}</a>
        </v-col>
      </v-col>
      <v-col cols="12" class="pa-0" v-if="this.$route.params.lang && this.checkDomain()">
        <v-col v-if="i18n.locale == 'en'">
          <h1 class="h2">Experience Reliable Sports Betting at Krikya</h1>
          <br />

          <p>
            From start to finish, the sports betting experience at
            <router-link class="router_href" :to="{ name: ROUTE_NAME.HOME, params: { lang: $route.params.lang } }">Krikya</router-link>
            was designed with clarity, trustworthiness and simplicity. On whatever sport the bet is (cricket or football and other sports too) the platform keeps it simple. All odds calculation and
            markets are based on a foundation of honesty and the clearest thinking. Krikya for Bangladesh players, will provide you with sports betting systematically in a simple and clean manner that
            lets you consume the sport you love, without all combatants. Right tools and resources behind the scenes have every bet backed with certainty.
          </p>
          <div :class="{ 'hidden-content': !expanded, show: expanded }">
            <h2 class="h2">Explore the 4 Most Popular Sports to Bet On</h2>
            <br />

            <h2 class="h2">Cricket Wagering</h2>
            <br />

            <p>
              While Krikya follows cricket betting by telling the flow of the game to give involvement rather than just predicting for a final result. The product lets players in Bangladesh understand
              the sport, betting on tests, even if its Internationals or T20 games. The odds are calculated on the key moments like power play, over and wicket to analyse a game level. It fits well
              with the sort of thing that takes patience and obsession needed to follow cricket and, for the devotee who wants their life saturated by the sport at all times this makes for greasier
              meat.
            </p>

            <h2 class="h2">Football Betting</h2>
            <br />

            <p>
              Krikya football betting is the framework of the complete game and not only the ending score for the final. Available in leagues that range from world cups to local games, the platform
              offers more than win/loss data. It goes deep into team momentum, player conditions and tactical alignments, adding more shading to the game without being simplistic. This helps the
              Bangladeshean users to take wiser and gamely bets, it also gives you that cat's eye view of football where you can think in strategic terms and place your bets with an insight into the
              bigger picture.
            </p>

            <h2 class="h2">Kabaddi Betting</h2>
            <br />

            <p>
              Krikya Kabaddi betting sport tactical view with extreme dynamic presentation of the game KQ. Rather than just statistics, the platform pulls the focus towards some other major issues
              i.e. player movements, team's formation on the field and major match moments. It enables Bangladeshi players to learn the game well, by giving emphasis on timing, strategy and individual
              player performance rather than being superficial. Not just the final score, it has an aim to bring forth users to play Kabaddi Game with a strategy and understand how tied play and
              decision make the play.
            </p>

            <h2 class="h2">Tennis Betting</h2>
            <br />

            <p>
              At Krikya, tennis betting is not just about who the match is going to be. The platform gives its users a comprehensive analysis of every single match sent down the corridor, from score
              line through set & surface to structure and momentum that has been running in both players' heads since first serve. This is important to players in Bangladesh, as it will allow them to
              even bet on such a match and not simply concentrate on the end result. This is satisfying the pointy-end tennis fans by rewarding those that watch the game, and adds an element of
              freshness and excitement considering what you receive beyond the final score.
            </p>

            <h2 class="h2">Real-Time Odds and Updates for Smarter Betting</h2>
            <br />

            <p>
              During Krikya, real-time updated odds alternate as per the happenings and available to Bangladeshi players to pay attention to evolving markets. Live statistics happen with each and
              every match, users can monitor the direction of the game and tweak their bets live. To keep the players in loop and to respond swiftly to the evolving game dynamics. In addition, the
              platform ensures swift settlement of results so players have instant confirmation that adds a puzzle where time, strategy and awareness matters most when betting.
            </p>

            <h2 class="h2">Enhanced Tools for Better Betting Decisions</h2>
            <br />

            <p>
              In Bangladesh, Krikya has a handful of tools that will guide players into making smarter and more educated bets. Match previews, form guides and full stats give players some added
              context into the dynamics within a team and the game of the players, thus making their decisions a lot more calculated. Simple bet slip and bet tracking via the platform help users make
              bets with ease, it is a one stop place to lay all their bets in. Through this they will be able to bet more data-driven and think not just strategically but their strategy is backed with
              data as well which will simply make the overall betting experience better.
            </p>

            <h2 class="h2">Building Loyalty Through Trust in Online Sports Betting</h2>
            <br />

            <p>
              Online sports betting loyalty is based on trust as well as knowing user behaviour you can orient your services accordingly. What Krikya truly excels at is building a secure and open
              platform for players to make confident choices. The platform takes care that users want to have a steady and guaranteed experience by keeping a radar of the needs/preferences of users.
              Keeping the players: by rewarding repeat business, providing high service levels and nothing but fair/eu or addicting wagering. Transparency and player satisfaction are key values
              ingrained in Krikya helping to build long term relationships where users can enjoy sports betting without hindrances.
            </p>
          </div>
          <a style="color: #959595;" @click="toggleContent">{{ expanded ? 'Read Less' : 'Read More' }}</a>
        </v-col>
        <v-col v-if="i18n.locale == 'bd'">
          <h1 class="h2">ক্রিকিয়াতে আত্মবিশ্বাসের সঙ্গে স্পোর্টসে বাজি ধরুন</h1>
          <br />
          <p>
            ক্রিকিয়া তে স্পোর্টস বেটিং এমনভাবে তৈরি করা হয়েছে যাতে শুরু থেকে শেষ পর্যন্ত খেলোয়াড়রা একটি পরিষ্কার ও নির্ভরযোগ্য অভিজ্ঞতা পেতে পারেন। আপনি ক্রিকেট, ফুটবল বা অন্য যেকোনো খেলায় বাজি
            ধরুন না কেন, এই প্ল্যাটফর্মটি নিশ্চিত করে যে সব ধরনের অডস ও মার্কেট স্বচ্ছতা ও বিশ্বাসযোগ্যতার উপর ভিত্তি করে তৈরি হয়েছে। বাংলাদেশের ব্যবহারকারীদের জন্য, ক্রিকিয়া একটি গঠনমূলক এবং
            সহজবোধ্য পদ্ধতিতে স্পোর্টস বেটিং উপস্থাপন করে, যাতে প্রিয় খেলাগুলোর সাথে যুক্ত হতে কোনো অতিরিক্ত জটিলতার মুখোমুখি হতে না হয়। সঠিক টুলস এবং রিসোর্স থাকার ফলে, প্রতিটি বাজিতে আত্মবিশ্বাস
            অর্জন স্বাভাবিকভাবেই সম্ভব হয়।
          </p>
          <div :class="{ 'hidden-content': !expanded, show: expanded }">
            <h2 class="h2">সবচেয়ে জনপ্রিয় ৪টি খেলায় বাজি ধরার অভিজ্ঞতা নিন</h2>
            <br />
            <h2 class="h2">ক্রিকেট</h2>
            <br />
            <p>
              ক্রিকিয়াতে ক্রিকেট বেটিং একটি চিন্তাশীল পদ্ধতিতে উপস্থাপিত হয়, যা শুধুমাত্র চূড়ান্ত ফলাফলের উপর নয়, বরং পুরো খেলার গতির উপর গুরুত্ব দেয়। টেস্ট ম্যাচ, ওয়ান ডে আন্তর্জাতিক বা টি২০
              যেকোনো ফরম্যাটেই হোক, এই প্ল্যাটফর্ম বাংলাদেশের ব্যবহারকারীদেরকে খেলার প্রতিটি দিক গভীরভাবে অনুসরণ করার সুযোগ দেয়। এখানে অডসের গঠন এমনভাবে তৈরি, যা পাওয়ার প্লে, ওভার এবং উইকেটের মতো
              গুরুত্বপূর্ণ মুহূর্তগুলোকে প্রতিফলিত করে, ফলে খেলোয়াড়রা ম্যাচ সম্পর্কে আরও গভীর ধারণা পেতে পারেন। এটি এমন একটি অভিজ্ঞতা যা ক্রিকেটের ধৈর্য এবং সূক্ষ্মতা বোঝার সাথে মিল রেখে তৈরি
              হয়েছে।
            </p>
            <h2 class="h2">ফুটবল</h2>
            <br />
            <p>
              ক্রিকিয়াতে ফুটবল বেটিং এমনভাবে তৈরি, যা মাঠে খেলার বাস্তব রূপকেই তুলে ধরে, শুধুমাত্র শেষ স্কোর নয়। আন্তর্জাতিক লিগ থেকে শুরু করে স্থানীয় ম্যাচ পর্যন্ত বিস্তৃত অপশন এর মাধ্যমে এই
              প্ল্যাটফর্মটি শুধুমাত্র জয় বা পরাজয় নয়, বরং দলের গতি, খেলোয়াড়দের অবস্থা এবং কৌশলগত ম্যাচআপগুলোকেও গুরুত্ব দেয়। এর ফলে বাংলাদেশের ব্যবহারকারীরা আরও তথ্যভিত্তিক এবং চিন্তাপূর্ণ বাজি
              ধরতে পারেন, যা ফুটবলের কৌশলগত গভীরতাকে প্রতিফলিত করে – শুধুমাত্র শেষ বাঁশির উপর নির্ভর করে নয়।
            </p>
            <h2 class="h2">কবাডি</h2>
            <br />
            <p>
              ক্রিকিয়া এমন একটি প্ল্যাটফর্মে কবাডি বেটিং নিয়ে এসেছে, যা এই দ্রুতগতির খেলার কৌশলগত প্রকৃতিকে সম্মান করে। শুধুমাত্র পরিসংখ্যানের উপর নির্ভর না করে, এখানে মূল গুরুত্ব দেওয়া হয়েছে
              খেলোয়াড়দের চলাফেরা, দলের গঠন এবং প্রতিটি ম্যাচের গুরুত্বপূর্ণ মুহূর্তগুলোর উপর। এর ফলে এটি শুধুমাত্র একটি চূড়ান্ত স্কোরে পৌঁছানোর প্রতিযোগিতা নয়, বরং বাংলাদেশের খেলোয়াড়দের জন্য
              কবাডিকে আরও গভীরভাবে বোঝার একটি সুযোগ তৈরি করে – যেখানে সময় নির্ধারণ, কৌশল এবং ব্যক্তিগত পারফরম্যান্সগুলোই বিজয় নির্ধারণ করে।
            </p>
            <h2 class="h2">টেনিস</h2>
            <br />
            <p>
              ক্রিকিয়াতে টেনিস বেটিং খেলার ছন্দকে ধারণ করে, প্রতিটি ম্যাচের অগ্রগতির একটি বিস্তারিত চিত্র তুলে ধরে। চূড়ান্ত ফলাফলের বাইরেও, এই প্ল্যাটফর্মটি সেটের গঠন, কোর্টের ধরন এবং খেলোয়াড়দের
              গতি ও মনোভাবের মতো বিষয়গুলো অনুসরণ করে, যার মাধ্যমে বাংলাদেশের ব্যবহারকারীরা ম্যাচ চলাকালীন সময়েই তথ্যসমৃদ্ধ বাজি ধরতে পারেন। এই অভিজ্ঞতা এমনভাবে তৈরি, যা খেলাটির সূক্ষ্মতা ও বিশ্লেষণী
              দিকগুলোতে মনোযোগ দেওয়ার মাধ্যমে আরও বেশি আকর্ষণীয় করে তোলে – শুধুমাত্র বিজয়ীকে অনুমান করার বাইরে গিয়ে।
            </p>
            <h2 class="h2">রিয়েল-টাইম আপডেটসহ ডাইনামিক অডস</h2>
            <br />
            <p>
              ক্রিকিয়াতে ডাইনামিক অডস নিয়মিতভাবে আপডেট হয়, যা রিয়েল-টাইম মার্কেট পরিবর্তনগুলোর প্রতিফলন ঘটায়, যাতে বাংলাদেশের খেলোয়াড়রা চলমান ঘটনার সঙ্গে তাল মিলিয়ে এগিয়ে থাকতে পারেন। ম্যাচ
              চলাকালীন লাইভ পরিসংখ্যানের মাধ্যমে ব্যবহারকারীরা খেলার অগ্রগতি সহজেই অনুসরণ করতে পারেন এবং সেই অনুযায়ী নিজেদের বাজি সামঞ্জস্য করতে পারেন। প্ল্যাটফর্মটি দ্রুত সেটেলমেন্টও নিশ্চিত করে,
              যাতে ফলাফল দ্রুত নিশ্চিত হয় এবং একটি ঝামেলামুক্ত অভিজ্ঞতা পাওয়া যায় – যেখানে প্রতিটি সিদ্ধান্তে সময় এবং কৌশলের গুরুত্বপূর্ণ ভূমিকা থাকে।
            </p>
            <h2 class="h2">বুদ্ধিদীপ্ত বাজির জন্য সহায়ক টুলস</h2>
            <br />
            <p>
              ক্রিকিয়া বাংলাদেশের ব্যবহারকারীদের জন্য এমন টুলস সরবরাহ করে, যা তথ্যভিত্তিক সিদ্ধান্ত গ্রহণকে সহজ করে তোলে। ম্যাচ প্রিভিউ, ফর্ম গাইড এবং বিস্তারিত বিশ্লেষণ খেলোয়াড়দের প্রতিটি ইভেন্ট
              সম্পর্কে আরও পরিষ্কার ধারণা দেয়, দলগত গতিশীলতা ও খেলোয়াড়দের পারফরম্যান্স সম্পর্কে অন্তর্দৃষ্টি প্রদান করে। এই প্ল্যাটফর্মে ব্যবহারবান্ধব বেট স্লিপ এবং ট্র্যাকিং সিস্টেমও অন্তর্ভুক্ত
              রয়েছে, যার ফলে খেলোয়াড়রা সহজেই বাজি দিতে, তা ম্যানেজ করতে এবং পুনর্বিবেচনা করতে পারেন। এই সব ফিচার একসাথে কাজ করে বেটিংকে আরও স্মার্ট এবং আত্মবিশ্বাসী করে তোলে, যাতে প্রতিটি বাজিতে
              থাকে চিন্তাশীল এবং পরিকল্পিত মনোভাব।
            </p>
            <h2 class="h2">অনলাইন স্পোর্টস বেটিং-এ বিশ্বস্ততা গড়ে ওঠে কীভাবে?</h2>
            <br />
            <p>
              অনলাইন স্পোর্টস বেটিং-এ বিশ্বস্ততা গড়ে ওঠে বিশ্বাস এবং ব্যবহারকারীর আচরণ বোঝার ভিত্তিতে। ক্রিকিয়াতে মূল লক্ষ্য হলো এমন একটি নির্ভরযোগ্য পরিবেশ তৈরি করা, যেখানে ব্যবহারকারীরা
              আত্মবিশ্বাসের সঙ্গে সিদ্ধান্ত নিতে পারেন, কারণ তারা জানেন যে তাদের অভিজ্ঞতা স্বচ্ছতা এবং ন্যায্যতার ভিত্তিতে গঠিত। খেলোয়াড়দের পছন্দের প্রতি মনোযোগ দিয়ে এবং ধারাবাহিকভাবে উচ্চমানের
              সেবা প্রদান করে, ক্রিকিয়া দীর্ঘমেয়াদি সম্পৃক্ততা বজায় রাখে। বিশ্বস্ততা ধরে রাখার জন্য এটি পুরস্কারভিত্তিক অনুগত্য, আস্থা রক্ষা এবং এমন একটি প্ল্যাটফর্ম প্রদান করে, যেখানে খেলোয়াড়রা
              অপ্রয়োজনীয় জটিলতা ছাড়াই স্পোর্টস বেটিং উপভোগ করতে পারেন – এই তিনটির ভারসাম্য রক্ষা করে।
            </p>
          </div>
          <a style="color: #959595;" @click="toggleContent">{{ expanded ? 'Read Less' : 'Read More' }}</a>
        </v-col>
      </v-col>
    </v-row>
    <v-row v-else-if="$route.name == routeName.TABLE_GAMES">
      <v-col cols="12" class="pa-0" v-if="!this.$route.params.lang && this.checkDomain()">
        <v-col>
          <h1 class="h2">Enjoy Classic Table Games at Krikya</h1>
          <br />
          <p>
            <router-link class="router_href" :to="{ name: ROUTE_NAME.HOME, params: { lang: $route.params.lang } }">Krikya</router-link>
            premieres of Traditional Table Games in Bangladesh, Players( special emphasis on charm and authenticity for the users) The game is organized according to the set rules and formats
            predefined by every user, strategy is what really counts.From the green felt of virtual blackjack tables to the calm rhythm of roulette spins, each game is designed to reflect the classic
            experience. Stable and clean interface, so players would not waste time on the interface and they can play focused on the game itself. This is for those who seek simple and long-time
            casino entertainments other than live dealers or streaming this part is just enjoy fashion.
          </p>
          <div :class="{ 'hidden-content': !expanded, show: expanded }">
            <h2 class="h2">A Wide Selection of Digital Table Games</h2>
            <br />
            <h2 class="h2">Blackjack</h2>
            <br />
            <p>
              Blackjack at Krikya is available in digital table game format, providing a very safe space for players who want no live dealer interference. The setup follows the original format, where
              the aim is to reach a stronger total than the dealer without going over. It is ideal for those who enjoy making thoughtful choices without time pressure. Instead of recreating the
              atmosphere of a live casino, this version provides a quiet, solo experience. Though many outlets do blackjack, Krikya conserves on all these and stay clean and structured through its
              gameplay which is still in traditional style many enjoy.
            </p>
            <h2 class="h2">Roulette</h2>
            <br />
            <p>
              At Krikya,roulette is as a "classic table game" and not under live c asmueus of course. No live hosts, all streaming etc. Only a clean, virtual table with spinning wheel This format
              allows players to take their time making wagers and watching with no superfluous distractions. Clear and familiar with little variation to the traditional roulette for those in your
              target audience. Though roulette is a common topic in online gaming, Krikya chooses to keep it grounded in its most enduring form.
            </p>
            <h2 class="h2">Baccarat</h2>
            <br />
            <p>
              Krikya baccarat is electronic table game based on traditional rules with no live dealer in operation. This plays-to-play format provides the full control of playing speed to players as
              they enter every round slowly and cautiously. A well designed layout, and clear structure makes this game friendly for both veterans of the game, as well as those that are trying to
              learn. While baccarat often appears with added layers in live casinos, Krikya presents it in a quiet, solo format that stays close to the original design.
            </p>
            <h2 class="h2">Casino Poker</h2>
            <br />
            <p>
              Table Games: Casino poker played at Krikya is fully digital with no live dealer sessions to interact with. This one is intended for enthusiasts of a solid environment in which every hand
              can be played carefully. Everything is in the rules following usual casino poker formats and not about how visually immersive it is. It’s a space where strategy matters more than
              performance. Though casino poker is widely featured online, Krikya offers a version that remains close to its roots, designed for quiet concentration rather than social features.
            </p>
            <h2 class="h2">Player-Controlled Experience Without Live Pressure</h2>
            <br />
            <p>
              Table games at Krikya offer a calm, player-controlled environment without the presence of live dealers or time pressure. This format allows users to play at their own pace, giving them
              the space to focus on their choices and understand each game more deeply. It is especially useful for those who wish to practice strategies or build confidence without distractions.
              Krikya stripping away live interaction, creates a space where players can process freely, ponder and ideally play the game on their terms.
            </p>
            <h2 class="h2">Smart Features for Table Game Enthusiasts</h2>
            <br />
            <p>
              Table games at Krikya have some useful tools to keep the focus and the flow in the play. Betting options can be changed according to personal preference, most players can see what
              happened in all past rounds with game history and may check the side bets if indeed exist. Auto-play and quick bet is for the faster sessions, auto-playing and betting which can be done
              with minimum manual input. These features are not added for show but to give regular players useful choices that match their habits. The goal is to provide a steady and practical setup
              that respects how each person chooses to play.
            </p>
            <h2 class="h2">The Role of Table Games in Online Casino Culture</h2>
            <br />
            <p>
              Table games have remained a steady part of online casino platforms because they continue to reflect the core ideas of strategy, structure, and focus. Their simplicity has influenced the
              construction of so many digital games that are played today, affecting the general layout playthrough and player interaction in other house games. The classics also color how people
              think about risk, reinforcing processes of patience and slow observation instead of instantaneous or random. Table games continue to capture attention in a sea of new toys and shallow
              trends in the digital world by having a proven rhythm that for too many is comfortable and rewarding.
            </p>
          </div>
          <a style="color: #959595;" @click="toggleContent">{{ expanded ? 'Read Less' : 'Read More' }}</a>
        </v-col>
      </v-col>
      <v-col cols="12" class="pa-0" v-if="this.$route.params.lang && this.checkDomain()">
        <v-col v-if="i18n.locale == 'en'">
          <h1 class="h2">Experience Classic Table Games with Krikya</h1>
          <br />

          <p>
            <router-link class="router_href" :to="{ name: ROUTE_NAME.HOME, params: { lang: $route.params.lang } }">Krikya</router-link>
            for table games in Bangladesh, the ageless appeal of traditional table games that bring that authentic, high quality gaming experience. These are games that follow a tried and true set of
            governing rules and formats, something for our skillful audience to enjoy in a comfortable environment. Even in the games of virtual blackjack played on green felt tables carpet and then
            to the smooth spinning Roulette wheels, the casino classic is always the aim. With a clean and stable platform interface as such the players will be able to really sink into the game
            without any distraction. For traditional casino buffs that want no distractions (like a Dealer) Krikya is a great place to be.
          </p>
          <div :class="{ 'hidden-content': !expanded, show: expanded }">
            <h2 class="h2">A Broad Range of Digital Table Games</h2>
            <br />

            <h2 class="h2">Blackjack</h2>
            <br />

            <p>
              Blackjack at Krikya is a digital table game that has concentration and contentment ambiance which gives a player the opportunity to sit back and play a classic version of a game with a
              conducive environment without live dealer.
              <br />
              Game still sticks to its original elements; players seek higher hand values compared to dealers but not above a total of 21 as the classic. Best for people that like to take their sweet
              time and make slow calculated decisions without a live setting. This offering is much more direct to the point experience at Krikya, a perfect example of what the game should be as an
              engagement for players who love that timeless glamour that is based in blackjack.
            </p>

            <h2 class="h2">Roulette</h2>
            <br />

            <p>
              Krikya's roulette is shown as a basic table game with players who can easily engage in a short and simple experience where live dealer or stream are not included. More of a virtual
              no-frills table with a wheel that spins, this will have players placing their bets in their own time and watching as the layout spins away peacefully. It is for those who love the
              classic way of playing roulette, nothing in their presence, happy distraction-free environment. Krikya’s way will make the classic tempos of playing roulette less flashy and extra
              infections, making it possible for players to enjoy timeless elements in roulette.
            </p>

            <h2 class="h2">Baccarat</h2>
            <br />

            <p>
              At Krikya, baccarat is a digital table game and follows the classic rules of the original game but with no live dealer baccarat elements. In that format, it gives a player full power
              over the time of the game even though they play each round very slowly at their own pace in a laid-back manner. Intuitive game design with simple but solid navigation. The game is very
              friendly for experienced and new players. Unlike the live casino version being often noisy and distracting, Krikya baccarat is still keeping the original touch of peace and strategy for
              the player to focus on the strategy while playing the flow.
            </p>

            <h2 class="h2">Casino Poker</h2>
            <br />

            <p>
              Krikya casino poker tables are a beautiful and engaging way to play poker without any live dealer intervention. You can play in this format because it allows players to manage their
              thoughts on every hand, making smart decisions within a safe, no-distraction environment. The game play is meant to emphasise strategy over visual effects with the nuts requiring core
              poker principles. Krikya is the way to play pure poker in Bangladesh, where the game is simple and suits the concentration well to those who want to see how timeless poker is.
            </p>

            <h2 class="h2">A Calm and Controlled Gaming Environment at Krikya</h2>
            <br />

            <p>
              Krikya's table games are a serene, player-led play where there is no pressure of having real dealers and time limits. This setup makes us feel at ease and encourages deliberative play,
              meaning players can take as much time as they need to decide not to be forced by the clock. If you are refinishing a technique or just testing the waters, the incremental deck changing
              at leisure establishes confidence and knowledge. For the individuals who are quiet gamers wanting simpler and more contemplative table games without all external distractions Krikya is
              the place to enjoy classic tables. For players who want to play their games with precision and each choice matters, it creates a wonderful spot to just be lost again in what feels like
              one player sessions.
            </p>

            <h2 class="h2">Tools Designed for Strategic Table Game Play</h2>
            <br />

            <p>
              In the table games of Krikya, many helpful tools are provided to make sure that you will have optimal experience. Users may bet their way, examine horse historical data used in past
              hands, and enjoy the side bets if provided. If you want to play faster, auto-play and quick bet options will facilitate the process, reducing a little intervention from your side in
              playing. These practical instruments are suitable for consistent players, with the added flexibility to satisfy any idiosyncrasy of the board. Krikya simply wants all players to have a
              natural experience playing the game at ease and ensure a flow of play respecting the different personal preferences.
            </p>

            <h2 class="h2">How Table Games Shape Online Casino Culture</h2>
            <br />

            <p>
              Table games remain at the heart of online casinos, everything strategy skill and focus flows from the games. Games inspired by these earlier online gaming constructs heavily influence
              the structure, pace and player interactions in many of the casino games around today. Simple interface of table games enforce slow style addicting behavior in players, play as a habit,
              based on moments of patience and observation. Table games, despite all the new technologies and trends, are at the very heart of an online casino experience as they provide players with
              rock solid but fun ways to engage their favorite classics, like table games should be. Even in the fast moving evolution of digital gaming, they are a constant as they provide many
              players with a beat and framework that is comfortable to follow.
            </p>
          </div>
          <a style="color: #959595;" @click="toggleContent">{{ expanded ? 'Read Less' : 'Read More' }}</a>
        </v-col>
        <v-col v-if="i18n.locale == 'bd'">
          <h1 class="h2">ক্রিকিয়াতে উপভোগ করুন ক্লাসিক টেবিল গেমস</h1>
          <br />
          <p>
            ক্রিকিয়া বাংলাদেশের খেলোয়াড়দের জন্য ঐতিহ্যবাহী টেবিল গেমস-এর আকর্ষণ নিয়ে এসেছে, যেখানে মান ও স্বতঃস্ফূর্ততা বজায় রাখা হয়েছে প্রধান লক্ষ্য হিসেবে। এই গেমগুলো সুপরিচিত নিয়ম ও ফরম্যাট
            অনুযায়ী পরিচালিত হয়, যার ফলে ব্যবহারকারীরা একটি পরিচিত পরিবেশে খেলার সুযোগ পান, যেখানে কৌশল ও দক্ষতা গুরুত্বপূর্ণ ভূমিকা রাখে। ভার্চুয়াল ব্ল্যাকজ্যাক টেবিলের সবুজ কাপড় থেকে শুরু করে
            রুলেট স্পিনের শান্ত ছন্দ পর্যন্ত, প্রতিটি গেমই এমনভাবে ডিজাইন করা হয়েছে, যা ক্লাসিক অভিজ্ঞতাকে প্রতিফলিত করে। ইন্টারফেসটি পরিষ্কার এবং স্থিতিশীল, যাতে খেলোয়াড়রা কোনো প্রকার বিঘ্ন ছাড়াই
            সম্পূর্ণ মনোযোগ গেমে কেন্দ্রীভূত করতে পারেন। যারা লাইভ ডিলার বা স্ট্রিমিং ছাড়া টাইমলেস ক্যাসিনো বিনোদন পছন্দ করেন, তাদের জন্য এই বিভাগটি একটি মনোযোগী ও উপভোগ্য বিকল্প উপস্থাপন করে।
          </p>
          <div :class="{ 'hidden-content': !expanded, show: expanded }">
            <h2 class="h2">ডিজিটাল টেবিল গেমসে বিস্তৃত নির্বাচন</h2>
            <br />
            <h2 class="h2">ব্ল্যাকজ্যাক</h2>
            <br />
            <p>
              ক্রিকিয়াতে ব্ল্যাকজ্যাক একটি ডিজিটাল টেবিল গেম হিসেবে উপলব্ধ, যা খেলোয়াড়দের জন্য একটি মনোযোগী পরিবেশ তৈরি করে – যেখানে কোনো লাইভ ডিলারের অংশগ্রহণ নেই। সেটআপটি মূল ফরম্যাট অনুসরণ করে,
              যেখানে লক্ষ্য থাকে ডিলারের চেয়ে বেশি পয়েন্ট অর্জন করা, তবে ২১ পয়েন্টের বেশি না হওয়া পর্যন্ত। এটি তাদের জন্য আদর্শ, যারা সময়ের চাপে না পড়ে চিন্তাভাবনা করে সিদ্ধান্ত নিতে পছন্দ করেন।
              একটি লাইভ ক্যাসিনোর পরিবেশ পুনর্নির্মাণের পরিবর্তে, এই সংস্করণটি একটি শান্ত, একক অভিজ্ঞতা প্রদান করে। যদিও বিভিন্ন প্ল্যাটফর্মে ব্ল্যাকজ্যাক ব্যাপকভাবে তুলে ধরা হয়, ক্রিকিয়া এটিকে সহজ
              ও গঠনমূলকভাবে রাখে, এবং ঐতিহ্যবাহী গেমপ্লে’র প্রতি বিশ্বস্ত থাকে – যা এখনো অনেক খেলোয়াড় পছন্দ করেন।
            </p>
            <h2 class="h2">রুলেট</h2>
            <br />
            <p>
              ক্রিকিয়াতে রুলেট একটি ক্লাসিক টেবিল গেম হিসেবে অফার করা হয়, যা লাইভ ক্যাসিনো বিভাগের অন্তর্ভুক্ত নয়। এখানে কোনো লাইভ হোস্ট বা স্ট্রিমিং ফিচার নেই, বরং একটি পরিষ্কার ভার্চুয়াল লেআউট
              এবং একটি ঘূর্ণায়মান চাকার মাধ্যমে খেলার সুযোগ দেওয়া হয়। এই ফরম্যাটটি খেলোয়াড়দের নিজস্ব গতিতে বাজি ধরার এবং ফলাফল দেখার স্বাধীনতা দেয়, কোনো অতিরিক্ত বিঘ্ন ছাড়াই। উপস্থাপনাটি
              স্বচ্ছতা এবং পরিচিত গেমপ্লে’র উপর কেন্দ্রীভূত, যা তাদের জন্য উপযুক্ত যারা অতিরিক্ত প্রভাব ছাড়াই ঐতিহ্যবাহী রুলেট উপভোগ করতে চান। যদিও রুলেট অনলাইন গেমিং জগতের একটি সাধারণ বিষয়,
              ক্রিকিয়া এটিকে তার সবচেয়ে টেকসই রূপেই উপস্থাপন করার সিদ্ধান্ত নিয়েছে।
            </p>
            <h2 class="h2">বাকারা</h2>
            <br />
            <p>
              ক্রিকিয়াতে বাকারা একটি ডিজিটাল টেবিল গেম হিসেবে উপস্থাপিত হয়েছে, যা স্ট্যান্ডার্ড নিয়ম অনুসরণ করে এবং এতে কোনো লাইভ ডিলার ফিচার যুক্ত নয়। এই ফরম্যাটটি খেলোয়াড়দেরকে সম্পূর্ণ
              নিয়ন্ত্রণ দেয় গেমের গতি ঠিক করার ক্ষেত্রে, যাতে প্রতিটি রাউন্ডে ধীর ও পরিমিতভাবে অংশগ্রহণ করা যায়। লেআউটটি পরিষ্কার এবং স্ট্রাকচারটি অনুসরণ করা সহজ, যার ফলে যাঁরা আগে থেকেই গেমটি
              জানেন, তাদের পাশাপাশি নতুন খেলোয়াড়রাও এটি সহজে উপভোগ করতে পারেন। যদিও লাইভ ক্যাসিনোতে বাকারা প্রায়শই অতিরিক্ত ফিচারসহ উপস্থাপিত হয়, ক্রিকিয়া এটিকে একটি শান্ত, একক প্লেয়ার অভিজ্ঞতা
              হিসেবে উপস্থাপন করে – যা মূল নকশার কাছাকাছি থাকে।
            </p>
            <h2 class="h2">ক্যাসিনো পোকার</h2>
            <br />
            <p>
              ক্রিকিয়াতে ক্যাসিনো পোকার টেবিল গেমস বিভাগের অন্তর্ভুক্ত, যার অর্থ হলো সব ধরনের ইন্টারঅ্যাকশন সম্পূর্ণভাবে ডিজিটাল এবং কোনো লাইভ ডিলার সেশন নেই। এই সংস্করণটি তাদের জন্য তৈরি, যারা একটি
              স্থিতিশীল পরিবেশে প্রতিটি হাত চিন্তাভাবনা করে খেলতে পছন্দ করেন। নিয়মাবলী স্ট্যান্ডার্ড ক্যাসিনো পোকার ফরম্যাট অনুযায়ী পরিচালিত হয় এবং গেমপ্লে স্পষ্ট রাখার উপর গুরুত্ব দেওয়া হয়েছে,
              ভিজ্যুয়াল ইফেক্টের উপর নয়। এটি এমন একটি জায়গা, যেখানে কৌশল পারফরম্যান্সের চেয়ে বেশি গুরুত্ব পায়। যদিও ক্যাসিনো পোকার অনলাইনে ব্যাপকভাবে প্রদর্শিত হয়, ক্রিকিয়া এমন একটি সংস্করণ
              অফার করে যা তার মূল রূপের কাছাকাছি থাকে – যা সামাজিক ফিচারের পরিবর্তে শান্ত ও মনোযোগী অভিজ্ঞতার জন্য ডিজাইন করা হয়েছে।
            </p>

            <h2 class="h2">লাইভ চাপ ছাড়াই প্লেয়ার-কন্ট্রোলড অভিজ্ঞতা</h2>
            <br />
            <p>
              ক্রিকিয়াতে টেবিল গেমস একটি শান্ত এবং খেলোয়াড়-নিয়ন্ত্রিত পরিবেশ প্রদান করে, যেখানে কোনো লাইভ ডিলার বা সময়ের চাপ নেই। এই ফরম্যাট ব্যবহারকারীদের নিজেদের গতিতে খেলার সুযোগ দেয়, যাতে
              তারা সিদ্ধান্ত গ্রহণের উপর মনোযোগ দিতে পারেন এবং প্রতিটি গেম আরও গভীরভাবে বুঝতে পারেন। এটি বিশেষভাবে উপকারী তাদের জন্য, যারা কৌশল অনুশীলন করতে চান বা বিভ্রান্তি ছাড়া আত্মবিশ্বাস গড়ে
              তুলতে চান। লাইভ ইন্টারঅ্যাকশন বাদ দিয়ে, ক্রিকিয়া এমন একটি সেটিং তৈরি করেছে, যেখানে খেলোয়াড়রা পরিষ্কারভাবে চিন্তা করতে পারেন, সময় নিয়ে সিদ্ধান্ত নিতে পারেন এবং নিজেদের নিয়ম
              অনুযায়ী গেমে সম্পৃক্ত হতে পারেন।
            </p>
            <h2 class="h2">টেবিল গেম প্রেমীদের জন্য স্মার্ট ফিচারসমূহ</h2>
            <br />
            <p>
              ক্রিকিয়ার টেবিল গেমস-এ এমন কিছু সহায়ক টুল অন্তর্ভুক্ত রয়েছে, যা মনোযোগী এবং কার্যকরী খেলার অভিজ্ঞতা প্রদান করে। খেলোয়াড়রা নিজেদের পছন্দ অনুযায়ী বাজির পরিমাণ সামঞ্জস্য করতে পারেন,
              গেম হিস্টোরি ফিচারের মাধ্যমে আগের রাউন্ডগুলো পর্যালোচনা করতে পারেন, এবং যেখানে উপলব্ধ, সাইড বেট অপশনও অন্বেষণ করতে পারেন। যারা দ্রুত সেশন পছন্দ করেন, তাদের জন্য অটো-প্লে এবং কুইক বেট
              অপশনও অন্তর্ভুক্ত আছে, যাতে কম ম্যানুয়াল ইনপুটে কার্যক্রম সম্পন্ন করা যায়। এই ফিচারগুলো শুধুমাত্র প্রদর্শনের জন্য নয়, বরং নিয়মিত খেলোয়াড়দের অভ্যাসের সঙ্গে সামঞ্জস্য রেখে কার্যকরী
              পছন্দের বিকল্প দেওয়ার উদ্দেশ্যে তৈরি। লক্ষ্য হলো একটি স্থির ও বাস্তবমুখী সেটআপ প্রদান করা, যা প্রত্যেক ব্যক্তির খেলার ধরনকে সম্মান করে।
            </p>
            <h2 class="h2">অনলাইন ক্যাসিনো কালচারে টেবিল গেমের ভূমিকা</h2>
            <br />
            <p>
              টেবিল গেমস অনলাইন ক্যাসিনো প্ল্যাটফর্মে একটি স্থায়ী অংশ হিসেবে রয়ে গেছে, কারণ এগুলো এখনো কৌশল, গঠন এবং মনোযোগের মূল ধারণাগুলোকে প্রতিফলিত করে। তাদের সরল ডিজাইন আজকের অনেক ডিজিটাল গেমের
              কাঠামো গঠনে প্রভাব ফেলেছে – বিশেষ করে লেআউট, প্রবাহ এবং খেলোয়াড়দের পারস্পরিক ক্রিয়ার ক্ষেত্রে। এই ক্লাসিক গেমগুলো খেলোয়াড়দের সিদ্ধান্ত গ্রহণে মনোযোগী করে তোলে, যা দ্রুততা বা
              কাকতালীয়তার পরিবর্তে ধৈর্য ও পর্যবেক্ষণ-ভিত্তিক অভ্যাসকে উৎসাহিত করে। এমনকি এক ডিজিটাল জগতে, যেখানে নতুন ফিচার ও দ্রুত পরিবর্তনশীল ট্রেন্ড বিদ্যমান, সেখানে টেবিল গেমস এখনো মনোযোগ ধরে
              রাখে – পরিচিত এক ছন্দের মাধ্যমে, যা অনেকেই নির্ভরযোগ্য এবং উপভোগ্য বলে মনে করেন।
            </p>
          </div>
          <a style="color: #959595;" @click="toggleContent">{{ expanded ? 'Read Less' : 'Read More' }}</a>
        </v-col>
      </v-col>
    </v-row>
    <v-row v-else-if="$route.name == routeName.VIP">
      <v-col v-if="i18n.locale == 'en'">
        <h1 class="h2">Claim Your KRIKYA Rewards Online On Time</h1>
        <br />
        <p>As of right now, KRIKYA Rewards will be the only resource you ever need for gaming information. Why?</p>
        <p>
          We at
          <router-link class="router_href" :to="{ name: ROUTE_NAME.HOME, params: { lang: $route.params.lang } }">Krikya</router-link>
          are committed to providing you, the online gambler, with the best in online gaming. We will only direct you to the safest, most reliable, and secure set of online casinos rooms available
          worldwide.
        </p>
        <p>Rewards Casino has what you're searching for, whether you're an experienced online gambler or a novice looking for your first casino room to play at.</p>
        <h2>Experience Only The Best With Krikya</h2>
        <p>At Krikya, we take great pride in offering you a selection of online casinos that have won our trust and loyalty.</p>
        <p>
          We sincerely hope that your stay with us will be educational and useful to you as you look for an online casino room that you can rely on and enjoy playing at with the assurance that you are
          doing it at one of the top online gambling destinations and KRIKYA VIP challenge available.
        </p>
        <p>Please confirm that your gear complies with the specifications listed beneath the download section. Enjoy!</p>
        <p>Online Casino {{ currentYear }} | Live Casino Online Bangladesh | Bangladesh Cricket Betting | Online Slots Bangladesh</p>
      </v-col>
      <v-col v-else-if="i18n.locale == 'bd'">
        <h1 class="h2">সময়মতো অনলাইনে আপনার KRIKYA পুরস্কার দাবি করুন</h1>
        <br />
        <p>এই মুহুর্তে, KRIKYA পুরস্কারই হবে একমাত্র সম্পদ যা আপনার গেমিং তথ্যের জন্য প্রয়োজন। কেন?</p>
        <p>
          আমরা krikya88-এ আপনাকে, অনলাইন জুয়াড়ি, অনলাইন গেমিংয়ে সেরা প্রদান করতে প্রতিশ্রুতিবদ্ধ। আমরা আপনাকে শুধুমাত্র বিশ্বব্যাপী উপলব্ধ অনলাইন ক্যাসিনো কক্ষগুলির সবচেয়ে নিরাপদ, সবচেয়ে
          নির্ভরযোগ্য এবং সুরক্ষিত সেটের দিকে পরিচালিত করব।
        </p>
        <p>রিওয়ার্ডস ক্যাসিনোতে আপনি যা খুঁজছেন তা রয়েছে, আপনি একজন অভিজ্ঞ অনলাইন জুয়াড়ি হোন বা আপনার প্রথম ক্যাসিনো রুম যেখানে খেলার জন্য খুঁজছেন একজন নবজাতক।</p>
        <h2>Krikya-এর সাথে শুধুমাত্র সেরা অভিজ্ঞতা নিন</h2>
        <p>Krikya-এ, আমরা আপনাকে অনলাইন ক্যাসিনোগুলির একটি বাছাই করার জন্য অফার করছি যা আমাদের বিশ্বাস এবং বিশ্বস্ততা জিতেছে।</p>
        <p>
          আমরা আন্তরিকভাবে আশা করি যে আমাদের সাথে আপনার থাকা আপনার জন্য শিক্ষামূলক এবং উপযোগী হবে কারণ আপনি একটি অনলাইন ক্যাসিনো রুম খুঁজছেন যার উপর আপনি নির্ভর করতে পারেন এবং খেলা উপভোগ করতে পারেন এই
          নিশ্চয়তার সাথে যে আপনি এটি সেরা অনলাইন জুয়ার গন্তব্যগুলির একটিতে করছেন এবং KRIKYA VIP চ্যালেঞ্জ উপলব্ধ৷
        </p>
        <p>অনুগ্রহ করে নিশ্চিত করুন যে আপনার গিয়ার ডাউনলোড বিভাগের নীচে তালিকাভুক্ত বৈশিষ্ট্যগুলি মেনে চলছে৷ উপভোগ করুন!</p>
        <p>অনলাইন ক্যাসিনো {{ currentYear }} | লাইভ ক্যাসিনো অনলাইন বাংলাদেশ | বাংলাদেশ ক্রিকেট বাজি | অনলাইন স্লট বাংলাদেশ</p>
      </v-col>
    </v-row>
    <v-row v-else-if="$route.name == routeName.PROMOTION">
      <v-col v-if="i18n.locale == 'en'">
        <h1 class="h2">
          Promotions | Welcome Bonus | App Download Free Bonus | Free Sign Up Bonus | Instant Register Bonus
        </h1>
        <br />

        <p>
          Unlock exciting rewards with
          <router-link class="router_href" :to="{ name: ROUTE_NAME.HOME, params: { lang: $route.params.lang } }">Krikya</router-link>
          ! New users can enjoy an exclusive
          <strong>welcome bonus</strong>
          just by signing up. Get extra value with our
          <strong>app download bonus</strong>
          —completely free when you install the Krikya app. We also offer a
          <strong>free sign up bonus</strong>
          for instant access to your favorite games without any deposit required.
        </p>

        <p>
          Ready to get started? Our
          <strong>instant register bonus</strong>
          gives you a head start in your online gaming journey. Whether you're into sports betting, slots, or live casino games, Krikya’s promotions give you more ways to win every day.
        </p>

        <p>Don’t miss out—register now and claim your Krikya bonuses instantly!</p>
      </v-col>
      <v-col v-else-if="i18n.locale == 'bd'">
        <h1 class="h2">
          ক্রিকেট বেটিং প্রচার | ক্রিকেট বেটিং স্বাগতম বোনাস | ক্রিকেট বেটিং অ্যাপ বিনামূল্যে বোনাস {{ currentYear }} | বিনামূল্যে 100 সাইন আপ বোনাস নো ডিপোজিট ক্রিকেট | ইনস্ট্যান্ট রেজিস্টার ক্রিকেট
          বোনাস নো ডিপোজিট
        </h1>
        <br />
        <h2>{{ currentYear }} সালেইনস্ট্যান্টরেজিস্টারক্রিকেটবোনাসনোডিপোজিটপান</h2>
        <p>খেলোয়াড়দের ইনস্ট্যান্ট রেজিস্টার ক্রিকেট বোনাস কোন ডিপোজিট সহবেটিংসাইটগুলিরজন্যআরওঅনুসন্ধানকরারদরকারনেই৷আজ, অনলাইনবুকিদেরমধ্যেপদেরজন্যপ্রচণ্ডপ্রতিযোগিতাচলছে.</p>
        <p>
          ফলস্বরূপ, অনেকবেটিংসাইটনতুনগ্রাহকদেরকিছুধরণেরপ্রণোদনাপ্রদানকরবে।ভারতীয়জুয়াড়িরাএখনবিভিন্নধরনের ক্রিকেট ক্রিকেট বেটিং প্রচার, ক্রিকেট বেটিং স্বাগতম বোনাস,
          এবংবিনামূল্যেরবাজিপ্রচার।কোনোডিপোজিটবোনাসছাড়াইবাজিধরারসাইটগুলিএমনএকটিযাজুয়াড়িরাপরিচিতনাও হতেপারে৷.
        </p>
        <h3>krikya-play.com-এউপলব্ধসেরাপ্রচারগুলিউপভোগকরুন৷</h3>
        <p>এইধরনেরএকটিঅফার, যাপ্রায়শইঅনলাইনক্যাসিনোগুলিরসাথেসম্পর্কিত, গ্রাহকদেরকাছথেকেকোনওবাজিরদাবিকরেনা৷এটিএটিসনাক্তকরাযথেষ্টচ্যালেঞ্জিংকরেতোলে।এটিউপলব্ধহ লে, যদিও, এটিব্যবহারকরাভাল.</p>
        <p>এমনকিএকটিক্রিকেট বেটিং অ্যাপ বিনামূল্যে বোনাস দিয়েও, জয়েরনিশ্চয়তানেই, তবেঅনেকবাজির, এইধরনেরচুক্তিপ্রবাদেরঅনুরূপগ্রিল."</p>
        <p>আপনিকিবিনামূল্যে 100 সাইনআপবোনাসনোডিপোজিটক্রিকেটনিতেচান?আজআমাদেরসাথেযোগাযোগকরুন.</p>
        <p>অনলাইনক্যাসিনো {{ currentYear }} | লাইভ ক্যাসিনো অনলাইন বাংলাদেশ | বাংলাদেশক্রিকেটবাজি | অনলাইন স্লট বাংলাদেশ</p>
      </v-col>
    </v-row>
  </v-row>
</template>

<script>
import { ROUTE_NAME } from '@/constants/route.constants'
import i18n from '@/plugins/i18n'

export default {
  name: 'footerContent',
  computed: {
    ROUTE_NAME() {
      return ROUTE_NAME
    }
  },
  data: () => ({
    expanded: false,
    panel: 0,
    routeName: ROUTE_NAME,
    hasContent: false,
    i18n,
    currentYear: new Date().getFullYear()
  }),
  created() {
    this.init()
  },
  methods: {
    checkDomain() {
      const currentDomain = window.location.hostname
      // Check if domain is krikya11.net or localhost
      console.log(/krikya11\.net$|krikya-play\.net$|localhost/.test(currentDomain))
      return /krikya11\.net$|krikya-play\.net$|localhost/.test(currentDomain)
    },
    toggleContent() {
      this.expanded = !this.expanded
    },
    init() {
      this.hasContent = [
        this.routeName.HOME,
        this.routeName.CASINO,
        this.routeName.VIP,
        this.routeName.CRICKET,
        this.routeName.LOTTERY,
        this.routeName.PROMOTION,
        this.routeName.SLOT,
        this.routeName.SPORTSBOOK,
        this.routeName.TABLE_GAMES
      ].includes(this.$route.name)
    }
  }
}
</script>

<style lang="scss">
.hidden-content {
  display: none;
}

.show {
  display: block;
}
.footer-expansion-panel {
  background-color: inherit !important;
}
.h2 {
  display: block;
  font-size: 1.5em;
  font-weight: bold;
  line-height: 1.3;
  text-align: justify;
}
</style>
